import { jsx as M, jsxs as wo } from "@emotion/react/jsx-runtime";
import * as go from "react";
import $o, { useRef as Mo, useState as Co, useMemo as Vt, useEffect as Eo, forwardRef as Po, useId as _n, useCallback as yt, useImperativeHandle as he, useLayoutEffect as Me } from "react";
import { prefixer as Oe } from "stylis";
import Pe from "@emotion/cache";
import { CacheProvider as Le, ThemeProvider as _e, Global as Ve, css as k, useTheme as Io } from "@emotion/react";
import eo from "@emotion/styled";
import Jn from "@emotion/is-prop-valid";
const jt = ({ focusVisibleStyle: o, focusStyle: t, prependToSelector: n = "", appendToSelector: r }) => {
  const e = r ? ` ${r}` : "";
  return o ? `
            @supports not selector(:focus-visible) {
                ${n}:focus${e} {
                    ${t ?? o}
                }
            }

            ${n}:focus-visible${e} {
                ${o}
            }
        ` : "";
}, _o = ({ focusVisibleStyle: o, focusStyle: t, prependToSelector: n = "", appendToSelector: r }) => o ? jt({
  focusVisibleStyle: o,
  focusStyle: t,
  appendToSelector: r
}) : t ? `${n}:focus${r ? ` ${r}` : ""} { ${t} }` : "", mt = (o, t = "", n = "") => o ? `${t}:focus-within${n ? ` ${n}` : ""} { ${o} }` : "", Yo = (o, t = "", n = "") => o ? `${t}:active${n ? ` ${n}` : ""} { ${o} }` : "", Fo = (o, t = "", n = "") => o ? `${t}:hover${n ? ` ${n}` : ""} { ${o} }` : "", Xo = (o, t = "", n = "") => o ? `${t}:disabled${n ? ` ${n}` : ""} { ${o} }` : "", Ln = (o, t = "", n = "") => o ? `${t}:checked${n ? ` ${n}` : ""} { ${o} }` : "", ve = (o) => o ? `::after { ${o} }` : "", we = (o) => o ? `::before { ${o} }` : "", it = (o, t = "", n = "") => o ? `${t}&[aria-invalid="true"]${n ? ` ${n}` : ""} { ${o} }` : "";
function je() {
  return (o) => {
    var t;
    o.type !== "decl" || !o.value || o.value.match(/important/) || ((t = o.root) == null ? void 0 : t.type) === "@font-face" || (o.value = o.value.replace(/;?$/, " !important;"));
  };
}
function He(...o) {
  const t = o.map((n) => `${n.trim()} `);
  return (n) => {
    var r;
    n.type === "rule" && ((r = n.root) == null ? void 0 : r.type) !== "@keyframes" && (!n.parent || n.props.length === 1 && n.value.charCodeAt(0) !== 58 || !n.length) && Array.isArray(n.props) && (n.props = n.props.flatMap((e) => t.map((i) => i + e)));
  };
}
const Wa = ({ namespace: o, theme: t, children: n }) => {
  const r = Mo(null), [e, i] = Co(t.state.currentWidgetWidth), { emotionCache: a, stylingScopeKey: c } = Vt(() => {
    const l = `${o}-${Math.floor(Math.random() * 123456789).toString()}`;
    return {
      emotionCache: Pe({
        key: o,
        stylisPlugins: [
          je(),
          Oe,
          He(`#${l}`)
        ]
      }),
      stylingScopeKey: l
    };
  }, [
    o
  ]);
  return Eo(() => {
    const l = new ResizeObserver(([p]) => {
      i(p.contentBoxSize.length ? p.contentBoxSize[0].inlineSize : p.contentRect.width);
    });
    return r.current && l.observe(r.current), () => {
      l.disconnect();
    };
  }, [
    t.breakpoint.matcher,
    r
  ]), /* @__PURE__ */ M(Le, {
    value: a,
    children: /* @__PURE__ */ wo(_e, {
      theme: {
        ...t,
        state: {
          ...t.state,
          currentWidgetWidth: e
        }
      },
      children: [
        /* @__PURE__ */ M(Ve, {
          styles: [
            (l) => k("*:not(svg *,canvas){all:revert;}", l.typography.customFontDeclaration ?? null)
          ]
        }),
        /* @__PURE__ */ M("div", {
          id: c,
          ref: r,
          style: {
            all: "revert",
            display: "block",
            margin: 0,
            padding: 0
          },
          children: n
        })
      ]
    }, o)
  });
}, lo = {
  MOBILE: "mobile",
  DESKTOP: "desktop"
}, ft = (o, t = 2) => o === null ? "" : o.toFixed(t).replace(".", ","), Ge = (o) => o.replace(/\s/g, ""), No = (o = {}, t) => {
  const n = [
    lo.DESKTOP,
    "variant",
    ...t || []
  ];
  return Object.entries(o).reduce((r, [e, i]) => n.some((a) => a === e) ? r : {
    ...r,
    [e]: i
  }, {});
};
function Ht(o, t, n) {
  var r = this, e = Mo(null), i = Mo(0), a = Mo(null), c = Mo([]), l = Mo(), p = Mo(), d = Mo(o), u = Mo(!0);
  d.current = o;
  var b = typeof window < "u", g = !t && t !== 0 && b;
  if (typeof o != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var m = !!(n = n || {}).leading, y = !("trailing" in n) || !!n.trailing, S = "maxWait" in n, h = "debounceOnServer" in n && !!n.debounceOnServer, w = S ? Math.max(+n.maxWait || 0, t) : null;
  Eo(function() {
    return u.current = !0, function() {
      u.current = !1;
    };
  }, []);
  var v = Vt(function() {
    var I = function(P) {
      var B = c.current, N = l.current;
      return c.current = l.current = null, i.current = P, p.current = d.current.apply(N, B);
    }, C = function(P, B) {
      g && cancelAnimationFrame(a.current), a.current = g ? requestAnimationFrame(P) : setTimeout(P, B);
    }, x = function(P) {
      if (!u.current) return !1;
      var B = P - e.current;
      return !e.current || B >= t || B < 0 || S && P - i.current >= w;
    }, T = function(P) {
      return a.current = null, y && c.current ? I(P) : (c.current = l.current = null, p.current);
    }, A = function P() {
      var B = Date.now();
      if (x(B)) return T(B);
      if (u.current) {
        var N = t - (B - e.current), _ = S ? Math.min(N, w - (B - i.current)) : N;
        C(P, _);
      }
    }, O = function() {
      if (b || h) {
        var P = Date.now(), B = x(P);
        if (c.current = [].slice.call(arguments), l.current = r, e.current = P, B) {
          if (!a.current && u.current) return i.current = e.current, C(A, t), m ? I(e.current) : p.current;
          if (S) return C(A, t), I(e.current);
        }
        return a.current || C(A, t), p.current;
      }
    };
    return O.cancel = function() {
      a.current && (g ? cancelAnimationFrame(a.current) : clearTimeout(a.current)), i.current = 0, c.current = e.current = l.current = a.current = null;
    }, O.isPending = function() {
      return !!a.current;
    }, O.flush = function() {
      return a.current ? T(Date.now()) : p.current;
    }, O;
  }, [m, S, t, w, y, g, b, h]);
  return v;
}
const Ba = () => {
  const o = Io(), { currentWidgetWidth: t } = o.state, n = window.matchMedia(`(min-width: ${o.breakpoint.mobile}${o.breakpoint.unit})`), r = window.matchMedia(`(min-width: ${o.breakpoint.desktop}${o.breakpoint.unit})`), [e, i] = Co({
    mobile: n.matches,
    desktop: r.matches
  }), a = Ht((p, d) => {
    i((u) => ({
      ...u,
      [d]: p.matches
    }));
  }, 300);
  Eo(() => (o.breakpoint.matcher === "viewportWidth" && (n.addEventListener("change", (p) => a(p, lo.MOBILE)), r.addEventListener("change", (p) => a(p, lo.DESKTOP))), () => {
    o.breakpoint.matcher === "viewportWidth" && (n.removeEventListener("change", (p) => a(p, lo.MOBILE)), r.removeEventListener("change", (p) => a(p, lo.DESKTOP)));
  }), [
    a
  ]);
  const c = Ht((p) => {
    i((d) => Object.keys(d).reduce((u, b) => (u[b] = o.breakpoint[b] < p, u), {
      ...d
    }));
  }, 300);
  return Eo(() => {
    o.breakpoint.matcher === "widgetWidth" && c(t);
  }, [
    t,
    c,
    o.breakpoint.matcher
  ]), Vt(() => {
    const p = Object.keys(e).reverse().find((d) => e[d]) || lo.MOBILE;
    return {
      currentBreakpoint: p,
      isMobile: p === lo.MOBILE,
      isDesktop: p === lo.DESKTOP
    };
  }, [
    e
  ]);
}, Zo = {
  AUSTRIA: "austria",
  DENMARK: "denmark",
  FINLAND: "finland",
  LITHUANIA: "lithuania",
  NORWAY: "norway",
  SLOVAKIA: "slovakia",
  SWEDEN: "sweden",
  UNITED_KINGDOM: "united-kingdom"
}, Oo = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  QUATERNARY: "quaternary"
}, qo = {
  ...Oo,
  TEXT: "text",
  CLEAN: "clean"
};
var Mn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ke(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var ln = { exports: {} };
ln.exports;
var se;
function Ue() {
  return se || (se = 1, function(o, t) {
    var n = 200, r = "__lodash_hash_undefined__", e = 800, i = 16, a = 9007199254740991, c = "[object Arguments]", l = "[object Array]", p = "[object AsyncFunction]", d = "[object Boolean]", u = "[object Date]", b = "[object Error]", g = "[object Function]", m = "[object GeneratorFunction]", y = "[object Map]", S = "[object Number]", h = "[object Null]", w = "[object Object]", v = "[object Proxy]", I = "[object RegExp]", C = "[object Set]", x = "[object String]", T = "[object Undefined]", A = "[object WeakMap]", O = "[object ArrayBuffer]", P = "[object DataView]", B = "[object Float32Array]", N = "[object Float64Array]", _ = "[object Int8Array]", D = "[object Int16Array]", R = "[object Int32Array]", j = "[object Uint8Array]", V = "[object Uint8ClampedArray]", Z = "[object Uint16Array]", J = "[object Uint32Array]", F = /[\\^$.*+?()[\]{}|]/g, L = /^\[object .+?Constructor\]$/, H = /^(?:0|[1-9]\d*)$/, E = {};
    E[B] = E[N] = E[_] = E[D] = E[R] = E[j] = E[V] = E[Z] = E[J] = !0, E[c] = E[l] = E[O] = E[d] = E[P] = E[u] = E[b] = E[g] = E[y] = E[S] = E[w] = E[I] = E[C] = E[x] = E[A] = !1;
    var to = typeof Mn == "object" && Mn && Mn.Object === Object && Mn, so = typeof self == "object" && self && self.Object === Object && self, K = to || so || Function("return this")(), X = t && !t.nodeType && t, q = X && !0 && o && !o.nodeType && o, ro = q && q.exports === X, no = ro && to.process, io = function() {
      try {
        var s = q && q.require && q.require("util").types;
        return s || no && no.binding && no.binding("util");
      } catch {
      }
    }(), ao = io && io.isTypedArray;
    function z(s, f, $) {
      switch ($.length) {
        case 0:
          return s.call(f);
        case 1:
          return s.call(f, $[0]);
        case 2:
          return s.call(f, $[0], $[1]);
        case 3:
          return s.call(f, $[0], $[1], $[2]);
      }
      return s.apply(f, $);
    }
    function W(s, f) {
      for (var $ = -1, U = Array(s); ++$ < s; )
        U[$] = f($);
      return U;
    }
    function G(s) {
      return function(f) {
        return s(f);
      };
    }
    function Y(s, f) {
      return s == null ? void 0 : s[f];
    }
    function Q(s, f) {
      return function($) {
        return s(f($));
      };
    }
    var oo = Array.prototype, co = Function.prototype, po = Object.prototype, uo = K["__core-js_shared__"], fo = co.toString, bo = po.hasOwnProperty, So = function() {
      var s = /[^.]+$/.exec(uo && uo.keys && uo.keys.IE_PROTO || "");
      return s ? "Symbol(src)_1." + s : "";
    }(), vo = po.toString, Ro = fo.call(Object), To = RegExp(
      "^" + fo.call(bo).replace(F, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Ao = ro ? K.Buffer : void 0, Do = K.Symbol, Vo = K.Uint8Array;
    Ao && Ao.allocUnsafe;
    var ot = Q(Object.getPrototypeOf, Object), tt = Object.create, at = po.propertyIsEnumerable, st = oo.splice, Wo = Do ? Do.toStringTag : void 0, Ko = function() {
      try {
        var s = Zt(Object, "defineProperty");
        return s({}, "", {}), s;
      } catch {
      }
    }(), ct = Ao ? Ao.isBuffer : void 0, nt = Math.max, lt = Date.now, et = Zt(K, "Map"), jo = Zt(Object, "create"), pt = /* @__PURE__ */ function() {
      function s() {
      }
      return function(f) {
        if (!Lt(f))
          return {};
        if (tt)
          return tt(f);
        s.prototype = f;
        var $ = new s();
        return s.prototype = void 0, $;
      };
    }();
    function Bo(s) {
      var f = -1, $ = s == null ? 0 : s.length;
      for (this.clear(); ++f < $; ) {
        var U = s[f];
        this.set(U[0], U[1]);
      }
    }
    function dt() {
      this.__data__ = jo ? jo(null) : {}, this.size = 0;
    }
    function ut(s) {
      var f = this.has(s) && delete this.__data__[s];
      return this.size -= f ? 1 : 0, f;
    }
    function $t(s) {
      var f = this.__data__;
      if (jo) {
        var $ = f[s];
        return $ === r ? void 0 : $;
      }
      return bo.call(f, s) ? f[s] : void 0;
    }
    function ht(s) {
      var f = this.__data__;
      return jo ? f[s] !== void 0 : bo.call(f, s);
    }
    function vt(s, f) {
      var $ = this.__data__;
      return this.size += this.has(s) ? 0 : 1, $[s] = jo && f === void 0 ? r : f, this;
    }
    Bo.prototype.clear = dt, Bo.prototype.delete = ut, Bo.prototype.get = $t, Bo.prototype.has = ht, Bo.prototype.set = vt;
    function Lo(s) {
      var f = -1, $ = s == null ? 0 : s.length;
      for (this.clear(); ++f < $; ) {
        var U = s[f];
        this.set(U[0], U[1]);
      }
    }
    function wt() {
      this.__data__ = [], this.size = 0;
    }
    function It(s) {
      var f = this.__data__, $ = Mt(f, s);
      if ($ < 0)
        return !1;
      var U = f.length - 1;
      return $ == U ? f.pop() : st.call(f, $, 1), --this.size, !0;
    }
    function xt(s) {
      var f = this.__data__, $ = Mt(f, s);
      return $ < 0 ? void 0 : f[$][1];
    }
    function kt(s) {
      return Mt(this.__data__, s) > -1;
    }
    function Ct(s, f) {
      var $ = this.__data__, U = Mt($, s);
      return U < 0 ? (++this.size, $.push([s, f])) : $[U][1] = f, this;
    }
    Lo.prototype.clear = wt, Lo.prototype.delete = It, Lo.prototype.get = xt, Lo.prototype.has = kt, Lo.prototype.set = Ct;
    function Qo(s) {
      var f = -1, $ = s == null ? 0 : s.length;
      for (this.clear(); ++f < $; ) {
        var U = s[f];
        this.set(U[0], U[1]);
      }
    }
    function Rt() {
      this.size = 0, this.__data__ = {
        hash: new Bo(),
        map: new (et || Lo)(),
        string: new Bo()
      };
    }
    function At(s) {
      var f = Pt(this, s).delete(s);
      return this.size -= f ? 1 : 0, f;
    }
    function Tt(s) {
      return Pt(this, s).get(s);
    }
    function Ft(s) {
      return Pt(this, s).has(s);
    }
    function zt(s, f) {
      var $ = Pt(this, s), U = $.size;
      return $.set(s, f), this.size += $.size == U ? 0 : 1, this;
    }
    Qo.prototype.clear = Rt, Qo.prototype.delete = At, Qo.prototype.get = Tt, Qo.prototype.has = Ft, Qo.prototype.set = zt;
    function Jo(s) {
      var f = this.__data__ = new Lo(s);
      this.size = f.size;
    }
    function Dt() {
      this.__data__ = new Lo(), this.size = 0;
    }
    function Nt(s) {
      var f = this.__data__, $ = f.delete(s);
      return this.size = f.size, $;
    }
    function Et(s) {
      return this.__data__.get(s);
    }
    function Wt(s) {
      return this.__data__.has(s);
    }
    function Bt(s, f) {
      var $ = this.__data__;
      if ($ instanceof Lo) {
        var U = $.__data__;
        if (!et || U.length < n - 1)
          return U.push([s, f]), this.size = ++$.size, this;
        $ = this.__data__ = new Qo(U);
      }
      return $.set(s, f), this.size = $.size, this;
    }
    Jo.prototype.clear = Dt, Jo.prototype.delete = Nt, Jo.prototype.get = Et, Jo.prototype.has = Wt, Jo.prototype.set = Bt;
    function dn(s, f) {
      var $ = Hn(s), U = !$ && jn(s), mo = !$ && !U && te(s), ho = !$ && !U && !mo && ee(s), xo = $ || U || mo || ho, yo = xo ? W(s.length, String) : [], ko = yo.length;
      for (var rt in s)
        xo && // Safari 9 has enumerable `arguments.length` in strict mode.
        (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        mo && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        ho && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
        Xt(rt, ko)) || yo.push(rt);
      return yo;
    }
    function Kt(s, f, $) {
      ($ !== void 0 && !Bn(s[f], $) || $ === void 0 && !(f in s)) && Ut(s, f, $);
    }
    function un(s, f, $) {
      var U = s[f];
      (!(bo.call(s, f) && Bn(U, $)) || $ === void 0 && !(f in s)) && Ut(s, f, $);
    }
    function Mt(s, f) {
      for (var $ = s.length; $--; )
        if (Bn(s[$][0], f))
          return $;
      return -1;
    }
    function Ut(s, f, $) {
      f == "__proto__" && Ko ? Ko(s, f, {
        configurable: !0,
        enumerable: !0,
        value: $,
        writable: !0
      }) : s[f] = $;
    }
    var fn = Cn();
    function Ot(s) {
      return s == null ? s === void 0 ? T : h : Wo && Wo in Object(s) ? Rn(s) : Nn(s);
    }
    function Qt(s) {
      return tn(s) && Ot(s) == c;
    }
    function gn(s) {
      if (!Lt(s) || zn(s))
        return !1;
      var f = Kn(s) ? To : L;
      return f.test(Fe(s));
    }
    function bn(s) {
      return tn(s) && ne(s.length) && !!E[Ot(s)];
    }
    function mn(s) {
      if (!Lt(s))
        return Dn(s);
      var f = on(s), $ = [];
      for (var U in s)
        U == "constructor" && (f || !bo.call(s, U)) || $.push(U);
      return $;
    }
    function Jt(s, f, $, U, mo) {
      s !== f && fn(f, function(ho, xo) {
        if (mo || (mo = new Jo()), Lt(ho))
          yn(s, f, xo, $, Jt, U, mo);
        else {
          var yo = U ? U(qt(s, xo), ho, xo + "", s, f, mo) : void 0;
          yo === void 0 && (yo = ho), Kt(s, xo, yo);
        }
      }, re);
    }
    function yn(s, f, $, U, mo, ho, xo) {
      var yo = qt(s, $), ko = qt(f, $), rt = xo.get(ko);
      if (rt) {
        Kt(s, $, rt);
        return;
      }
      var Uo = ho ? ho(yo, ko, $ + "", s, f, xo) : void 0, nn = Uo === void 0;
      if (nn) {
        var Un = Hn(ko), Zn = !Un && te(ko), ae = !Un && !Zn && ee(ko);
        Uo = ko, Un || Zn || ae ? Hn(yo) ? Uo = yo : ze(yo) ? Uo = In(yo) : Zn ? (nn = !1, Uo = hn(ko)) : ae ? (nn = !1, Uo = wn(ko)) : Uo = [] : De(ko) || jn(ko) ? (Uo = yo, jn(yo) ? Uo = Ne(yo) : (!Lt(yo) || Kn(yo)) && (Uo = An(ko))) : nn = !1;
      }
      nn && (xo.set(ko, Uo), mo(Uo, ko, U, ho, xo), xo.delete(ko)), Kt(s, $, Uo);
    }
    function Sn(s, f) {
      return Wn(En(s, f, ie), s + "");
    }
    var $n = Ko ? function(s, f) {
      return Ko(s, "toString", {
        configurable: !0,
        enumerable: !1,
        value: We(f),
        writable: !0
      });
    } : ie;
    function hn(s, f) {
      return s.slice();
    }
    function vn(s) {
      var f = new s.constructor(s.byteLength);
      return new Vo(f).set(new Vo(s)), f;
    }
    function wn(s, f) {
      var $ = vn(s.buffer);
      return new s.constructor($, s.byteOffset, s.length);
    }
    function In(s, f) {
      var $ = -1, U = s.length;
      for (f || (f = Array(U)); ++$ < U; )
        f[$] = s[$];
      return f;
    }
    function xn(s, f, $, U) {
      var mo = !$;
      $ || ($ = {});
      for (var ho = -1, xo = f.length; ++ho < xo; ) {
        var yo = f[ho], ko = void 0;
        ko === void 0 && (ko = s[yo]), mo ? Ut($, yo, ko) : un($, yo, ko);
      }
      return $;
    }
    function kn(s) {
      return Sn(function(f, $) {
        var U = -1, mo = $.length, ho = mo > 1 ? $[mo - 1] : void 0, xo = mo > 2 ? $[2] : void 0;
        for (ho = s.length > 3 && typeof ho == "function" ? (mo--, ho) : void 0, xo && Tn($[0], $[1], xo) && (ho = mo < 3 ? void 0 : ho, mo = 1), f = Object(f); ++U < mo; ) {
          var yo = $[U];
          yo && s(f, yo, U, ho);
        }
        return f;
      });
    }
    function Cn(s) {
      return function(f, $, U) {
        for (var mo = -1, ho = Object(f), xo = U(f), yo = xo.length; yo--; ) {
          var ko = xo[++mo];
          if ($(ho[ko], ko, ho) === !1)
            break;
        }
        return f;
      };
    }
    function Pt(s, f) {
      var $ = s.__data__;
      return Fn(f) ? $[typeof f == "string" ? "string" : "hash"] : $.map;
    }
    function Zt(s, f) {
      var $ = Y(s, f);
      return gn($) ? $ : void 0;
    }
    function Rn(s) {
      var f = bo.call(s, Wo), $ = s[Wo];
      try {
        s[Wo] = void 0;
        var U = !0;
      } catch {
      }
      var mo = vo.call(s);
      return U && (f ? s[Wo] = $ : delete s[Wo]), mo;
    }
    function An(s) {
      return typeof s.constructor == "function" && !on(s) ? pt(ot(s)) : {};
    }
    function Xt(s, f) {
      var $ = typeof s;
      return f = f ?? a, !!f && ($ == "number" || $ != "symbol" && H.test(s)) && s > -1 && s % 1 == 0 && s < f;
    }
    function Tn(s, f, $) {
      if (!Lt($))
        return !1;
      var U = typeof f;
      return (U == "number" ? Gn($) && Xt(f, $.length) : U == "string" && f in $) ? Bn($[f], s) : !1;
    }
    function Fn(s) {
      var f = typeof s;
      return f == "string" || f == "number" || f == "symbol" || f == "boolean" ? s !== "__proto__" : s === null;
    }
    function zn(s) {
      return !!So && So in s;
    }
    function on(s) {
      var f = s && s.constructor, $ = typeof f == "function" && f.prototype || po;
      return s === $;
    }
    function Dn(s) {
      var f = [];
      if (s != null)
        for (var $ in Object(s))
          f.push($);
      return f;
    }
    function Nn(s) {
      return vo.call(s);
    }
    function En(s, f, $) {
      return f = nt(f === void 0 ? s.length - 1 : f, 0), function() {
        for (var U = arguments, mo = -1, ho = nt(U.length - f, 0), xo = Array(ho); ++mo < ho; )
          xo[mo] = U[f + mo];
        mo = -1;
        for (var yo = Array(f + 1); ++mo < f; )
          yo[mo] = U[mo];
        return yo[f] = $(xo), z(s, this, yo);
      };
    }
    function qt(s, f) {
      if (!(f === "constructor" && typeof s[f] == "function") && f != "__proto__")
        return s[f];
    }
    var Wn = Te($n);
    function Te(s) {
      var f = 0, $ = 0;
      return function() {
        var U = lt(), mo = i - (U - $);
        if ($ = U, mo > 0) {
          if (++f >= e)
            return arguments[0];
        } else
          f = 0;
        return s.apply(void 0, arguments);
      };
    }
    function Fe(s) {
      if (s != null) {
        try {
          return fo.call(s);
        } catch {
        }
        try {
          return s + "";
        } catch {
        }
      }
      return "";
    }
    function Bn(s, f) {
      return s === f || s !== s && f !== f;
    }
    var jn = Qt(/* @__PURE__ */ function() {
      return arguments;
    }()) ? Qt : function(s) {
      return tn(s) && bo.call(s, "callee") && !at.call(s, "callee");
    }, Hn = Array.isArray;
    function Gn(s) {
      return s != null && ne(s.length) && !Kn(s);
    }
    function ze(s) {
      return tn(s) && Gn(s);
    }
    var te = ct || Be;
    function Kn(s) {
      if (!Lt(s))
        return !1;
      var f = Ot(s);
      return f == g || f == m || f == p || f == v;
    }
    function ne(s) {
      return typeof s == "number" && s > -1 && s % 1 == 0 && s <= a;
    }
    function Lt(s) {
      var f = typeof s;
      return s != null && (f == "object" || f == "function");
    }
    function tn(s) {
      return s != null && typeof s == "object";
    }
    function De(s) {
      if (!tn(s) || Ot(s) != w)
        return !1;
      var f = ot(s);
      if (f === null)
        return !0;
      var $ = bo.call(f, "constructor") && f.constructor;
      return typeof $ == "function" && $ instanceof $ && fo.call($) == Ro;
    }
    var ee = ao ? G(ao) : bn;
    function Ne(s) {
      return xn(s, re(s));
    }
    function re(s) {
      return Gn(s) ? dn(s) : mn(s);
    }
    var Ee = kn(function(s, f, $) {
      Jt(s, f, $);
    });
    function We(s) {
      return function() {
        return s;
      };
    }
    function ie(s) {
      return s;
    }
    function Be() {
      return !1;
    }
    o.exports = Ee;
  }(ln, ln.exports)), ln.exports;
}
var Ze = Ue();
const qe = /* @__PURE__ */ Ke(Ze), Ma = ({ baseSpacing: o, overrides: t = {} }) => ({
  ...qe({
    breakpoint: {
      matcher: "widgetWidth",
      unit: "px",
      desktop: 769,
      mobile: 300
    },
    state: {
      currentWidgetWidth: 320
    },
    typography: {
      color: {
        primary: "#000",
        secondary: "#666"
      },
      font: {
        primary: "Helvetica, Arial, sans-serif",
        secondary: "Helvetica, Arial, sans-serif"
      },
      size: {
        xxxs: "8px",
        xxs: "10px",
        xs: "12px",
        sm: "14px",
        md: "16px",
        lg: "18px",
        xl: "20px",
        xxl: "22px",
        xxxl: "26px",
        xxxxl: "32px"
      }
    }
  }, t),
  mq({ theme: e, min: i, max: a, css: c }) {
    if (c.trim().length === 0)
      return "";
    if (e.breakpoint.matcher === "widgetWidth") {
      if (e.breakpoint.unit !== "px")
        throw new Error('Theme breakpoints must use px unit when matcher is "widgetWidth"');
      const { currentWidgetWidth: u } = e.state, b = i != null ? e.breakpoint[i] : 0, g = a != null ? e.breakpoint[a] : 0;
      return b && g ? u > b && u < g ? c : "" : b && u > b || g && u < g ? c : "";
    }
    const { unit: l } = e.breakpoint, p = i != null ? `${e.breakpoint[i]}${l}` : "", d = a != null ? `${e.breakpoint[a]}${l}` : "";
    return p && d ? `@media (min-width: ${p}) and (max-width: ${d}) { ${c} }` : p ? `@media (min-width: ${p}) { ${c} }` : d ? `@media (max-width: ${d}) { ${c} }` : "";
  },
  spacing(e, i, a, c) {
    const { amount: l, unit: p } = o, d = (u) => typeof u == "number" ? `${u * l}${u !== 0 ? p : ""}` : u;
    return [
      d(e),
      d(i),
      d(a),
      d(c)
    ].filter((u) => u).join(" ");
  }
}), pn = /* @__PURE__ */ eo("span", {
  target: "e1obdov00"
})("all:revert;box-sizing:border-box;"), Ye = /* @__PURE__ */ eo("button", {
  target: "e1obdov01"
})(({ theme: o, variant: t, hasIcon: n, iconPlacement: r }) => {
  var i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q;
  const e = {
    ...((i = o.component) == null ? void 0 : i.Button) ?? {},
    ...t === qo.TEXT ? {
      padding: 0,
      background: "transparent",
      border: "none",
      hoverStyle: "background: transparent;",
      focusVisibleStyle: `
                background: transparent;
                border: none;
                outline: none;
            `,
      activeStyle: "background: transparent;"
    } : {},
    ...t === qo.CLEAN ? {
      display: "inline-flex",
      width: "auto",
      maxWidth: "100%",
      padding: 0,
      background: "transparent",
      border: "none",
      borderRadius: 0,
      boxShadow: "none",
      fontFamily: "primary",
      fontSize: "md",
      fontWeight: "normal",
      lineHeight: 1,
      color: o.typography.color.primary,
      textAlign: "initial",
      cursor: "initial",
      textDecoration: "none",
      transition: "none",
      hoverStyle: "background: transparent;",
      focusVisibleStyle: `
                          background: transparent;
                          border: none;
                          outline: none;
                      `,
      activeStyle: "background: transparent;"
    } : {},
    ...((l = (c = (a = o.component) == null ? void 0 : a.Button) == null ? void 0 : c.variant) == null ? void 0 : l[t]) ?? {},
    withIcon: {
      ...((d = (p = o.component) == null ? void 0 : p.Button) == null ? void 0 : d.withIcon) ?? {},
      ...((m = (g = (b = (u = o.component) == null ? void 0 : u.Button) == null ? void 0 : b.variant) == null ? void 0 : g[t]) == null ? void 0 : m.withIcon) ?? {},
      ...r === "left" && ((h = (S = (y = o.component) == null ? void 0 : y.Button) == null ? void 0 : S.withIcon) != null && h.leftPlacement) ? o.component.Button.withIcon.leftPlacement : {},
      desktop: {
        ...((I = (v = (w = o.component) == null ? void 0 : w.Button) == null ? void 0 : v.withIcon) == null ? void 0 : I.desktop) ?? {},
        ...((O = (A = (T = (x = (C = o.component) == null ? void 0 : C.Button) == null ? void 0 : x.variant) == null ? void 0 : T[t]) == null ? void 0 : A.withIcon) == null ? void 0 : O.desktop) ?? {},
        ...r === "left" && ((_ = (N = (B = (P = o.component) == null ? void 0 : P.Button) == null ? void 0 : B.withIcon) == null ? void 0 : N.leftPlacement) != null && _.desktop) ? o.component.Button.withIcon.leftPlacement.desktop : {}
      }
    }
  };
  return `
            all: revert;
            box-sizing: border-box;
            display: ${e.display || "inline-flex"};
            ${e.justifyContent ? `justify-content: ${e.justifyContent};` : ""}
            ${e.alignItems ? `align-items: ${e.alignItems};` : ""}
            width: ${e.width ?? "auto"};
            max-width: ${e.maxWidth ?? "100%"};
            margin: 0;
            padding: ${e.padding ?? o.spacing(3, 5)};
            background: ${e.background || "#fff"};
            border: ${e.border ?? "1px solid #000"};
            border-radius: ${e.borderRadius ?? 0};
            ${e.boxShadow ? `box-shadow: ${e.boxShadow};` : ""}
            font-family: ${o.typography.font[e.fontFamily || "primary"]};
            font-size: ${o.typography.size[e.fontSize || "md"]};
            font-weight: ${e.fontWeight || "normal"};
            line-height: ${e.lineHeight ?? "100%"};
            ${e.letterSpacing != null ? `letter-spacing: ${e.letterSpacing};` : ""}
            color: ${e.color || o.typography.color.primary};
            text-align: ${e.textAlign || "initial"};
            text-decoration: ${e.textDecoration || "none"};
            ${e.transition ? `transition: ${e.transition};` : ""}
            cursor: ${e.cursor || "pointer"};

            // Webkit browsers tend to add a background color on mobile when tapping a link or similar, this removes it.
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            -webkit-tap-highlight-color: transparent;

            ${Fo(e.hoverStyle)}
            ${_o({
    focusStyle: e.focusStyle,
    focusVisibleStyle: e.focusVisibleStyle
  })}
            ${Yo(e.activeStyle)}
            ${Xo(e.disabledStyle)}

            ${e.contentMargin != null ? `> ${pn} { margin: ${e.contentMargin}}; ` : ""}

            ${e.desktop ? o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                            ${e.desktop.display ? `display: ${e.desktop.display};` : ""}
                            ${e.desktop.justifyContent ? `justify-content: ${e.desktop.justifyContent};` : ""}
                            ${e.desktop.alignItems ? `align-items: ${e.desktop.alignItems};` : ""}
                            ${e.desktop.width != null ? `width: ${e.desktop.width};` : ""}
                            ${e.desktop.maxWidth != null ? `max-width: ${e.desktop.maxWidth};` : ""}
                            ${e.desktop.padding != null ? `padding: ${e.desktop.padding};` : ""}
                            ${e.desktop.background ? `background: ${e.desktop.background};` : ""}
                            ${e.desktop.border != null ? `border: ${e.desktop.border};` : ""}
                            ${e.desktop.borderRadius != null ? `border-radius: ${e.desktop.borderRadius};` : ""}
                            ${e.desktop.boxShadow ? `box-shadow: ${e.desktop.boxShadow};` : ""}
                            ${e.desktop.fontFamily ? `font-family: ${o.typography.font[e.desktop.fontFamily]};` : ""}
                            ${e.desktop.fontSize ? `font-size: ${o.typography.size[e.desktop.fontSize]}` : ""};
                            ${e.desktop.fontWeight != null ? `font-weight: ${e.desktop.fontWeight};` : ""}
                            ${e.desktop.lineHeight != null ? `line-height: ${e.desktop.lineHeight};` : ""};
                            ${e.desktop.letterSpacing != null ? `letter-spacing: ${e.desktop.letterSpacing};` : ""};
                            ${e.desktop.color ? `color: ${e.desktop.color};` : ""}
                            ${e.desktop.textAlign ? `text-align: ${e.desktop.textAlign};` : ""}
                            ${e.desktop.textDecoration ? `text-decoration: ${e.desktop.textDecoration};` : ""}
                            ${e.desktop.transition ? `transition: ${e.desktop.transition};` : ""}
                        
                            ${Fo(e.desktop.hoverStyle)}
                            ${_o({
      focusStyle: e.desktop.focusStyle,
      focusVisibleStyle: e.desktop.focusVisibleStyle
    })}
                            ${Yo(e.desktop.activeStyle)}
                            ${Xo(e.desktop.disabledStyle)}

                            ${e.desktop.contentMargin != null ? `> ${pn} { margin: ${e.desktop.contentMargin}}; ` : ""}
                          `
  }) : ""}

            ${n ? `
                        display: grid;
                        grid-auto-flow: column;
                        justify-content: ${((D = e.withIcon) == null ? void 0 : D.justifyContent) || "space-between"};
                        align-items: ${((R = e.withIcon) == null ? void 0 : R.alignItems) || "center"};
                        gap: ${((j = e.withIcon) == null ? void 0 : j.gap) ?? o.spacing(2)};
                        ${((V = e.withIcon) == null ? void 0 : V.padding) != null ? `padding: ${e.withIcon.padding};` : ""}

                        ${((Z = e.withIcon) == null ? void 0 : Z.contentMargin) != null ? `> ${pn} { margin: ${e.withIcon.contentMargin}}; ` : ""}

                        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                                ${(F = (J = e.withIcon) == null ? void 0 : J.desktop) != null && F.justifyContent ? `justify-content: ${e.withIcon.desktop.justifyContent};` : ""}
                                ${(H = (L = e.withIcon) == null ? void 0 : L.desktop) != null && H.alignItems ? `align-items: ${e.withIcon.desktop.alignItems};` : ""}
                                ${((to = (E = e.withIcon) == null ? void 0 : E.desktop) == null ? void 0 : to.gap) != null ? `gap: ${e.withIcon.desktop.gap};` : ""}
                                ${((K = (so = e.withIcon) == null ? void 0 : so.desktop) == null ? void 0 : K.padding) != null ? `padding: ${e.withIcon.desktop.padding};` : ""}

                                ${((q = (X = e.withIcon) == null ? void 0 : X.desktop) == null ? void 0 : q.contentMargin) != null ? `> ${pn} { margin: ${e.withIcon.desktop.contentMargin}}; ` : ""}
                            `
  })}
                    ` : ""}
        `;
}), St = /* @__PURE__ */ $o.forwardRef(({ variant: o = qo.PRIMARY, icon: t, iconPlacement: n = "right", type: r = "button", children: e, ...i }, a) => /* @__PURE__ */ wo(Ye, {
  variant: o,
  hasIcon: !!t,
  iconPlacement: n,
  type: r,
  ref: a,
  ...i,
  children: [
    n === "left" && t,
    /* @__PURE__ */ M(pn, {
      children: e
    }),
    n === "right" && t
  ]
})), Qn = {
  white: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNzUgOC43NUw2Ljc1IDEyLjI1TDE0LjI1IDEuNzUiIHN0cm9rZT0iI2ZmZmZmZiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
  black: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNzUgOC43NUw2Ljc1IDEyLjI1TDE0LjI1IDEuNzUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
  grey: "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNzUgOC43NUw2Ljc1IDEyLjI1TDE0LjI1IDEuNzUiIHN0cm9rZT0iIzgwODA4MCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
}, Qe = (o) => typeof o < "u" && Object.keys(Qn).includes(o), Je = (o) => o ? Qe(o) ? Qn[o] : o : Qn.black, Xe = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo, Ro, To, Ao, Do;
  return /* @__PURE__ */ k("all:revert;box-sizing:border-box;appearance:none;", (n = (t = o.component) == null ? void 0 : t.Checkbox) != null && n.position ? `position: ${o.component.Checkbox.position};` : "", "  display:", ((e = (r = o.component) == null ? void 0 : r.Checkbox) == null ? void 0 : e.display) ?? "inline-flex", ";width:", ((a = (i = o.component) == null ? void 0 : i.Checkbox) == null ? void 0 : a.width) ?? "20px", ";height:", ((l = (c = o.component) == null ? void 0 : c.Checkbox) == null ? void 0 : l.height) ?? "20px", ";margin:0;padding:", ((d = (p = o.component) == null ? void 0 : p.Checkbox) == null ? void 0 : d.padding) ?? ((u = o.formInput) == null ? void 0 : u.padding) ?? 0, ";background:", ((g = (b = o.component) == null ? void 0 : b.Checkbox) == null ? void 0 : g.background) ?? ((m = o.formInput) == null ? void 0 : m.background) ?? "#fff", ";border:", ((S = (y = o.component) == null ? void 0 : y.Checkbox) == null ? void 0 : S.border) ?? ((h = o.formInput) == null ? void 0 : h.border) ?? "1px solid #000", ";", ((v = (w = o.component) == null ? void 0 : w.Checkbox) == null ? void 0 : v.borderBottom) != null ? `border-bottom: ${o.component.Checkbox.borderBottom};` : "", "  border-radius:", ((C = (I = o.component) == null ? void 0 : I.Checkbox) == null ? void 0 : C.borderRadius) ?? ((x = o.formInput) == null ? void 0 : x.borderRadius) ?? "0", ";box-shadow:", ((A = (T = o.component) == null ? void 0 : T.Checkbox) == null ? void 0 : A.boxShadow) ?? ((O = o.formInput) == null ? void 0 : O.boxShadow) ?? "none", ";cursor:", ((B = (P = o.component) == null ? void 0 : P.Checkbox) == null ? void 0 : B.cursor) ?? "pointer", ";", (_ = (N = o.component) == null ? void 0 : N.Checkbox) != null && _.transition || (D = o.formInput) != null && D.transition ? `transition: ${((j = (R = o.component) == null ? void 0 : R.Checkbox) == null ? void 0 : j.transition) || ((V = o.formInput) == null ? void 0 : V.transition)};` : "", " ", (J = (Z = o.component) == null ? void 0 : Z.Checkbox) != null && J.transitionProperty || (F = o.formInput) != null && F.transitionProperty ? `transition-property: ${((H = (L = o.component) == null ? void 0 : L.Checkbox) == null ? void 0 : H.transitionProperty) || ((E = o.formInput) == null ? void 0 : E.transitionProperty)};` : "", " ", we((so = (to = o.component) == null ? void 0 : to.Checkbox) == null ? void 0 : so.beforeElementStyle), " ", ve((X = (K = o.component) == null ? void 0 : K.Checkbox) == null ? void 0 : X.afterElementStyle), " ", Ln(`
        background-image: url(data:image/svg+xml;base64,${Je((ro = (q = o.component) == null ? void 0 : q.Checkbox) == null ? void 0 : ro.checkmark)});
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 90%;
        ${((io = (no = o.component) == null ? void 0 : no.Checkbox) == null ? void 0 : io.checkedStyle) || ""}`), " ", _o({
    focusStyle: ((z = (ao = o.component) == null ? void 0 : ao.Checkbox) == null ? void 0 : z.focusStyle) || ((W = o.formInput) == null ? void 0 : W.focusStyle),
    focusVisibleStyle: ((Y = (G = o.component) == null ? void 0 : G.Checkbox) == null ? void 0 : Y.focusVisibleStyle) || ((Q = o.formInput) == null ? void 0 : Q.focusVisibleStyle)
  }), " ", Fo(((co = (oo = o.component) == null ? void 0 : oo.Checkbox) == null ? void 0 : co.hoverStyle) || ((po = o.formInput) == null ? void 0 : po.hoverStyle)), " ", Yo(((fo = (uo = o.component) == null ? void 0 : uo.Checkbox) == null ? void 0 : fo.activeStyle) || ((bo = o.formInput) == null ? void 0 : bo.activeStyle)), " ", Xo(((vo = (So = o.component) == null ? void 0 : So.Checkbox) == null ? void 0 : vo.disabledStyle) || ((Ro = o.formInput) == null ? void 0 : Ro.disabledStyle)), " ", it(((Ao = (To = o.component) == null ? void 0 : To.Checkbox) == null ? void 0 : Ao.invalidStyle) || ((Do = o.formInput) == null ? void 0 : Do.invalidStyle)));
}, or = {
  checkbox: Xe
}, Oa = /* @__PURE__ */ $o.forwardRef(({ hasError: o = !1, errorMessageElementId: t, ...n }, r) => /* @__PURE__ */ M("input", {
  type: "checkbox",
  css: or.checkbox,
  ref: r,
  "aria-invalid": o,
  "aria-errormessage": o ? t : void 0,
  ...n
})), tr = /* @__PURE__ */ eo("dd", {
  target: "eq0ehr80"
})(({ theme: o, variant: t = Oo.PRIMARY }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m;
  const n = {
    ...(r = o.component) == null ? void 0 : r.DescriptionDetail,
    ...(a = (i = (e = o.component) == null ? void 0 : e.DescriptionDetail) == null ? void 0 : i.variant) == null ? void 0 : a[t],
    desktop: {
      ...(l = (c = o.component) == null ? void 0 : c.DescriptionDetail) == null ? void 0 : l.desktop,
      ...(b = (u = (d = (p = o.component) == null ? void 0 : p.DescriptionDetail) == null ? void 0 : d.variant) == null ? void 0 : u[t]) == null ? void 0 : b.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    justifyContent: n.justifyContent,
    alignItems: n.alignItems,
    margin: n.margin ?? 0,
    padding: n.padding ?? 0,
    fontFamily: n.fontFamily ? o.typography.font[n.fontFamily] : "inherit",
    fontSize: n.fontSize ? o.typography.size[n.fontSize] : "inherit",
    fontWeight: n.fontWeight || "inherit",
    lineHeight: n.lineHeight ?? "inherit",
    letterSpacing: n.letterSpacing ?? "inherit",
    textTransform: n.textTransform || "inherit",
    textAlign: n.textAlign || "right",
    color: n.color || "inherit"
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...n.desktop,
      fontFamily: (g = n.desktop) != null && g.fontFamily ? o.typography.font[n.desktop.fontFamily] : void 0,
      fontSize: (m = n.desktop) != null && m.fontSize ? o.typography.size[n.desktop.fontSize] : void 0
    }).styles
  })}
    `;
}), nr = /* @__PURE__ */ eo("dt", {
  target: "e1g7ht1x0"
})(({ theme: o, variant: t = Oo.PRIMARY }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m;
  const n = {
    ...(r = o.component) == null ? void 0 : r.DescriptionTerm,
    ...(a = (i = (e = o.component) == null ? void 0 : e.DescriptionTerm) == null ? void 0 : i.variant) == null ? void 0 : a[t],
    desktop: {
      ...(l = (c = o.component) == null ? void 0 : c.DescriptionTerm) == null ? void 0 : l.desktop,
      ...(b = (u = (d = (p = o.component) == null ? void 0 : p.DescriptionTerm) == null ? void 0 : d.variant) == null ? void 0 : u[t]) == null ? void 0 : b.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    justifyContent: n.justifyContent,
    alignItems: n.alignItems,
    margin: n.margin ?? 0,
    padding: n.padding ?? 0,
    fontFamily: n.fontFamily ? o.typography.font[n.fontFamily] : "inherit",
    fontSize: n.fontSize ? o.typography.size[n.fontSize] : "inherit",
    fontWeight: n.fontWeight || "inherit",
    lineHeight: n.lineHeight ?? "inherit",
    letterSpacing: n.letterSpacing ?? "inherit",
    textTransform: n.textTransform || "inherit",
    textAlign: n.textAlign || "left",
    color: n.color || "inherit"
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...n.desktop,
      fontFamily: (g = n.desktop) != null && g.fontFamily ? o.typography.font[n.desktop.fontFamily] : void 0,
      fontSize: (m = n.desktop) != null && m.fontSize ? o.typography.size[n.desktop.fontSize] : void 0
    }).styles
  })}
    `;
}), er = /* @__PURE__ */ eo("h3", {
  target: "e1qz211v0"
})(({ level: o, noBottomMargin: t, theme: n }) => {
  var a, c, l;
  const r = (a = n.component) == null ? void 0 : a.Heading, e = (l = (c = n.component) == null ? void 0 : c.Heading) == null ? void 0 : l[`h${o}`], i = {
    ...r,
    ...e,
    [lo.DESKTOP]: {
      ...r == null ? void 0 : r.desktop,
      ...e == null ? void 0 : e.desktop
    }
  };
  return `
            all: revert;
            display: ${i.display || "block"};
            margin: ${i.margin ?? n.spacing(0, 0, 1, 0)};
            ${t ? "margin-bottom: 0;" : ""}
            padding: ${i.padding ?? 0};
            border: ${i.border ?? "none"};
            border-bottom: ${i.borderBottom ?? "none"};
            box-shadow: ${i.boxShadow || "none"};
            font-family: ${n.typography.font[i.fontFamily ?? "primary"]};
            font-weight: ${i.fontWeight ?? "bold"};
            font-size: ${n.typography.size[i.fontSize ?? "lg"]};
            line-height: ${i.lineHeight ?? "inherit"};
            ${i.letterSpacing != null ? `letter-spacing: ${i.letterSpacing};` : ""}
            color: ${i.color || "inherit"};
            text-transform: ${i.textTransform || "none"};
            text-align: ${i.textAlign || "left"};

            ${_o({
    focusStyle: i.focusStyle,
    focusVisibleStyle: i.focusVisibleStyle
  })}
            
            ${n.mq({
    theme: n,
    min: lo.DESKTOP,
    css: `
                    ${k({
      ...i.desktop,
      fontFamily: i.desktop.fontFamily ? n.typography.font[i.desktop.fontFamily] : void 0,
      fontSize: i.desktop.fontSize ? n.typography.size[i.desktop.fontSize] : void 0
    }).styles}
                    ${_o({
      focusStyle: i.desktop.focusStyle,
      focusVisibleStyle: i.desktop.focusVisibleStyle
    })}
                `
  })}
        `;
}), rr = /* @__PURE__ */ $o.forwardRef(({ level: o, noBottomMargin: t = !1, children: n, ...r }, e) => /* @__PURE__ */ M(er, {
  as: `h${o}`,
  level: o,
  noBottomMargin: t,
  ref: e,
  tabIndex: -1,
  ...r,
  children: n
})), zo = /* @__PURE__ */ $o.forwardRef(({ instance: o, ...t }, n) => /* @__PURE__ */ M(o, {
  ref: n,
  ...t
})), Ho = {
  ARROW_LEFT: "arrowLeft",
  ARROW_RIGHT: "arrowRight",
  ARROW_UP: "arrowUp",
  ARROW_DOWN: "arrowDown",
  CHEVRON_UP: "chevronUp",
  CHEVRON_DOWN: "chevronDown",
  CHEVRON_LEFT: "chevronLeft",
  CHEVRON_RIGHT: "chevronRight",
  CROSS: "cross",
  ERROR: "error",
  MINUS: "minus",
  PLUS: "plus",
  QUESTIONMARK: "questionmark",
  INFO: "info"
}, ir = (o, t) => {
  var n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x;
  return /* @__PURE__ */ k({
    all: "revert",
    boxSizing: "border-box",
    width: ((r = (n = o.component) == null ? void 0 : n.Icon) == null ? void 0 : r.width) ?? "24px",
    minWidth: (i = (e = o.component) == null ? void 0 : e.Icon) == null ? void 0 : i.minWidth,
    maxWidth: (c = (a = o.component) == null ? void 0 : a.Icon) == null ? void 0 : c.maxWidth,
    height: ((p = (l = o.component) == null ? void 0 : l.Icon) == null ? void 0 : p.height) ?? "24px",
    minHeight: (u = (d = o.component) == null ? void 0 : d.Icon) == null ? void 0 : u.minHeight,
    maxHeight: (g = (b = o.component) == null ? void 0 : b.Icon) == null ? void 0 : g.maxHeight,
    margin: ((y = (m = o.component) == null ? void 0 : m.Icon) == null ? void 0 : y.margin) ?? 0,
    padding: ((h = (S = o.component) == null ? void 0 : S.Icon) == null ? void 0 : h.padding) ?? 0,
    color: ((v = (w = o.component) == null ? void 0 : w.Icon) == null ? void 0 : v.color) || "inherit",
    ...(x = (C = (I = o.component) == null ? void 0 : I.Icon) == null ? void 0 : C[t]) == null ? void 0 : x.styles
  });
}, Go = {
  icon: ir
}, ar = (o, t) => /* @__PURE__ */ go.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { d: "M10.5 6L4.5 12M4.5 12L10.5 18M4.5 12L18.5 12", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), sr = Po(ar), cr = (o, t) => /* @__PURE__ */ go.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { d: "M12.5 18L18.5 12M18.5 12L12.5 6M18.5 12H4.5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), lr = Po(cr), pr = (o, t) => /* @__PURE__ */ go.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { d: "M17.5 11L11.5 5M11.5 5L5.5 11M11.5 5L11.5 19", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), dr = Po(pr), ur = (o, t) => /* @__PURE__ */ go.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { d: "M5.5 13L11.5 19M11.5 19L17.5 13M11.5 19L11.5 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), fr = Po(ur), gr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.293 8.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 10.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6Z", clipRule: "evenodd" })), br = Po(gr), mr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z", clipRule: "evenodd" })), yr = Po(mr), Sr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.707 5.293a1 1 0 0 1 0 1.414L10.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z", clipRule: "evenodd" })), $r = Po(Sr), hr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414Z", clipRule: "evenodd" })), vr = Po(hr), wr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293Z" })), Ir = Po(wr), xr = (o, t) => /* @__PURE__ */ go.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { d: "M12 6V15", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ go.createElement("circle", { cx: 12, cy: 12, r: 10.25, fill: "transparent", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ go.createElement("circle", { cx: 12, cy: 18, r: 1, fill: "currentColor" })), kr = Po(xr), Cr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z", clipRule: "evenodd" })), Rr = Po(Cr), Ar = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1Z", clipRule: "evenodd" })), Tr = Po(Ar), Fr = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", d: "M10.848 15.534v-1.33c0-.393.032-.72.096-.982s.16-.495.288-.698a2.62 2.62 0 0 1 .504-.611c.224-.204.496-.444.816-.72l.768-.655c.256-.233.488-.465.696-.698.208-.247.376-.502.504-.764.144-.276.216-.581.216-.916 0-.335-.072-.64-.216-.916a2.17 2.17 0 0 0-.528-.742 2.432 2.432 0 0 0-.816-.48 2.73 2.73 0 0 0-.984-.175c-.784 0-1.424.226-1.92.677-.48.45-.768 1.04-.864 1.767L6.96 8.073c.208-1.266.784-2.255 1.728-2.968.96-.727 2.144-1.09 3.552-1.09.672 0 1.296.094 1.872.283a4.386 4.386 0 0 1 1.536.786c.432.334.768.756 1.008 1.265.256.495.384 1.062.384 1.702 0 .553-.088 1.04-.264 1.462a4.381 4.381 0 0 1-.744 1.156l-1.44 1.353-.24.196c-.256.218-.464.407-.624.567a2.16 2.16 0 0 0-.36.48c-.08.16-.136.342-.168.546a5.05 5.05 0 0 0-.048.764v.96h-2.304Zm-.456 3.011c0-.392.152-.727.456-1.003.32-.291.696-.437 1.128-.437.432 0 .8.146 1.104.437.32.276.48.61.48 1.003 0 .393-.16.735-.48 1.026a1.583 1.583 0 0 1-1.104.414 1.67 1.67 0 0 1-1.128-.414c-.304-.291-.456-.633-.456-1.026Z" })), zr = Po(Fr), Dr = (o, t) => /* @__PURE__ */ go.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { d: "M9.33325 9.30163C9.33325 8.84139 9.70635 8.4683 10.1666 8.4683C10.6268 8.4683 10.9999 8.84139 10.9999 9.30163V13.9166C10.9999 14.3769 10.6268 14.75 10.1666 14.75C9.70635 14.75 9.33325 14.3769 9.33325 13.9166V9.30163Z", fill: "currentColor" }), /* @__PURE__ */ go.createElement("path", { d: "M10.1666 6.92195C9.69039 6.92195 9.33325 6.54581 9.33325 6.04429C9.33325 5.54277 9.69039 5.16663 10.1666 5.16663C10.6428 5.16663 10.9999 5.54277 10.9999 6.04429C10.9999 6.54581 10.6428 6.92195 10.1666 6.92195Z", fill: "currentColor" }), /* @__PURE__ */ go.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.3333 10.1667C19.3333 15.2293 15.2293 19.3333 10.1667 19.3333C5.10406 19.3333 1 15.2293 1 10.1667C1 5.10406 5.10406 1 10.1667 1C15.2293 1 19.3333 5.10406 19.3333 10.1667ZM18.3333 10.1667C18.3333 14.677 14.677 18.3333 10.1667 18.3333C5.65634 18.3333 2 14.677 2 10.1667C2 5.65634 5.65634 2 10.1667 2C14.677 2 18.3333 5.65634 18.3333 10.1667Z", fill: "currentColor" })), Nr = Po(Dr), Er = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.arrowLeft) == null ? void 0 : e.icon) || sr,
    css: Go.icon(t, Ho.ARROW_LEFT),
    ...o
  });
}, Wr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.arrowRight) == null ? void 0 : e.icon) || lr,
    css: Go.icon(t, Ho.ARROW_RIGHT),
    ...o
  });
}, Br = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.arrowUp) == null ? void 0 : e.icon) || dr,
    css: Go.icon(t, Ho.ARROW_UP),
    ...o
  });
}, Mr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.arrowDown) == null ? void 0 : e.icon) || fr,
    css: Go.icon(t, Ho.ARROW_DOWN),
    ...o
  });
}, Or = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.chevronUp) == null ? void 0 : e.icon) || br,
    css: Go.icon(t, Ho.CHEVRON_UP),
    ...o
  });
}, Pr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.chevronDown) == null ? void 0 : e.icon) || yr,
    css: Go.icon(t, Ho.CHEVRON_DOWN),
    ...o
  });
}, Lr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.chevronLeft) == null ? void 0 : e.icon) || $r,
    css: Go.icon(t, Ho.CHEVRON_LEFT),
    ...o
  });
}, _r = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.chevronRight) == null ? void 0 : e.icon) || vr,
    css: Go.icon(t, Ho.CHEVRON_RIGHT),
    ...o
  });
}, Vr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.cross) == null ? void 0 : e.icon) || Ir,
    css: Go.icon(t, Ho.CROSS),
    ...o
  });
}, jr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.error) == null ? void 0 : e.icon) || kr,
    css: Go.icon(t, Ho.ERROR),
    ...o
  });
}, Hr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.minus) == null ? void 0 : e.icon) || Rr,
    css: Go.icon(t, Ho.MINUS),
    ...o
  });
}, Gr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.plus) == null ? void 0 : e.icon) || Tr,
    css: Go.icon(t, Ho.PLUS),
    ...o
  });
}, Kr = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.questionmark) == null ? void 0 : e.icon) || zr,
    css: Go.icon(t, Ho.QUESTIONMARK),
    ...o
  });
}, Ur = ({ ...o }) => {
  var n, r, e;
  const t = Io();
  return /* @__PURE__ */ M(zo, {
    instance: ((e = (r = (n = t.component) == null ? void 0 : n.Icon) == null ? void 0 : r.info) == null ? void 0 : e.icon) || Nr,
    css: Go.icon(t, Ho.INFO),
    ...o
  });
}, Gt = {
  ArrowLeft: Er,
  ArrowRight: Wr,
  ArrowUp: Br,
  ArrowDown: Mr,
  ChevronDown: Pr,
  ChevronLeft: Lr,
  ChevronRight: _r,
  ChevronUp: Or,
  Cross: Vr,
  Error: jr,
  Minus: Hr,
  Plus: Gr,
  Questionmark: Kr,
  Info: Ur
}, Zr = /* @__PURE__ */ eo("div", {
  target: "et97ugo0"
})("all:revert;position:relative;"), _t = /* @__PURE__ */ eo("div", {
  target: "et97ugo1"
})("all:revert;box-sizing:border-box;position:absolute;display:flex;align-items:center;pointer-events:none;", ({ theme: o }) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo;
  return `
        top: ${((r = (n = (t = o.component) == null ? void 0 : t.InputField) == null ? void 0 : n.suffix) == null ? void 0 : r.offset) ?? 0};
        bottom: ${((a = (i = (e = o.component) == null ? void 0 : e.InputField) == null ? void 0 : i.suffix) == null ? void 0 : a.offset) ?? 0};
        right: ${((p = (l = (c = o.component) == null ? void 0 : c.InputField) == null ? void 0 : l.suffix) == null ? void 0 : p.offset) ?? 0};
        padding: ${((b = (u = (d = o.component) == null ? void 0 : d.InputField) == null ? void 0 : u.suffix) == null ? void 0 : b.padding) ?? ((m = (g = o.component) == null ? void 0 : g.InputField) == null ? void 0 : m.padding) ?? ((y = o.formInput) == null ? void 0 : y.padding) ?? o.spacing(3, 4)};
        font-family: ${o.typography.font[((w = (h = (S = o.component) == null ? void 0 : S.InputField) == null ? void 0 : h.suffix) == null ? void 0 : w.fontFamily) ?? ((I = (v = o.component) == null ? void 0 : v.InputField) == null ? void 0 : I.fontFamily) ?? ((C = o.formInput) == null ? void 0 : C.fontFamily) ?? "primary"]};
        font-weight: ${((A = (T = (x = o.component) == null ? void 0 : x.InputField) == null ? void 0 : T.suffix) == null ? void 0 : A.fontWeight) ?? ((P = (O = o.component) == null ? void 0 : O.InputField) == null ? void 0 : P.fontWeight) ?? ((B = o.formInput) == null ? void 0 : B.fontWeight) ?? "normal"};
        font-size: ${((D = (_ = (N = o.component) == null ? void 0 : N.InputField) == null ? void 0 : _.suffix) == null ? void 0 : D.fontSize) ?? o.typography.size[((j = (R = o.component) == null ? void 0 : R.InputField) == null ? void 0 : j.fontSize) ?? ((V = o.formInput) == null ? void 0 : V.fontSize) ?? "md"]};
        line-height: ${((F = (J = (Z = o.component) == null ? void 0 : Z.InputField) == null ? void 0 : J.suffix) == null ? void 0 : F.lineHeight) ?? ((H = (L = o.component) == null ? void 0 : L.InputField) == null ? void 0 : H.lineHeight) ?? ((E = o.formInput) == null ? void 0 : E.lineHeight) ?? "inherit"};
        text-transform: ${((K = (so = (to = o.component) == null ? void 0 : to.InputField) == null ? void 0 : so.suffix) == null ? void 0 : K.textTransform) ?? ((q = (X = o.component) == null ? void 0 : X.InputField) == null ? void 0 : q.textTransform) ?? ((ro = o.formInput) == null ? void 0 : ro.textTransform) ?? "none"};
        color: ${((ao = (io = (no = o.component) == null ? void 0 : no.InputField) == null ? void 0 : io.suffix) == null ? void 0 : ao.color) ?? ((W = (z = o.component) == null ? void 0 : z.InputField) == null ? void 0 : W.color) ?? ((G = o.formInput) == null ? void 0 : G.color) ?? "inherit"};
        background: ${((oo = (Q = (Y = o.component) == null ? void 0 : Y.InputField) == null ? void 0 : Q.suffix) == null ? void 0 : oo.background) ?? ((po = (co = o.component) == null ? void 0 : co.InputField) == null ? void 0 : po.background) ?? ((uo = o.formInput) == null ? void 0 : uo.background) ?? "transparent"};
    `;
}), Ie = (o, t) => t ? `
        ~${_t} {
            ${t.padding != null ? `padding: ${t.padding};` : ""}
            ${t.fontFamily ? `font-family: ${o.typography.font[t.fontFamily]};` : ""}
            ${t.fontWeight ? `font-weight: ${t.fontWeight};` : ""};
            ${t.fontSize ? `font-size: ${o.typography.size[t.fontSize]};` : ""}
            ${t.lineHeight != null ? `line-height: ${t.lineHeight};` : "100%;"}
            ${t.textTransform ? `text-transform: ${t.textTransform};` : ""}
            ${t.color ? `color: ${t.color};` : ""}
            ${t.background ? `background: ${t.background};` : ""}
            ${t.boxShadow != null ? `box-shadow: ${t.boxShadow};` : ""}
            ${t.transition ? `transition: ${t.transition};` : ""}
            ${t.transitionProperty ? `transition-property: ${t.transitionProperty};` : ""}
        }

        ${_o({
  focusStyle: t.focusStyle,
  focusVisibleStyle: t.focusVisibleStyle,
  appendToSelector: `~${_t}`
})}
        ${Fo(t.hoverStyle, void 0, `~${_t}`)}
        ${Yo(t.activeStyle, void 0, `~${_t}`)}
        ${Xo(t.disabledStyle, void 0, `~${_t}`)}
        ${it(t.invalidStyle, void 0, `~${_t}`)}
    ` : "", qr = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo, Ro, To, Ao, Do;
  return /* @__PURE__ */ k("all:revert;box-sizing:border-box;appearance:none;width:100%;margin:0;padding:", ((n = (t = o.component) == null ? void 0 : t.InputField) == null ? void 0 : n.padding) ?? ((r = o.formInput) == null ? void 0 : r.padding) ?? o.spacing(3, 4), ";font-family:", o.typography.font[((i = (e = o.component) == null ? void 0 : e.InputField) == null ? void 0 : i.fontFamily) || ((a = o.formInput) == null ? void 0 : a.fontFamily) || "primary"], ";font-weight:", ((l = (c = o.component) == null ? void 0 : c.InputField) == null ? void 0 : l.fontWeight) || ((p = o.formInput) == null ? void 0 : p.fontWeight) || "normal", ";font-size:", o.typography.size[((u = (d = o.component) == null ? void 0 : d.InputField) == null ? void 0 : u.fontSize) || ((b = o.formInput) == null ? void 0 : b.fontSize) || "md"], ";line-height:", ((m = (g = o.component) == null ? void 0 : g.InputField) == null ? void 0 : m.lineHeight) ?? ((y = o.formInput) == null ? void 0 : y.lineHeight) ?? "inherit", ";text-transform:", ((h = (S = o.component) == null ? void 0 : S.InputField) == null ? void 0 : h.textTransform) || ((w = o.formInput) == null ? void 0 : w.textTransform) || "none", ";color:", ((I = (v = o.component) == null ? void 0 : v.InputField) == null ? void 0 : I.color) || ((C = o.formInput) == null ? void 0 : C.color) || "inherit", ";background:", ((T = (x = o.component) == null ? void 0 : x.InputField) == null ? void 0 : T.background) ?? ((A = o.formInput) == null ? void 0 : A.background) ?? "#fff", ";border:", ((P = (O = o.component) == null ? void 0 : O.InputField) == null ? void 0 : P.border) ?? ((B = o.formInput) == null ? void 0 : B.border) ?? "none", ";", ((_ = (N = o.component) == null ? void 0 : N.InputField) == null ? void 0 : _.borderBottom) != null || ((D = o.formInput) == null ? void 0 : D.borderBottom) != null ? `border-bottom: ${((j = (R = o.component) == null ? void 0 : R.InputField) == null ? void 0 : j.borderBottom) ?? ((V = o.formInput) == null ? void 0 : V.borderBottom)}` : "", ";border-radius:", ((J = (Z = o.component) == null ? void 0 : Z.InputField) == null ? void 0 : J.borderRadius) ?? ((F = o.formInput) == null ? void 0 : F.borderRadius) ?? 0, ";box-shadow:", ((H = (L = o.component) == null ? void 0 : L.InputField) == null ? void 0 : H.boxShadow) ?? ((E = o.formInput) == null ? void 0 : E.boxShadow) ?? "none", ";transition:", ((so = (to = o.component) == null ? void 0 : to.InputField) == null ? void 0 : so.transition) ?? ((K = o.formInput) == null ? void 0 : K.transition) ?? "none", ";", (q = (X = o.component) == null ? void 0 : X.InputField) != null && q.transitionProperty || (ro = o.formInput) != null && ro.transitionProperty ? `transition-property: ${((io = (no = o.component) == null ? void 0 : no.InputField) == null ? void 0 : io.transitionProperty) ?? ((ao = o.formInput) == null ? void 0 : ao.transitionProperty)};` : "", " ", jt({
    focusStyle: ((W = (z = o.component) == null ? void 0 : z.InputField) == null ? void 0 : W.focusStyle) ?? ((G = o.formInput) == null ? void 0 : G.focusStyle),
    focusVisibleStyle: ((Q = (Y = o.component) == null ? void 0 : Y.InputField) == null ? void 0 : Q.focusVisibleStyle) ?? ((oo = o.formInput) == null ? void 0 : oo.focusVisibleStyle)
  }), " ", Fo(((po = (co = o.component) == null ? void 0 : co.InputField) == null ? void 0 : po.hoverStyle) ?? ((uo = o.formInput) == null ? void 0 : uo.hoverStyle)), " ", Xo(((bo = (fo = o.component) == null ? void 0 : fo.InputField) == null ? void 0 : bo.disabledStyle) ?? ((So = o.formInput) == null ? void 0 : So.disabledStyle)), " ", it(((Ro = (vo = o.component) == null ? void 0 : vo.InputField) == null ? void 0 : Ro.invalidStyle) ?? ((To = o.formInput) == null ? void 0 : To.invalidStyle)), " ", Ie(o, (Do = (Ao = o.component) == null ? void 0 : Ao.InputField) == null ? void 0 : Do.suffix));
}, xe = (o, t) => `
    ${(t == null ? void 0 : t.padding) != null ? `padding: ${t.padding};` : ""}
    ${t != null && t.fontFamily ? `font-family: ${o.typography.font[t.fontFamily]};` : ""}
    ${t != null && t.fontWeight ? `font-weight: ${t.fontWeight};` : ""};
    ${t != null && t.fontSize ? `font-size: ${o.typography.size[t.fontSize]};` : ""}
    ${(t == null ? void 0 : t.lineHeight) != null ? `line-height: ${t.lineHeight};` : "100%;"}
    ${t != null && t.textTransform ? `text-transform: ${t.textTransform};` : ""}
    ${t != null && t.color ? `color: ${t.color};` : ""}
    ${t != null && t.background ? `background: ${t.background};` : ""}
    ${(t == null ? void 0 : t.border) != null ? `border: ${t.border};` : ""}
    ${(t == null ? void 0 : t.borderBottom) != null ? `border-bottom: ${t.borderBottom};` : ""};
    ${(t == null ? void 0 : t.borderRadius) != null ? `border-radius: ${t.borderRadius};` : ""}
    ${(t == null ? void 0 : t.boxShadow) != null ? `box-shadow: ${t.boxShadow};` : ""}
    ${t != null && t.transition ? `transition: ${t.transition};` : ""}
    ${t != null && t.transitionProperty ? `transition-property: ${t.transitionProperty};` : ""}

    ${_o({
  focusStyle: t == null ? void 0 : t.focusStyle,
  focusVisibleStyle: t == null ? void 0 : t.focusVisibleStyle
})}
    ${Fo(t == null ? void 0 : t.hoverStyle)}
    ${Yo(t == null ? void 0 : t.activeStyle)}
    ${Xo(t == null ? void 0 : t.disabledStyle)}
    ${it(t == null ? void 0 : t.invalidStyle)}
    ${Ie(o, t == null ? void 0 : t.suffix)}
`, Yr = (o) => {
  var t, n;
  return /* @__PURE__ */ k(xe(o, (n = (t = o.component) == null ? void 0 : t.InputField) == null ? void 0 : n.primary));
}, Qr = (o) => {
  var t, n;
  return /* @__PURE__ */ k(xe(o, (n = (t = o.component) == null ? void 0 : t.InputField) == null ? void 0 : n.secondary));
}, Jr = (o) => {
  var t, n, r;
  return /* @__PURE__ */ k("padding-right:", ((r = (n = (t = o.component) == null ? void 0 : t.InputField) == null ? void 0 : n.inputFieldWithSuffix) == null ? void 0 : r.paddingRight) ?? o.spacing(10), ";");
}, Xr = /* @__PURE__ */ k("appearance:none;-moz-appearance:textfield;::-webkit-inner-spin-button,::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}"), en = {
  inputField: qr,
  inputFieldPrimary: Yr,
  inputFieldSecondary: Qr,
  inputFieldWithSuffix: Jr,
  inputFieldNumber: Xr
}, qn = {
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Xn = /* @__PURE__ */ $o.forwardRef(({ variant: o = qn.PRIMARY, type: t = "text", suffix: n, suffixAriaLabel: r, hasError: e = !1, errorMessageElementId: i, ...a }, c) => {
  const l = [
    en.inputField,
    o === qn.PRIMARY && en.inputFieldPrimary,
    o === qn.SECONDARY && en.inputFieldSecondary,
    t === "number" && en.inputFieldNumber,
    n && en.inputFieldWithSuffix
  ].filter(Boolean), p = _n(), d = [
    e ? i : void 0,
    n ? p : void 0,
    a["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, u = /* @__PURE__ */ M("input", {
    type: t,
    css: l,
    ref: c,
    "aria-invalid": e,
    "aria-errormessage": e ? i : void 0,
    "aria-describedby": d,
    ...a
  });
  return n ? /* @__PURE__ */ wo(Zr, {
    children: [
      u,
      /* @__PURE__ */ M(_t, {
        id: p,
        "aria-label": r,
        children: n
      })
    ]
  }) : u;
}), oi = /* @__PURE__ */ eo("label", {
  target: "e1alpy1d0"
})(({ theme: o, variant: t = Oo.PRIMARY }) => {
  var e, i, a, c, l, p, d, u, b;
  const n = (i = (e = o.component) == null ? void 0 : e.Label) == null ? void 0 : i[t], r = {
    ...No((a = o.component) == null ? void 0 : a.Label, [
      Oo.PRIMARY,
      Oo.SECONDARY,
      Oo.TERTIARY,
      Oo.QUATERNARY
    ]),
    ...No(n),
    desktop: {
      ...(l = (c = o.component) == null ? void 0 : c.Label) == null ? void 0 : l.desktop,
      ...n == null ? void 0 : n.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    display: r.display || "inline-block",
    margin: 0,
    padding: r.padding ?? 0,
    background: r.background || "none",
    border: r.border || "none",
    borderRadius: r.borderRadius || 0,
    boxShadow: r.boxShadow || "none",
    fontFamily: o.typography.font[r.fontFamily || "primary"],
    fontSize: o.typography.size[r.fontSize || "md"],
    fontWeight: r.fontWeight || "normal",
    lineHeight: r.lineHeight || "inherit",
    letterSpacing: r.letterSpacing || "normal",
    textTransform: r.textTransform || "none",
    color: r.color || "inherit",
    cursor: r.cursor || "default"
  }).styles}

        ${Fo(r.hoverStyle)}
        ${mt(r.focusWithinStyle)}

        // Webkit browsers tend to add a background color on mobile when tapping a link or similar, this removes it.
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${k({
      ...No(r.desktop, [
        "hoverStyle",
        "focusWithinStyle"
      ]),
      fontFamily: (p = r.desktop) != null && p.fontFamily ? o.typography.font[r.desktop.fontFamily] : void 0,
      fontSize: (d = r.desktop) != null && d.fontSize ? o.typography.size[r.desktop.fontSize] : void 0
    }).styles}

                ${Fo((u = r.desktop) == null ? void 0 : u.hoverStyle)}
                ${mt((b = r.desktop) == null ? void 0 : b.focusWithinStyle)}
            `
  })}
    `;
}), ti = {
  ...Oo,
  QUINARY: "quinary"
}, ke = /* @__PURE__ */ eo("legend", {
  target: "eklmtfu0"
})(({ variant: o = ti.PRIMARY, theme: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m;
  const n = {
    ...((r = t.component) == null ? void 0 : r.Legend) || {},
    ...((a = (i = (e = t.component) == null ? void 0 : e.Legend) == null ? void 0 : i.variant) == null ? void 0 : a[o]) || {},
    desktop: {
      ...((l = (c = t.component) == null ? void 0 : c.Legend) == null ? void 0 : l.desktop) || {},
      ...((b = (u = (d = (p = t.component) == null ? void 0 : p.Legend) == null ? void 0 : d.variant) == null ? void 0 : u[o]) == null ? void 0 : b.desktop) || {}
    }
  };
  return `
        all: revert;
        box-sizing: border-box;
        display: ${n.display || "block"};
        ${n.justifyContent ? `justify-content: ${n.justifyContent};` : ""}
        ${n.alignItems ? `align-items: ${n.alignItems};` : ""}
        margin: ${n.margin ?? 0};
        padding: ${n.padding ?? 0};
        font-family: ${t.typography.font[n.fontFamily || "primary"]};
        font-weight: ${n.fontWeight || "normal"};
        font-size: ${t.typography.size[n.fontSize || "md"]};
        line-height: ${n.lineHeight ?? 1};
        color: ${n.color || t.typography.color.primary};
        text-align: ${n.textAlign || "left"};
        text-transform: ${n.textTransform || "none"};

        ${t.mq({
    theme: t,
    min: lo.DESKTOP,
    css: k({
      ...n.desktop,
      fontFamily: (g = n.desktop) != null && g.fontFamily ? t.typography.font[n.desktop.fontFamily] : void 0,
      fontSize: (m = n.desktop) != null && m.fontSize ? t.typography.size[n.desktop.fontSize] : void 0
    }).styles
  })}
    `;
}), ce = ({ display: o, width: t, maxWidth: n, padding: r, fontFamily: e, fontWeight: i, fontSize: a, textAlign: c, color: l, textDecoration: p, transition: d, hoverStyle: u, focusStyle: b, focusVisibleStyle: g }, m) => `
    ${o ? `display: ${o};` : ""}
    ${t != null ? `width: ${t};` : ""}
    ${n != null ? `max-width: ${n};` : ""}
    ${r != null ? `padding: ${r};` : ""}
    ${e ? `font-family: ${m.typography.font[e]};` : ""}
    ${i != null ? `font-weight: ${i};` : ""}
    ${a ? `font-size: ${m.typography.size[a]};` : ""}
    ${c ? `text-align: ${c};` : ""}
    ${l ? `color: ${l};` : ""}
    ${p ? `text-decoration: ${p};` : ""};
    ${d ? `transition: ${d};` : ""}
    ${Fo(u)}
    ${_o({
  focusStyle: b,
  focusVisibleStyle: g
})}
`, ni = (o) => {
  var t, n, r, e, i;
  return /* @__PURE__ */ k("all:revert;cursor:", ((n = (t = o.component) == null ? void 0 : t.Link) == null ? void 0 : n.cursor) ?? "pointer", ";margin:0;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;", ce(((r = o.component) == null ? void 0 : r.Link) ?? {}, o), " ", (i = (e = o.component) == null ? void 0 : e.Link) != null && i.desktop ? o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: ce(o.component.Link.desktop, o)
  }) : "");
}, ei = (o) => {
  var t, n, r, e, i, a, c, l;
  return /* @__PURE__ */ k("display:grid;grid-auto-flow:column;gap:", ((e = (r = (n = (t = o.component) == null ? void 0 : t.Link) == null ? void 0 : n.variant) == null ? void 0 : r.withIcon) == null ? void 0 : e.gap) ?? o.spacing(2), ";justify-content:start;align-items:center;", (l = (c = (a = (i = o.component) == null ? void 0 : i.Link) == null ? void 0 : a.variant) == null ? void 0 : c.withIcon) != null && l.desktop ? `
                ${o.component.Link.variant.withIcon.desktop.gap != null ? `gap: ${o.component.Link.variant.withIcon.desktop.gap};` : ""}
            ` : "");
}, le = {
  link: ni,
  linkWithIcon: ei
}, ri = /* @__PURE__ */ $o.forwardRef(({ href: o, icon: t, children: n, ...r }, e) => {
  const i = [
    le.link,
    typeof t < "u" && le.linkWithIcon
  ].filter(Boolean);
  return /* @__PURE__ */ wo("a", {
    href: o,
    css: i,
    ref: e,
    ...r,
    children: [
      n,
      t
    ]
  });
}), Pa = /* @__PURE__ */ eo("span", {
  target: "e1enz3sj0"
})({
  all: "revert",
  boxSizing: "border-box",
  display: "inline-block",
  margin: 0,
  padding: 0,
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  color: "inherit",
  lineHeight: "inherit",
  whiteSpace: "inherit",
  letterSpacing: "inherit"
}), ii = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A;
  return /* @__PURE__ */ k("all:revert;font-family:", (n = (t = o.component) == null ? void 0 : t.Option) != null && n.fontFamily || (r = o.formInput) != null && r.fontFamily ? o.typography.font[
    // At least one property is available but TS don't get that, therefore add "!".
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
    ((i = (e = o.component) == null ? void 0 : e.Option) == null ? void 0 : i.fontFamily) || ((a = o.formInput) == null ? void 0 : a.fontFamily)
  ] : "inherit", ";font-size:", (l = (c = o.component) == null ? void 0 : c.Option) != null && l.fontSize || (p = o.formInput) != null && p.fontSize ? o.typography.size[
    // At least one property is available but TS don't get that, therefore add "!".
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
    ((u = (d = o.component) == null ? void 0 : d.Option) == null ? void 0 : u.fontSize) || ((b = o.formInput) == null ? void 0 : b.fontSize)
  ] : "inherit", ";font-weight:", ((m = (g = o.component) == null ? void 0 : g.Option) == null ? void 0 : m.fontWeight) || ((y = o.formInput) == null ? void 0 : y.fontWeight) || "inherit", ";text-transform:", ((h = (S = o.component) == null ? void 0 : S.Option) == null ? void 0 : h.textTransform) || ((w = o.formInput) == null ? void 0 : w.textTransform) || "none", ";color:", ((I = (v = o.component) == null ? void 0 : v.Option) == null ? void 0 : I.color) || ((C = o.formInput) == null ? void 0 : C.color) || "inherit", ";", Xo(((T = (x = o.component) == null ? void 0 : x.Option) == null ? void 0 : T.disabledStyle) || ((A = o.formInput) == null ? void 0 : A.disabledStyle)));
}, ai = {
  option: ii
}, si = ({ value: o, label: t = "", children: n, ...r }) => /* @__PURE__ */ M("option", {
  value: o,
  css: ai.option,
  ...r,
  children: n ?? t
}), ci = /* @__PURE__ */ eo("p", {
  target: "e1x1gvnf0"
})(({ noBottomMargin: o, noBottomMarginOnLast: t, theme: n }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S;
  return `
        all: revert;
        box-sizing: border-box;
        margin: ${((e = (r = n.component) == null ? void 0 : r.Paragraph) == null ? void 0 : e.margin) ?? n.spacing(0, 0, 3, 0)};
        ${o ? "margin-bottom: 0;" : ""}
        font-family: ${n.typography.font[((a = (i = n.component) == null ? void 0 : i.Paragraph) == null ? void 0 : a.fontFamily) ?? "primary"]};
        font-size: ${n.typography.size[((l = (c = n.component) == null ? void 0 : c.Paragraph) == null ? void 0 : l.fontSize) ?? "md"]};
        font-weight: ${((d = (p = n.component) == null ? void 0 : p.Paragraph) == null ? void 0 : d.fontWeight) ?? "normal"};
        line-height: ${((b = (u = n.component) == null ? void 0 : u.Paragraph) == null ? void 0 : b.lineHeight) ?? "inherit"};
        ${((m = (g = n.component) == null ? void 0 : g.Paragraph) == null ? void 0 : m.letterSpacing) != null ? `letter-spacing: ${n.component.Paragraph.letterSpacing};` : ""}
        color: ${((S = (y = n.component) == null ? void 0 : y.Paragraph) == null ? void 0 : S.color) ?? "inherit"};

        ${t ? `
                    &:last-child {
                        margin-bottom: 0;
                    }
                ` : ""}
    `;
}), li = /* @__PURE__ */ $o.forwardRef(({ noBottomMargin: o = !1, noBottomMarginOnLast: t = !1, children: n, ...r }, e) => /* @__PURE__ */ M(ci, {
  noBottomMargin: o,
  noBottomMarginOnLast: t,
  ref: e,
  ...r,
  children: n
})), pi = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q;
  return /* @__PURE__ */ k("all:revert;appearance:none;display:", ((n = (t = o.component) == null ? void 0 : t.RadioButton) == null ? void 0 : n.display) ?? "inline-flex", ";", (e = (r = o.component) == null ? void 0 : r.RadioButton) != null && e.position ? `position: ${o.component.RadioButton.position};` : "", "  box-sizing:border-box;width:", ((a = (i = o.component) == null ? void 0 : i.RadioButton) == null ? void 0 : a.width) ?? "15px", ";height:", ((l = (c = o.component) == null ? void 0 : c.RadioButton) == null ? void 0 : l.height) ?? "15px", ";margin:0;padding:", ((d = (p = o.component) == null ? void 0 : p.RadioButton) == null ? void 0 : d.padding) ?? 0, ";background:", ((b = (u = o.component) == null ? void 0 : u.RadioButton) == null ? void 0 : b.background) ?? ((g = o.formInput) == null ? void 0 : g.background) ?? "#fff", ";border:", ((y = (m = o.component) == null ? void 0 : m.RadioButton) == null ? void 0 : y.border) ?? ((S = o.formInput) == null ? void 0 : S.background) ?? "1px solid #000", ";border-radius:", ((w = (h = o.component) == null ? void 0 : h.RadioButton) == null ? void 0 : w.borderRadius) ?? "50%", ";box-shadow:", ((I = (v = o.component) == null ? void 0 : v.RadioButton) == null ? void 0 : I.boxShadow) || ((C = o.formInput) == null ? void 0 : C.boxShadow) || "none", ";cursor:", ((T = (x = o.component) == null ? void 0 : x.RadioButton) == null ? void 0 : T.cursor) ?? "pointer", ";transition:", ((O = (A = o.component) == null ? void 0 : A.RadioButton) == null ? void 0 : O.transition) || ((P = o.formInput) == null ? void 0 : P.transition) || "none", ";", (N = (B = o.component) == null ? void 0 : B.RadioButton) != null && N.transitionProperty || (_ = o.formInput) != null && _.transitionProperty ? `transition-property: ${((R = (D = o.component) == null ? void 0 : D.RadioButton) == null ? void 0 : R.transitionProperty) || ((j = o.formInput) == null ? void 0 : j.transitionProperty)};` : "", " ", we((Z = (V = o.component) == null ? void 0 : V.RadioButton) == null ? void 0 : Z.beforeElementStyle), " ", ve((F = (J = o.component) == null ? void 0 : J.RadioButton) == null ? void 0 : F.afterElementStyle), " ", Fo(((H = (L = o.component) == null ? void 0 : L.RadioButton) == null ? void 0 : H.hoverStyle) || ((E = o.formInput) == null ? void 0 : E.hoverStyle)), " ", _o({
    focusStyle: ((so = (to = o.component) == null ? void 0 : to.RadioButton) == null ? void 0 : so.focusStyle) || ((K = o.formInput) == null ? void 0 : K.focusStyle),
    focusVisibleStyle: ((q = (X = o.component) == null ? void 0 : X.RadioButton) == null ? void 0 : q.focusVisibleStyle) || ((ro = o.formInput) == null ? void 0 : ro.focusVisibleStyle)
  }), " ", Yo(((io = (no = o.component) == null ? void 0 : no.RadioButton) == null ? void 0 : io.activeStyle) || ((ao = o.formInput) == null ? void 0 : ao.activeStyle)), " ", Xo(((W = (z = o.component) == null ? void 0 : z.RadioButton) == null ? void 0 : W.disabledStyle) || ((G = o.formInput) == null ? void 0 : G.disabledStyle)), " ", Ln(((Q = (Y = o.component) == null ? void 0 : Y.RadioButton) == null ? void 0 : Q.checkedStyle) ?? "background: radial-gradient(#000 45%, #fff 52%) no-repeat center center;"));
}, di = {
  radioButton: pi
}, ui = /* @__PURE__ */ $o.forwardRef(({ ...o }, t) => /* @__PURE__ */ M("input", {
  type: "radio",
  css: di.radioButton,
  ref: t,
  ...o
})), gt = {
  thumbWidth: "10px",
  thumbHeight: "10px",
  trackHeight: "5px"
}, Yt = (o, t, n) => {
  var c, l, p, d, u, b;
  function r() {
    var g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So;
    switch (o) {
      case "hover":
        return {
          base: (m = (g = t.component) == null ? void 0 : g.Slider) == null ? void 0 : m.hoverStyle,
          track: (h = (S = (y = t.component) == null ? void 0 : y.Slider) == null ? void 0 : S.track) == null ? void 0 : h.hover,
          thumb: (I = (v = (w = t.component) == null ? void 0 : w.Slider) == null ? void 0 : v.thumb) == null ? void 0 : I.hoverStyle
        };
      case "focus":
        return {
          base: (x = (C = t.component) == null ? void 0 : C.Slider) == null ? void 0 : x.focusStyle,
          track: (O = (A = (T = t.component) == null ? void 0 : T.Slider) == null ? void 0 : A.track) == null ? void 0 : O.focus,
          thumb: (N = (B = (P = t.component) == null ? void 0 : P.Slider) == null ? void 0 : B.thumb) == null ? void 0 : N.focusStyle
        };
      case "focusVisible":
        return {
          base: (D = (_ = t.component) == null ? void 0 : _.Slider) == null ? void 0 : D.focusVisibleStyle,
          track: (V = (j = (R = t.component) == null ? void 0 : R.Slider) == null ? void 0 : j.track) == null ? void 0 : V.focusVisible,
          thumb: (F = (J = (Z = t.component) == null ? void 0 : Z.Slider) == null ? void 0 : J.thumb) == null ? void 0 : F.focusVisibleStyle
        };
      case "active":
        return {
          base: (H = (L = t.component) == null ? void 0 : L.Slider) == null ? void 0 : H.activeStyle,
          track: (so = (to = (E = t.component) == null ? void 0 : E.Slider) == null ? void 0 : to.track) == null ? void 0 : so.active,
          thumb: (q = (X = (K = t.component) == null ? void 0 : K.Slider) == null ? void 0 : X.thumb) == null ? void 0 : q.activeStyle
        };
      case "disabled":
        return {
          base: (no = (ro = t.component) == null ? void 0 : ro.Slider) == null ? void 0 : no.disabledStyle,
          track: (z = (ao = (io = t.component) == null ? void 0 : io.Slider) == null ? void 0 : ao.track) == null ? void 0 : z.disabled,
          thumb: (Y = (G = (W = t.component) == null ? void 0 : W.Slider) == null ? void 0 : G.thumb) == null ? void 0 : Y.disabledStyle
        };
      case "invalid":
        return {
          base: (oo = (Q = t.component) == null ? void 0 : Q.Slider) == null ? void 0 : oo.invalidStyle,
          track: (uo = (po = (co = t.component) == null ? void 0 : co.Slider) == null ? void 0 : po.track) == null ? void 0 : uo.invalid,
          thumb: (So = (bo = (fo = t.component) == null ? void 0 : fo.Slider) == null ? void 0 : bo.thumb) == null ? void 0 : So.invalidStyle
        };
      default:
        return {
          base: void 0,
          track: void 0,
          thumb: void 0
        };
    }
  }
  const { base: e, track: i, thumb: a } = r();
  return `
        ${e || "outline: none;"}

        ${i ? `
                    ::-webkit-slider-runnable-track {
                        ${i.backgroundColor || i.backgroundColorRightOfThumb ? `
                                    background: linear-gradient(
                                        to right,
                                        ${i.backgroundColor ?? ((p = (l = (c = t.component) == null ? void 0 : c.Slider) == null ? void 0 : l.track) == null ? void 0 : p.backgroundColor) ?? "#000"} ${n},
                                        ${i.backgroundColorRightOfThumb ?? ((b = (u = (d = t.component) == null ? void 0 : d.Slider) == null ? void 0 : u.track) == null ? void 0 : b.backgroundColorRightOfThumb) ?? i.backgroundColor ?? "#000"} ${n}
                                    );
                                ` : ""}
                        ${i.border != null ? `border: ${i.border};` : ""}
                        ${i.borderRadius != null ? `border-radius: ${i.borderRadius};` : ""}
                        ${i.boxShadow ? `box-shadow: ${i.boxShadow};` : ""}
                        outline: ${i.outline ?? "none"};
                    }

                    ::-moz-range-track {
                        ${i.backgroundColorRightOfThumb ? `background: ${i.backgroundColorRightOfThumb};` : ""}
                        ${i.border != null ? `border: ${i.border};` : ""}
                        ${i.borderRadius != null ? `
                                    border-top-right-radius: ${i.borderRadius};
                                    border-bottom-right-radius: ${i.borderRadius};
                                ` : ""}
                        ${i.boxShadow ? `box-shadow: ${i.boxShadow};` : ""}
                        outline: ${i.outline ?? "none"};
                    }
                            
                    ::-moz-range-progress {
                        ${i.backgroundColor ? `background: ${i.backgroundColor};` : ""}
                        ${i.border != null ? `border: ${i.border};` : ""}
                        ${i.borderRadius != null ? `
                                    border-top-left-radius: ${i.borderRadius};
                                    border-bottom-left-radius: ${i.borderRadius};
                                ` : ""}
                        ${i.boxShadow ? `box-shadow: ${i.boxShadow};` : ""}
                        outline: ${i.outline ?? "none"};
                    }
                ` : ""}

        ::-webkit-slider-thumb {
            ${a ?? "outline: none;"}
        }
        
        ::-moz-range-thumb {
            ${a ?? "outline: none;"}
        }
    `;
}, fi = /* @__PURE__ */ eo("div", {
  target: "e1qyobim0"
})(({ theme: o }) => {
  var t, n, r, e, i, a, c, l, p;
  return {
    display: ((r = (n = (t = o.component) == null ? void 0 : t.Slider) == null ? void 0 : n.wrapper) == null ? void 0 : r.display) ?? "flex",
    alignItems: ((a = (i = (e = o.component) == null ? void 0 : e.Slider) == null ? void 0 : i.wrapper) == null ? void 0 : a.alignItems) ?? "center",
    gap: ((p = (l = (c = o.component) == null ? void 0 : c.Slider) == null ? void 0 : l.wrapper) == null ? void 0 : p.gap) ?? o.spacing(2)
  };
}), pe = /* @__PURE__ */ eo("label", {
  target: "e1qyobim1"
})(({ theme: o }) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C;
  return {
    textAlign: ((r = (n = (t = o.component) == null ? void 0 : t.Slider) == null ? void 0 : n.labels) == null ? void 0 : r.textAlign) ?? "center",
    fontFamily: o.typography.font[((a = (i = (e = o.component) == null ? void 0 : e.Slider) == null ? void 0 : i.labels) == null ? void 0 : a.fontFamily) || "primary"],
    fontSize: o.typography.size[((p = (l = (c = o.component) == null ? void 0 : c.Slider) == null ? void 0 : l.labels) == null ? void 0 : p.fontSize) || "md"],
    color: ((b = (u = (d = o.component) == null ? void 0 : d.Slider) == null ? void 0 : u.labels) == null ? void 0 : b.color) || o.typography.color.primary,
    fontWeight: ((y = (m = (g = o.component) == null ? void 0 : g.Slider) == null ? void 0 : m.labels) == null ? void 0 : y.fontWeight) ?? "normal",
    margin: ((w = (h = (S = o.component) == null ? void 0 : S.Slider) == null ? void 0 : h.labels) == null ? void 0 : w.margin) ?? 0,
    padding: ((C = (I = (v = o.component) == null ? void 0 : v.Slider) == null ? void 0 : I.labels) == null ? void 0 : C.padding) ?? 0
  };
}), gi = /* @__PURE__ */ eo("input", {
  target: "e1qyobim2"
})(({ thumbPosition: o, theme: t }) => {
  var n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo, Ro, To, Ao, Do, Vo, ot, tt, at, st, Wo, Ko, ct, nt, lt, et, jo, pt, Bo, dt, ut, $t, ht, vt, Lo, wt, It, xt, kt, Ct, Qo, Rt, At, Tt, Ft, zt, Jo, Dt, Nt, Et, Wt, Bt, dn, Kt, un, Mt, Ut, fn, Ot, Qt, gn, bn, mn, Jt, yn, Sn, $n, hn, vn, wn, In, xn, kn, Cn, Pt, Zt, Rn, An, Xt, Tn, Fn, zn, on, Dn, Nn, En, qt, Wn;
  return `
        all: revert;
        appearance: none;
        box-sizing: border-box;
        width: 100%;
        height: ${((r = (n = t.component) == null ? void 0 : n.Slider) == null ? void 0 : r.height) ?? ((a = (i = (e = t.component) == null ? void 0 : e.Slider) == null ? void 0 : i.thumb) == null ? void 0 : a.height) ?? gt.thumbHeight};
        margin: 0;
        padding: 0; // Note: Browsers calculate padding differently, use height instead (height = thumb height + desired padding)
        background: ${((l = (c = t.component) == null ? void 0 : c.Slider) == null ? void 0 : l.background) ?? "transparent"};
        cursor: ${((d = (p = t.component) == null ? void 0 : p.Slider) == null ? void 0 : d.cursor) ?? "pointer"};
        ${(b = (u = t.component) == null ? void 0 : u.Slider) != null && b.transition ? `transition: ${t.component.Slider.transition};` : ""}

        // Webkit browsers tend to add a background color on mobile when tapping a link or similar, this removes it.
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;
    
        ::-webkit-slider-runnable-track {
            -webkit-appearance: none;
            box-sizing: border-box;
            width: 100%;
            height: ${((y = (m = (g = t.component) == null ? void 0 : g.Slider) == null ? void 0 : m.track) == null ? void 0 : y.height) ?? gt.trackHeight};
            background: linear-gradient(
                to right,
                ${((w = (h = (S = t.component) == null ? void 0 : S.Slider) == null ? void 0 : h.track) == null ? void 0 : w.backgroundColor) ?? "#000"} ${o},
                ${((C = (I = (v = t.component) == null ? void 0 : v.Slider) == null ? void 0 : I.track) == null ? void 0 : C.backgroundColorRightOfThumb) ?? ((A = (T = (x = t.component) == null ? void 0 : x.Slider) == null ? void 0 : T.track) == null ? void 0 : A.backgroundColor) ?? "#000"} ${o}
            );
            border: ${((B = (P = (O = t.component) == null ? void 0 : O.Slider) == null ? void 0 : P.track) == null ? void 0 : B.border) ?? 0};
            border-radius: ${((D = (_ = (N = t.component) == null ? void 0 : N.Slider) == null ? void 0 : _.track) == null ? void 0 : D.borderRadius) ?? 0};
            box-shadow: ${((V = (j = (R = t.component) == null ? void 0 : R.Slider) == null ? void 0 : j.track) == null ? void 0 : V.boxShadow) ?? "none"};
            outline: ${((F = (J = (Z = t.component) == null ? void 0 : Z.Slider) == null ? void 0 : J.track) == null ? void 0 : F.outline) ?? "none"};
            ${(E = (H = (L = t.component) == null ? void 0 : L.Slider) == null ? void 0 : H.track) != null && E.transition ? `transition: ${t.component.Slider.track.transition};` : ""}
        }
        
        ::-webkit-slider-thumb {
            -webkit-appearance: none;
            box-sizing: border-box;
            width: ${((K = (so = (to = t.component) == null ? void 0 : to.Slider) == null ? void 0 : so.thumb) == null ? void 0 : K.width) ?? gt.thumbWidth};
            height: ${((ro = (q = (X = t.component) == null ? void 0 : X.Slider) == null ? void 0 : q.thumb) == null ? void 0 : ro.height) ?? gt.thumbHeight};
            transform: translateY(
                calc(-50% + calc(${((ao = (io = (no = t.component) == null ? void 0 : no.Slider) == null ? void 0 : io.track) == null ? void 0 : ao.height) ?? gt.trackHeight} / 2))
            );
            background: ${((G = (W = (z = t.component) == null ? void 0 : z.Slider) == null ? void 0 : W.thumb) == null ? void 0 : G.background) ?? "#000"};
            border: ${((oo = (Q = (Y = t.component) == null ? void 0 : Y.Slider) == null ? void 0 : Q.thumb) == null ? void 0 : oo.border) ?? 0};
            border-radius: ${((uo = (po = (co = t.component) == null ? void 0 : co.Slider) == null ? void 0 : po.thumb) == null ? void 0 : uo.borderRadius) ?? 0};
            box-shadow: ${((So = (bo = (fo = t.component) == null ? void 0 : fo.Slider) == null ? void 0 : bo.thumb) == null ? void 0 : So.boxShadow) ?? "none"};
            outline: ${((To = (Ro = (vo = t.component) == null ? void 0 : vo.Slider) == null ? void 0 : Ro.thumb) == null ? void 0 : To.outline) ?? "none"};
            ${(Vo = (Do = (Ao = t.component) == null ? void 0 : Ao.Slider) == null ? void 0 : Do.thumb) != null && Vo.transition ? `transition: ${t.component.Slider.thumb.transition};` : ""}
        }
            
        ::-moz-range-track {
            box-sizing: border-box;
            width: 100%;
            height: ${((at = (tt = (ot = t.component) == null ? void 0 : ot.Slider) == null ? void 0 : tt.track) == null ? void 0 : at.height) ?? gt.trackHeight};
            background: ${((Ko = (Wo = (st = t.component) == null ? void 0 : st.Slider) == null ? void 0 : Wo.track) == null ? void 0 : Ko.backgroundColorRightOfThumb) ?? ((lt = (nt = (ct = t.component) == null ? void 0 : ct.Slider) == null ? void 0 : nt.track) == null ? void 0 : lt.backgroundColor) ?? "#000"};
            border: ${((pt = (jo = (et = t.component) == null ? void 0 : et.Slider) == null ? void 0 : jo.track) == null ? void 0 : pt.border) ?? 0};
            border-radius: ${((ut = (dt = (Bo = t.component) == null ? void 0 : Bo.Slider) == null ? void 0 : dt.track) == null ? void 0 : ut.borderRadius) ?? 0};
            box-shadow: ${((vt = (ht = ($t = t.component) == null ? void 0 : $t.Slider) == null ? void 0 : ht.track) == null ? void 0 : vt.boxShadow) ?? "none"};
            outline: ${((It = (wt = (Lo = t.component) == null ? void 0 : Lo.Slider) == null ? void 0 : wt.track) == null ? void 0 : It.outline) ?? "none"};
            ${(Ct = (kt = (xt = t.component) == null ? void 0 : xt.Slider) == null ? void 0 : kt.track) != null && Ct.transition ? `transition: ${t.component.Slider.track.transition};` : ""}
        }
                
        ::-moz-range-progress {
            box-sizing: border-box;
            width: 100%;
            height: ${((At = (Rt = (Qo = t.component) == null ? void 0 : Qo.Slider) == null ? void 0 : Rt.track) == null ? void 0 : At.height) ?? gt.trackHeight};
            background: ${((zt = (Ft = (Tt = t.component) == null ? void 0 : Tt.Slider) == null ? void 0 : Ft.track) == null ? void 0 : zt.backgroundColor) ?? "#000"};
            border: ${((Nt = (Dt = (Jo = t.component) == null ? void 0 : Jo.Slider) == null ? void 0 : Dt.track) == null ? void 0 : Nt.border) ?? 0};
            border-top-left-radius: ${((Bt = (Wt = (Et = t.component) == null ? void 0 : Et.Slider) == null ? void 0 : Wt.track) == null ? void 0 : Bt.borderRadius) ?? 0};
            border-bottom-left-radius: ${((un = (Kt = (dn = t.component) == null ? void 0 : dn.Slider) == null ? void 0 : Kt.track) == null ? void 0 : un.borderRadius) ?? 0};
            box-shadow: ${((fn = (Ut = (Mt = t.component) == null ? void 0 : Mt.Slider) == null ? void 0 : Ut.track) == null ? void 0 : fn.boxShadow) ?? "none"};
            outline: ${((gn = (Qt = (Ot = t.component) == null ? void 0 : Ot.Slider) == null ? void 0 : Qt.track) == null ? void 0 : gn.outline) ?? "none"};
            ${(Jt = (mn = (bn = t.component) == null ? void 0 : bn.Slider) == null ? void 0 : mn.track) != null && Jt.transition ? `transition: ${t.component.Slider.track.transition};` : ""}
        }
                
        ::-moz-range-thumb {
            box-sizing: border-box;
            width: ${(($n = (Sn = (yn = t.component) == null ? void 0 : yn.Slider) == null ? void 0 : Sn.thumb) == null ? void 0 : $n.width) ?? gt.thumbWidth};
            height: ${((wn = (vn = (hn = t.component) == null ? void 0 : hn.Slider) == null ? void 0 : vn.thumb) == null ? void 0 : wn.height) ?? gt.thumbHeight};
            background: ${((kn = (xn = (In = t.component) == null ? void 0 : In.Slider) == null ? void 0 : xn.thumb) == null ? void 0 : kn.background) ?? "#000"};
            border: ${((Zt = (Pt = (Cn = t.component) == null ? void 0 : Cn.Slider) == null ? void 0 : Pt.thumb) == null ? void 0 : Zt.border) ?? 0};
            border-radius: ${((Xt = (An = (Rn = t.component) == null ? void 0 : Rn.Slider) == null ? void 0 : An.thumb) == null ? void 0 : Xt.borderRadius) ?? 0};
            box-shadow: ${((zn = (Fn = (Tn = t.component) == null ? void 0 : Tn.Slider) == null ? void 0 : Fn.thumb) == null ? void 0 : zn.boxShadow) ?? "none"};
            outline: ${((Nn = (Dn = (on = t.component) == null ? void 0 : on.Slider) == null ? void 0 : Dn.thumb) == null ? void 0 : Nn.outline) ?? "none"};
            ${(Wn = (qt = (En = t.component) == null ? void 0 : En.Slider) == null ? void 0 : qt.thumb) != null && Wn.transition ? `transition: ${t.component.Slider.thumb.transition};` : ""}
        }

        ${Fo(Yt("hover", t, o))}
        ${_o({
    focusStyle: Yt("focus", t, o),
    focusVisibleStyle: Yt("focusVisible", t, o)
  })}
        ${Yo(Yt("active", t, o))}
        ${Xo(Yt("disabled", t, o))}
        ${it(Yt("invalid", t, o))}
    `;
}), bi = /* @__PURE__ */ $o.forwardRef(({ value: o, min: t, max: n, step: r = 1, decimals: e = 2, onChange: i, hasError: a = !1, errorMessageElementId: c, showLabels: l = !1, ...p }, d) => {
  const u = _n(), b = p.id || u, [g, m] = Co(!0), y = yt((x) => Number.isInteger(x) ? Math.ceil(x / r) * r : Number((Math.ceil(Number((x / r).toFixed(e))) * r).toFixed(e)), [
    e,
    r
  ]), S = yt((x) => {
    const T = Number(x.target.value);
    if (T <= t)
      i(t, g);
    else if (T + r > n)
      i(n, g);
    else {
      const A = y(Number.isInteger(r) ? T - t : T);
      i(T % r === 0 ? T : A > t ? A : t, g);
    }
  }, [
    n,
    t,
    i,
    y,
    g,
    r
  ]), h = () => {
    m(!1);
  }, w = () => {
    m(!0), i(o, !0);
  }, v = y(o), I = `${Math.round(98 * (v - t) / (n - t) + 1)}%`, C = o % r !== 0 ? n + r : n;
  return /* @__PURE__ */ wo(fi, {
    children: [
      l && /* @__PURE__ */ M(pe, {
        htmlFor: b,
        children: t
      }),
      /* @__PURE__ */ M(gi, {
        type: "range",
        id: b,
        min: t,
        max: C,
        step: r,
        value: v,
        thumbPosition: I,
        onChange: S,
        onPointerDown: h,
        onPointerUp: w,
        onTouchStart: h,
        onTouchEnd: w,
        ref: d,
        "aria-invalid": a,
        "aria-errormessage": a ? c : void 0,
        ...p
      }),
      l && /* @__PURE__ */ M(pe, {
        htmlFor: b,
        children: n
      })
    ]
  });
}), La = /* @__PURE__ */ eo("span", {
  target: "etg26ws0"
})({
  all: "revert",
  boxSizing: "border-box",
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-9999px;",
  overflow: "hidden",
  border: "0",
  whiteSpace: "nowrap"
}), de = (o = 0) => o === 0 || o === "0" || o.length === 0 ? "0px" : o.toString().split(" ")[1] ?? o, mi = /* @__PURE__ */ eo("div", {
  target: "e1aoads60"
})(({ theme: o, columns: t, maxColumns: n, equalRowHeight: r, gap: e }) => `
        all: revert;
        box-sizing: border-box;
        display: grid;
        ${typeof t < "u" ? `
                    grid-template-columns: repeat(${typeof t == "object" ? t.mobile : t}, 1fr);
                ` : ""}
        ${typeof n < "u" ? `        
                    grid-template-columns: repeat(auto-fit, minmax(calc(${100 / (typeof n == "object" ? n.mobile : n)}% - ${de(typeof e == "object" ? e.mobile : e)}), 1fr));
                ` : ""}
        grid-auto-rows: ${typeof r == "object" && r.mobile || typeof r == "boolean" && r ? "1fr" : "auto"};
        gap: ${typeof e == "object" ? e.mobile : e ?? 0};
        margin: 0;
        padding: 0;

        ${o.mq({
  theme: o,
  min: lo.DESKTOP,
  css: `
                ${typeof t == "object" ? `
                            grid-template-columns: repeat(${t.desktop}, 1fr);
                        ` : ""}
                ${typeof n == "object" ? `        
                            grid-template-columns: repeat(auto-fit, minmax(calc(${100 / n.desktop}% - ${de(typeof e == "object" ? e.desktop : e)}), 1fr));
                        ` : ""}
                grid-auto-rows: ${typeof r == "object" && r.desktop || typeof r == "boolean" && r ? "1fr" : "auto"};
                ${typeof e == "object" ? `gap: ${e.desktop};` : ""};
            `
})}
    `), _a = /* @__PURE__ */ eo("b", {
  target: "epp03sm0"
})(({ theme: o }) => {
  var t, n, r, e;
  return k({
    all: "revert",
    boxSizing: "border-box",
    display: "inline",
    margin: 0,
    padding: 0,
    fontFamily: (n = (t = o.component) == null ? void 0 : t.TransBold) != null && n.fontFamily ? o.typography.font[o.component.TransBold.fontFamily] : "inherit",
    fontWeight: ((e = (r = o.component) == null ? void 0 : r.TransBold) == null ? void 0 : e.fontWeight) || "inherit"
  });
}), Va = /* @__PURE__ */ $o.forwardRef(({ to: o, target: t, children: n, ...r }, e) => !o || !n ? null : /* @__PURE__ */ M(ri, {
  href: o,
  target: t || "_blank",
  ref: e,
  ...r,
  children: n
})), yi = /* @__PURE__ */ eo("div", {
  target: "e1u5ifpo0"
})(({ theme: o, variant: t }) => {
  var r, e, i, a, c, l;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Accordion) == null ? void 0 : e.wrapper,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Accordion) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.wrapper
  };
  return k({
    all: "revert",
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    ...n
  });
}), Si = /* @__PURE__ */ eo(St, {
  target: "e1u5ifpo1"
})(({ theme: o, accordionVariant: t, isExpanded: n }) => {
  var a, c, l, p, d;
  const { toggleButton: r } = ((a = o.component) == null ? void 0 : a.Accordion) || {}, e = ((d = (p = (l = (c = o.component) == null ? void 0 : c.Accordion) == null ? void 0 : l.variant) == null ? void 0 : p[t]) == null ? void 0 : d.toggleButton) || {}, i = e.isExpandedStyle || (r == null ? void 0 : r.isExpandedStyle) || "";
  return `
            ${k({
    display: e.display || (r == null ? void 0 : r.display),
    width: e.width ?? (r == null ? void 0 : r.width),
    height: e.height ?? (r == null ? void 0 : r.height),
    gap: e.gap ?? (r == null ? void 0 : r.gap) ?? o.spacing(6),
    padding: e.padding ?? (r == null ? void 0 : r.padding),
    background: e.background ?? (r == null ? void 0 : r.background),
    border: e.border ?? (r == null ? void 0 : r.border),
    borderBottom: e.borderBottom ?? (r == null ? void 0 : r.borderBottom),
    borderRadius: e.borderRadius ?? (r == null ? void 0 : r.borderRadius),
    boxShadow: e.boxShadow || (r == null ? void 0 : r.boxShadow),
    fontFamily: e.fontFamily || r != null && r.fontFamily ? o.typography.font[e.fontFamily || (r == null ? void 0 : r.fontFamily) || "primary"] : void 0,
    fontWeight: r == null ? void 0 : r.fontWeight,
    fontSize: e.fontSize || r != null && r.fontSize ? o.typography.size[e.fontSize || (r == null ? void 0 : r.fontSize) || "md"] : void 0,
    color: e.color ?? (r == null ? void 0 : r.color),
    transition: e.transition ?? (r == null ? void 0 : r.transition)
  }).styles}


            ${Fo(e.hoverStyle || (r == null ? void 0 : r.hoverStyle))}
            ${jt({
    focusStyle: e.focusStyle || (r == null ? void 0 : r.focusStyle),
    focusVisibleStyle: e.focusVisibleStyle || (r == null ? void 0 : r.focusVisibleStyle)
  })}
            ${Yo(e.activeStyle || (r == null ? void 0 : r.activeStyle))}

            ${n ? i : ""}
        `;
}), $i = /* @__PURE__ */ eo(Gt.ChevronDown, {
  shouldForwardProp: (o) => Jn(o),
  target: "e1u5ifpo2"
})(({ theme: o, variant: t, isExpanded: n }) => {
  var r, e, i, a, c, l, p, d;
  return k({
    transition: "transform 0.15s",
    transform: `rotate(${n ? "180deg" : 0})`,
    color: ((c = (a = (i = (e = (r = o.component) == null ? void 0 : r.Accordion) == null ? void 0 : e.variant) == null ? void 0 : i[t]) == null ? void 0 : a.toggleButton) == null ? void 0 : c.iconColor) || ((d = (p = (l = o.component) == null ? void 0 : l.Accordion) == null ? void 0 : p.toggleButton) == null ? void 0 : d.iconColor) || "inherit"
  });
}), hi = /* @__PURE__ */ eo("div", {
  target: "e1u5ifpo3"
})(({ theme: o, variant: t, isExpanded: n, isTransitioning: r }) => {
  var p, d, u, b, g, m;
  const e = (b = (u = (d = (p = o.component) == null ? void 0 : p.Accordion) == null ? void 0 : d.variant) == null ? void 0 : u[t]) == null ? void 0 : b.collapsible, { maxHeight: i, showOverflowWhenExpanded: a, transitionDuration: c, transitionTimingFunction: l } = {
    maxHeight: "1000px",
    transitionDuration: "250ms",
    transitionTimingFunction: "ease",
    ...(m = (g = o.component) == null ? void 0 : g.Accordion) == null ? void 0 : m.collapsible,
    ...e
  };
  return k({
    all: "revert",
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    overflow: a && !r && n ? "visible" : "hidden",
    visibility: n ? "visible" : "hidden",
    maxHeight: n ? i : 0,
    transition: `max-height ${c} ${l}, visibility 0ms ${n ? "0ms" : c}`
  });
}), vi = /* @__PURE__ */ eo("div", {
  target: "e1u5ifpo4"
})(({ theme: o, variant: t }) => {
  var n, r, e, i, a, c;
  return k({
    ...(r = (n = o.component) == null ? void 0 : n.Accordion) == null ? void 0 : r.content,
    ...(c = (a = (i = (e = o.component) == null ? void 0 : e.Accordion) == null ? void 0 : i.variant) == null ? void 0 : a[t]) == null ? void 0 : c.content
  });
}), rn = {
  Wrapper: yi,
  ToggleButton: Si,
  ToggleButtonIcon: $i,
  Collapsible: hi,
  Content: vi
}, ja = /* @__PURE__ */ $o.forwardRef(({ variant: o = Oo.PRIMARY, label: t, id: n, onToggle: r, children: e, ...i }, a) => {
  var y, S, h;
  const c = Io(), [l, p] = Co(!1), [d, u] = Co(!1), b = `${n}-button`, g = `${n}-content`, m = () => {
    u(!0), p((w) => {
      const v = !w;
      return typeof r == "function" && r(v), v;
    });
  };
  return /* @__PURE__ */ wo(rn.Wrapper, {
    variant: o,
    ref: a,
    ...i,
    children: [
      /* @__PURE__ */ M(rn.ToggleButton, {
        accordionVariant: o,
        isExpanded: l,
        variant: ((h = (S = (y = c.component) == null ? void 0 : y.Accordion) == null ? void 0 : S.toggleButton) == null ? void 0 : h.variant) || qo.TEXT,
        icon: /* @__PURE__ */ M(rn.ToggleButtonIcon, {
          variant: o,
          isExpanded: l
        }),
        onClick: m,
        "aria-expanded": l,
        id: b,
        "aria-controls": g,
        children: t
      }),
      /* @__PURE__ */ M(rn.Collapsible, {
        role: "region",
        variant: o,
        id: g,
        "aria-labelledby": b,
        isExpanded: l,
        isTransitioning: d,
        onTransitionEnd: () => {
          u(!1);
        },
        children: /* @__PURE__ */ M(rn.Content, {
          variant: o,
          children: e
        })
      })
    ]
  });
}), wi = /* @__PURE__ */ eo("div", {
  target: "e1yy5nlu0"
})(({ theme: o }) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w;
  return ` 
        ${k({
    all: "revert",
    boxSizing: "border-box",
    position: "relative",
    padding: (r = (n = (t = o.component) == null ? void 0 : t.Autocomplete) == null ? void 0 : n.wrapper) == null ? void 0 : r.padding,
    background: (a = (i = (e = o.component) == null ? void 0 : e.Autocomplete) == null ? void 0 : i.wrapper) == null ? void 0 : a.background,
    border: (p = (l = (c = o.component) == null ? void 0 : c.Autocomplete) == null ? void 0 : l.wrapper) == null ? void 0 : p.border,
    borderRadius: (b = (u = (d = o.component) == null ? void 0 : d.Autocomplete) == null ? void 0 : u.wrapper) == null ? void 0 : b.borderRadius,
    boxShadow: (y = (m = (g = o.component) == null ? void 0 : g.Autocomplete) == null ? void 0 : m.wrapper) == null ? void 0 : y.boxShadow
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k((w = (h = (S = o.component) == null ? void 0 : S.Autocomplete) == null ? void 0 : h.wrapper) == null ? void 0 : w.desktop).styles
  })}   
    `;
}), Ii = /* @__PURE__ */ eo("button", {
  target: "e1yy5nlu1"
})(({ theme: o }) => {
  var t, n, r, e, i, a, c, l, p, d, u, b;
  return {
    all: "revert",
    boxSizing: "border-box",
    pointerEvents: "all",
    display: ((e = (r = (n = (t = o.component) == null ? void 0 : t.Autocomplete) == null ? void 0 : n.inputField) == null ? void 0 : r.clearButton) == null ? void 0 : e.display) || "flex",
    justifyContent: ((l = (c = (a = (i = o.component) == null ? void 0 : i.Autocomplete) == null ? void 0 : a.inputField) == null ? void 0 : c.clearButton) == null ? void 0 : l.justifyContent) || "center",
    alignItems: ((b = (u = (d = (p = o.component) == null ? void 0 : p.Autocomplete) == null ? void 0 : d.inputField) == null ? void 0 : u.clearButton) == null ? void 0 : b.alignItems) || "center",
    margin: 0,
    padding: 0,
    background: "none",
    border: "none",
    boxShadow: "none",
    outline: "none",
    cursor: "pointer",
    color: "inherit"
  };
}), xi = /* @__PURE__ */ eo("button", {
  target: "e1yy5nlu2"
})(({ theme: o, isOpen: t }) => {
  var n, r, e, i, a, c, l, p, d, u, b, g;
  return {
    all: "revert",
    boxSizing: "border-box",
    pointerEvents: t ? "all" : "none",
    display: ((i = (e = (r = (n = o.component) == null ? void 0 : n.Autocomplete) == null ? void 0 : r.inputField) == null ? void 0 : e.dropdownButton) == null ? void 0 : i.display) || "flex",
    justifyContent: ((p = (l = (c = (a = o.component) == null ? void 0 : a.Autocomplete) == null ? void 0 : c.inputField) == null ? void 0 : l.dropdownButton) == null ? void 0 : p.justifyContent) || "center",
    alignItems: ((g = (b = (u = (d = o.component) == null ? void 0 : d.Autocomplete) == null ? void 0 : u.inputField) == null ? void 0 : b.dropdownButton) == null ? void 0 : g.alignItems) || "center",
    margin: o.spacing(0, 0, 0, 2),
    padding: 0,
    background: "none",
    border: "none",
    boxShadow: "none",
    outline: "none",
    cursor: "pointer"
  };
}), ki = /* @__PURE__ */ eo("ul", {
  target: "e1yy5nlu3"
})(({ theme: o, isOpen: t, isEmpty: n, renderOnTop: r }) => {
  var e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F;
  return ` 
        ${k({
    all: "revert",
    boxSizing: "border-box",
    position: "absolute",
    ...r && {
      bottom: "100%"
    },
    ...!r && {
      top: "100%"
    },
    left: ((a = (i = (e = o.component) == null ? void 0 : e.Autocomplete) == null ? void 0 : i.list) == null ? void 0 : a.left) ?? 0,
    right: ((p = (l = (c = o.component) == null ? void 0 : c.Autocomplete) == null ? void 0 : l.list) == null ? void 0 : p.right) ?? 0,
    zIndex: ((b = (u = (d = o.component) == null ? void 0 : d.Autocomplete) == null ? void 0 : u.list) == null ? void 0 : b.zIndex) ?? 10,
    display: t && !n ? "block" : "none",
    maxHeight: ((y = (m = (g = o.component) == null ? void 0 : g.Autocomplete) == null ? void 0 : m.list) == null ? void 0 : y.maxHeight) ?? "40vh",
    overflowY: "auto",
    listStyle: "none",
    margin: ((w = (h = (S = o.component) == null ? void 0 : S.Autocomplete) == null ? void 0 : h.list) == null ? void 0 : w.margin) ?? 0,
    padding: ((C = (I = (v = o.component) == null ? void 0 : v.Autocomplete) == null ? void 0 : I.list) == null ? void 0 : C.padding) ?? 0,
    background: (A = (T = (x = o.component) == null ? void 0 : x.Autocomplete) == null ? void 0 : T.list) == null ? void 0 : A.background,
    border: (B = (P = (O = o.component) == null ? void 0 : O.Autocomplete) == null ? void 0 : P.list) == null ? void 0 : B.border,
    borderRadius: (D = (_ = (N = o.component) == null ? void 0 : N.Autocomplete) == null ? void 0 : _.list) == null ? void 0 : D.borderRadius,
    boxShadow: (V = (j = (R = o.component) == null ? void 0 : R.Autocomplete) == null ? void 0 : j.list) == null ? void 0 : V.boxShadow
  }).styles}
        
        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k((F = (J = (Z = o.component) == null ? void 0 : Z.Autocomplete) == null ? void 0 : J.list) == null ? void 0 : F.desktop).styles
  })}   
    `;
}), Ci = /* @__PURE__ */ eo("li", {
  target: "e1yy5nlu4"
})(({ theme: o, hasFocus: t }) => {
  var n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo, Ro, To, Ao, Do, Vo, ot, tt, at, st, Wo, Ko, ct, nt, lt, et, jo, pt, Bo, dt, ut, $t, ht, vt, Lo, wt, It, xt, kt, Ct, Qo, Rt, At, Tt, Ft, zt, Jo, Dt, Nt, Et, Wt, Bt;
  return ` 
        ${k({
    all: "revert",
    "&::before, &::after": {
      all: "revert"
    },
    boxSizing: "border-box",
    display: "grid",
    gridTemplateAreas: "'label icon'",
    gridTemplateColumns: "1fr auto",
    ...((i = (e = (r = (n = o.component) == null ? void 0 : n.Autocomplete) == null ? void 0 : r.listItem) == null ? void 0 : e.icon) == null ? void 0 : i.iconPlacement) === "left" ? {
      gridTemplateAreas: "'icon label'",
      gridTemplateColumns: "auto 1fr"
    } : {},
    ...((p = (l = (c = (a = o.component) == null ? void 0 : a.Autocomplete) == null ? void 0 : c.listItem) == null ? void 0 : l.icon) == null ? void 0 : p.iconPlacement) === "right" ? {
      gridTemplateColumns: "auto 1fr"
    } : {},
    gap: ((b = (u = (d = o.component) == null ? void 0 : d.Autocomplete) == null ? void 0 : u.listItem) == null ? void 0 : b.gap) ?? o.spacing(1),
    padding: ((y = (m = (g = o.component) == null ? void 0 : g.Autocomplete) == null ? void 0 : m.listItem) == null ? void 0 : y.padding) ?? o.spacing(2, 3),
    background: ((w = (h = (S = o.component) == null ? void 0 : S.Autocomplete) == null ? void 0 : h.listItem) == null ? void 0 : w.background) || "#FFFFFF",
    border: (C = (I = (v = o.component) == null ? void 0 : v.Autocomplete) == null ? void 0 : I.listItem) == null ? void 0 : C.border,
    fontFamily: o.typography.font[((A = (T = (x = o.component) == null ? void 0 : x.Autocomplete) == null ? void 0 : T.listItem) == null ? void 0 : A.fontFamily) || "primary"],
    fontSize: o.typography.size[((B = (P = (O = o.component) == null ? void 0 : O.Autocomplete) == null ? void 0 : P.listItem) == null ? void 0 : B.fontSize) || "md"],
    fontWeight: (D = (_ = (N = o.component) == null ? void 0 : N.Autocomplete) == null ? void 0 : _.listItem) == null ? void 0 : D.fontWeight,
    color: (V = (j = (R = o.component) == null ? void 0 : R.Autocomplete) == null ? void 0 : j.listItem) == null ? void 0 : V.color,
    cursor: ((F = (J = (Z = o.component) == null ? void 0 : Z.Autocomplete) == null ? void 0 : J.listItem) == null ? void 0 : F.cursor) || "pointer",
    ...((E = (H = (L = o.component) == null ? void 0 : L.Autocomplete) == null ? void 0 : H.listItem) == null ? void 0 : E.separator) && {
      ":not(:last-of-type)": {
        borderBottomColor: o.component.Autocomplete.listItem.separator.color,
        borderBottomWidth: o.component.Autocomplete.listItem.separator.width,
        borderBottomStyle: o.component.Autocomplete.listItem.separator.style || "solid"
      }
    },
    ...t && {
      background: (X = (K = (so = (to = o.component) == null ? void 0 : to.Autocomplete) == null ? void 0 : so.listItem) == null ? void 0 : K.focus) == null ? void 0 : X.background,
      border: (io = (no = (ro = (q = o.component) == null ? void 0 : q.Autocomplete) == null ? void 0 : ro.listItem) == null ? void 0 : no.focus) == null ? void 0 : io.border,
      color: (G = (W = (z = (ao = o.component) == null ? void 0 : ao.Autocomplete) == null ? void 0 : z.listItem) == null ? void 0 : W.focus) == null ? void 0 : G.color
    }
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      gap: (co = (oo = (Q = (Y = o.component) == null ? void 0 : Y.Autocomplete) == null ? void 0 : Q.listItem) == null ? void 0 : oo.desktop) == null ? void 0 : co.gap,
      padding: (bo = (fo = (uo = (po = o.component) == null ? void 0 : po.Autocomplete) == null ? void 0 : uo.listItem) == null ? void 0 : fo.desktop) == null ? void 0 : bo.padding,
      background: (To = (Ro = (vo = (So = o.component) == null ? void 0 : So.Autocomplete) == null ? void 0 : vo.listItem) == null ? void 0 : Ro.desktop) == null ? void 0 : To.background,
      border: (ot = (Vo = (Do = (Ao = o.component) == null ? void 0 : Ao.Autocomplete) == null ? void 0 : Do.listItem) == null ? void 0 : Vo.desktop) == null ? void 0 : ot.border,
      fontFamily: (Wo = (st = (at = (tt = o.component) == null ? void 0 : tt.Autocomplete) == null ? void 0 : at.listItem) == null ? void 0 : st.desktop) != null && Wo.fontFamily ? o.typography.font[o.component.Autocomplete.listItem.desktop.fontFamily] : void 0,
      fontSize: (lt = (nt = (ct = (Ko = o.component) == null ? void 0 : Ko.Autocomplete) == null ? void 0 : ct.listItem) == null ? void 0 : nt.desktop) != null && lt.fontSize ? o.typography.size[o.component.Autocomplete.listItem.desktop.fontSize] : void 0,
      fontWeight: (Bo = (pt = (jo = (et = o.component) == null ? void 0 : et.Autocomplete) == null ? void 0 : jo.listItem) == null ? void 0 : pt.desktop) == null ? void 0 : Bo.fontWeight,
      color: (ht = ($t = (ut = (dt = o.component) == null ? void 0 : dt.Autocomplete) == null ? void 0 : ut.listItem) == null ? void 0 : $t.desktop) == null ? void 0 : ht.color,
      ...((It = (wt = (Lo = (vt = o.component) == null ? void 0 : vt.Autocomplete) == null ? void 0 : Lo.listItem) == null ? void 0 : wt.desktop) == null ? void 0 : It.separator) && {
        ":not(:last-of-type)": {
          borderBottomColor: o.component.Autocomplete.listItem.desktop.separator.color,
          borderBottomWidth: o.component.Autocomplete.listItem.desktop.separator.width,
          borderBottomStyle: o.component.Autocomplete.listItem.desktop.separator.style
        }
      },
      ...t && {
        background: (Rt = (Qo = (Ct = (kt = (xt = o.component) == null ? void 0 : xt.Autocomplete) == null ? void 0 : kt.listItem) == null ? void 0 : Ct.desktop) == null ? void 0 : Qo.focus) == null ? void 0 : Rt.background,
        border: (Jo = (zt = (Ft = (Tt = (At = o.component) == null ? void 0 : At.Autocomplete) == null ? void 0 : Tt.listItem) == null ? void 0 : Ft.desktop) == null ? void 0 : zt.focus) == null ? void 0 : Jo.border,
        color: (Bt = (Wt = (Et = (Nt = (Dt = o.component) == null ? void 0 : Dt.Autocomplete) == null ? void 0 : Nt.listItem) == null ? void 0 : Et.desktop) == null ? void 0 : Wt.focus) == null ? void 0 : Bt.color
      }
    }).styles
  })}   
    `;
}), Ri = (o, t) => {
  var n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h;
  return /* @__PURE__ */ k(k({
    gridArea: "icon",
    width: "16px",
    height: "16px",
    margin: 0,
    color: "inherit",
    ...(e = (r = (n = o.component) == null ? void 0 : n.Autocomplete) == null ? void 0 : r.listItem) == null ? void 0 : e.icon,
    ...t ? (l = (c = (a = (i = o.component) == null ? void 0 : i.Autocomplete) == null ? void 0 : a.listItem) == null ? void 0 : c.focus) == null ? void 0 : l.icon : {}
  }).styles, " ", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...(b = (u = (d = (p = o.component) == null ? void 0 : p.Autocomplete) == null ? void 0 : d.listItem) == null ? void 0 : u.desktop) == null ? void 0 : b.icon,
      ...t ? (h = (S = (y = (m = (g = o.component) == null ? void 0 : g.Autocomplete) == null ? void 0 : m.listItem) == null ? void 0 : y.desktop) == null ? void 0 : S.focus) == null ? void 0 : h.icon : {}
    }).styles
  }));
}, Ai = (o) => {
  var t, n, r, e, i, a, c;
  return /* @__PURE__ */ k(k({
    margin: o.spacing(0, 0, 0, 2),
    width: "20px",
    height: "20px",
    ...No((r = (n = (t = o.component) == null ? void 0 : t.Autocomplete) == null ? void 0 : n.inputField) == null ? void 0 : r.searchIcon, [
      "component"
    ])
  }).styles, " ", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k((c = (a = (i = (e = o.component) == null ? void 0 : e.Autocomplete) == null ? void 0 : i.inputField) == null ? void 0 : a.searchIcon) == null ? void 0 : c.desktop).styles
  }));
}, Ti = (o, t) => {
  var n, r, e, i, a, c, l, p, d;
  return /* @__PURE__ */ k(k({
    ...No((i = (e = (r = (n = o.component) == null ? void 0 : n.Autocomplete) == null ? void 0 : r.inputField) == null ? void 0 : e.dropdownButton) == null ? void 0 : i.icon, [
      "component"
    ]),
    ...t && {
      transform: "rotate(180deg)",
      transformOrigin: "center"
    }
  }).styles, " ", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k((d = (p = (l = (c = (a = o.component) == null ? void 0 : a.Autocomplete) == null ? void 0 : c.inputField) == null ? void 0 : l.dropdownButton) == null ? void 0 : p.icon) == null ? void 0 : d.desktop).styles
  }));
}, Fi = (o) => {
  var t, n, r, e, i, a, c, l, p;
  return /* @__PURE__ */ k(k({
    width: "20px",
    height: "20px",
    ...No((e = (r = (n = (t = o.component) == null ? void 0 : t.Autocomplete) == null ? void 0 : n.inputField) == null ? void 0 : r.clearButton) == null ? void 0 : e.icon, [
      "component"
    ])
  }).styles, " ", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k((p = (l = (c = (a = (i = o.component) == null ? void 0 : i.Autocomplete) == null ? void 0 : a.inputField) == null ? void 0 : c.clearButton) == null ? void 0 : l.icon) == null ? void 0 : p.desktop).styles
  }));
}, On = {
  listItemIcon: Ri,
  searchIcon: Ai,
  dropdownButtonIcon: Ti,
  clearButtonIcon: Fi
}, an = {
  Wrapper: wi,
  ClearButton: Ii,
  DropdownButton: xi,
  List: ki,
  ListItem: Ci
}, zi = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", d: "M15.707 5.707a1 1 0 0 0-1.414-1.414L10 8.586 5.707 4.293a1 1 0 0 0-1.414 1.414L8.586 10l-4.293 4.293a1 1 0 1 0 1.414 1.414L10 11.414l4.293 4.293a1 1 0 0 0 1.414-1.414L11.414 10l4.293-4.293Z" })), Di = Po(zi), Ni = (o, t) => /* @__PURE__ */ go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 25", ref: t, ...o }, /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.501 15.685a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0 1a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z", clipRule: "evenodd" }), /* @__PURE__ */ go.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.647 14.831a.5.5 0 0 1 .707 0l5.5 5.5a.5.5 0 1 1-.707.707l-5.5-5.5a.5.5 0 0 1 0-.707Z", clipRule: "evenodd" })), Vn = Po(Ni), Ce = ({ items: o, listAreaLabel: t, clearButtonTitle: n, inputChangeCallback: r, itemSelectionCallback: e, mode: i = "search", defaultSearchString: a, inputFieldProps: c, fieldValueFormatter: l, ref: p, ...d }) => {
  var V, Z, J;
  const u = Io(), [b, g] = Co(!1), m = Mo(null), y = Mo(null), S = Mo(`econans-autocomplete-${Math.round(Math.random() * 12345)}`).current, [h, w] = Co((l == null ? void 0 : l(a || "")) ?? (a || "")), [, v] = Co(!1), [I, C] = Co(-1), [x, T] = Co(-1), [A, O] = Co(!1), P = (F) => {
    var L;
    F < 0 || F > o.length - 1 || (C(F), T(F), w((l == null ? void 0 : l(o[F].label)) ?? o[F].label), O(!1), (L = m.current) == null || L.focus(), e(o[F]));
  }, B = () => {
    v(!0), O(!0);
  }, N = (F) => {
    var L;
    (L = F.relatedTarget) != null && L.getAttribute("data-index") || (v(!1), O(!1)), o.length === 1 && o[0].label === h && (C(0), T(0), e(o[0]));
  }, _ = yt((F) => {
    const L = document.querySelector(`#${S}-item-${F}`);
    y.current && L && L.scrollIntoView({
      block: "nearest",
      behavior: "smooth"
    });
  }, [
    S
  ]), D = (F) => {
    O(!0);
    const L = o.length - 1;
    switch (F.key) {
      case "ArrowUp":
        F.preventDefault(), T((H) => H - 1 < 0 ? L : H - 1);
        break;
      case "ArrowDown":
        F.preventDefault(), T((H) => H + 1 > L ? 0 : H + 1);
        break;
      case "PageUp":
        F.preventDefault(), T((H) => {
          let E = H - 5 < 0 ? 0 : H - 5;
          return H === 0 && (E = L), E;
        });
        break;
      case "PageDown":
        F.preventDefault(), T((H) => {
          let E = H + 5 > L ? L : H + 5;
          return (H === L || H === -1) && (E = 0), E;
        });
        break;
      case "Enter":
        F.preventDefault(), P(x);
        break;
      case "Escape":
        T(-1), O(!1), _(0);
        break;
    }
  }, R = () => {
    if (m.current && y.current) {
      const { top: F, height: L } = m.current.getBoundingClientRect(), { height: H } = y.current.getBoundingClientRect(), E = window.innerHeight;
      g(F + L + H > E);
    }
  }, j = yt(() => {
    var F, L, H, E, to, so, K, X, q, ro, no, io, ao, z;
    return /* @__PURE__ */ wo($o.Fragment, {
      children: [
        h.length > 0 && /* @__PURE__ */ M(an.ClearButton, {
          type: "button",
          tabIndex: -1,
          onClick: () => {
            var W;
            w(""), (W = m.current) == null || W.focus();
          },
          title: n,
          children: /* @__PURE__ */ M(zo, {
            instance: ((to = (E = (H = (L = (F = u.component) == null ? void 0 : F.Autocomplete) == null ? void 0 : L.inputField) == null ? void 0 : H.clearButton) == null ? void 0 : E.icon) == null ? void 0 : to.component) || Di,
            css: On.clearButtonIcon
          })
        }),
        i === "search" && h.length === 0 && /* @__PURE__ */ M(zo, {
          instance: ((q = (X = (K = (so = u.component) == null ? void 0 : so.Autocomplete) == null ? void 0 : K.inputField) == null ? void 0 : X.searchIcon) == null ? void 0 : q.component) || Vn,
          css: On.searchIcon
        }),
        i === "dropdown" && /* @__PURE__ */ M(an.DropdownButton, {
          tabIndex: -1,
          isOpen: A,
          children: /* @__PURE__ */ M(zo, {
            instance: ((z = (ao = (io = (no = (ro = u.component) == null ? void 0 : ro.Autocomplete) == null ? void 0 : no.inputField) == null ? void 0 : io.dropdownButton) == null ? void 0 : ao.icon) == null ? void 0 : z.component) || Gt.ChevronDown,
            css: On.dropdownButtonIcon(u, A)
          })
        })
      ]
    });
  }, [
    n,
    h.length,
    A,
    i,
    u
  ]);
  return Eo(() => {
    r(h);
  }, [
    h
  ]), Eo(() => {
    A && x !== -1 && _(x);
  }, [
    A,
    _,
    x
  ]), Eo(() => {
    o.length === 1 && x !== 0 && T(0), o.length === 0 && T(-1);
  }, [
    o,
    x,
    T
  ]), Eo(() => (window.addEventListener("resize", R), window.addEventListener("scroll", R), () => {
    window.removeEventListener("resize", R), window.removeEventListener("scroll", R);
  }), []), /* @__PURE__ */ wo(an.Wrapper, {
    ref: p,
    ...d,
    children: [
      /* @__PURE__ */ M(Xn, {
        ...c,
        ref: m,
        type: "text",
        autoComplete: "off",
        autoCapitalize: "none",
        spellCheck: "false",
        role: "combobox",
        "aria-controls": `${S}-list`,
        "aria-expanded": A,
        "aria-activedescendant": I > -1 ? `${S}-item-${I}` : void 0,
        value: h,
        onFocus: B,
        onBlur: N,
        onChange: (F) => {
          w((l == null ? void 0 : l(F.currentTarget.value)) ?? F.currentTarget.value);
        },
        onKeyDown: D,
        onClick: () => {
          O(!0);
        },
        variant: (J = (Z = (V = u.component) == null ? void 0 : V.Autocomplete) == null ? void 0 : Z.inputField) == null ? void 0 : J.variant,
        suffix: j()
      }),
      /* @__PURE__ */ M(an.List, {
        ref: y,
        tabIndex: -1,
        id: `${S}-list`,
        role: "listbox",
        "aria-label": t,
        isOpen: A && !(c != null && c.disabled),
        isEmpty: o.length === 0,
        renderOnTop: b,
        children: o.map((F, L) => /* @__PURE__ */ wo(an.ListItem, {
          id: `${S}-item-${L}`,
          "data-index": L,
          tabIndex: -1,
          role: "option",
          "aria-selected": I === L,
          onClick: () => {
            P(L);
          },
          onMouseDown: (H) => {
            H.preventDefault();
          },
          onMouseMove: () => {
            T(L);
          },
          hasFocus: x === L,
          children: [
            F.label,
            F.icon && /* @__PURE__ */ M(zo, {
              instance: F.icon,
              css: On.listItemIcon(u, L === x)
            })
          ]
        }, F.key))
      })
    ]
  });
}, Ei = /* @__PURE__ */ $o.forwardRef(({ value: o, onChange: t, decimals: n = 2, min: r, max: e, allowLowerThanMin: i = !1, allowHigherThanMax: a = !1, step: c = 1, debounceTime: l = 800, variant: p, suffix: d, clearOnFocusIfZero: u, allowEmptyValue: b = !1, autoSetMinValue: g = !0, autoSetMaxValue: m = !0, suffixAriaLabel: y, ...S }, h) => {
  const [w, v] = Co(!1), [I, C] = Co({
    asNumber: o,
    asText: ft(o, n)
  }), x = Ht(t, l);
  Eo(() => () => {
    x.cancel();
  }, [
    x
  ]), Eo(() => {
    w || C({
      asNumber: o,
      asText: ft(o, n)
    });
  }, [
    o,
    n
  ]);
  const T = (D) => {
    var V;
    const R = D.replace(/[^\d.,]/g, "").replace(".", ",").replace(
      // eslint-disable-next-line no-useless-escape
      /^([^,]*\,)(.*)$/,
      (Z, J, F) => J + F.replace(",", "")
    ), j = ((V = R.split(",")[1]) == null ? void 0 : V.length) || 0;
    return j > n ? R.substring(0, R.length - (j - n)) : R;
  }, A = (D) => (
    // Add a leading zero if the string starts with a comma, otherwise
    // for example ",12" will be converted to 12
    Number((D.startsWith(",") ? `0${D}` : D).replace(",", "."))
  ), O = (D, R = !1) => {
    if (D.asText.length === 0 || Number.isNaN(D.asNumber) || D.asNumber === o || /^0+[0-9]/.test(D.asText)) {
      x.cancel();
      return;
    }
    if (b && !i && typeof r == "number" && D.asNumber !== null && D.asNumber < r) {
      if (R && g) {
        C({
          asNumber: r,
          asText: ft(r, n)
        }), x(r);
        return;
      }
      x.cancel();
      return;
    }
    if (!a && typeof e == "number" && D.asNumber !== null && D.asNumber > e) {
      if (R && m) {
        C({
          asNumber: e,
          asText: ft(e, n)
        }), x(e);
        return;
      }
      x.cancel();
      return;
    }
    x(D.asNumber);
  }, P = (D) => {
    const R = T(D.target.value), j = A(R);
    C({
      asNumber: Number.isNaN(j) ? I.asNumber : j,
      asText: R
    }), O({
      asNumber: j,
      asText: R
    });
  }, B = (D) => {
    const { key: R } = D, j = I.asNumber ?? 0;
    if (R === "ArrowUp") {
      const V = a || e === void 0 ? Number((j + c).toFixed(n)) : Math.min(Number((j + c).toFixed(n)), e), Z = {
        asNumber: V,
        asText: ft(V, n)
      };
      C(Z), O(Z, !0);
      return;
    }
    if (R === "ArrowDown") {
      const V = i || r === void 0 ? Number((j - c).toFixed(n)) : Math.max(Number((j - c).toFixed(n)), r), Z = {
        asNumber: V,
        asText: ft(V, n)
      };
      C(Z), O(Z, !0);
    }
  }, N = () => {
    var V;
    if (v(!1), b && I.asText === "") {
      t(null);
      return;
    }
    let D = I.asText.replace(/^0+(\d)/gm, "$1"), R = A(D);
    if (R !== o && (!i && g && typeof r == "number" && R < r ? (R = r, D = T(ft(r, n))) : !a && m && typeof e == "number" && R > e && (R = e, D = T(ft(e, n)))), ((V = D.split(",")[1]) == null ? void 0 : V.length) !== n && (D = T(ft(R, n))), D.startsWith(",") && (D = `0${D}`), Number.isNaN(R)) return;
    const j = {
      asNumber: R,
      asText: D
    };
    C(j), O(j, !0);
  }, _ = () => {
    v(!0), u && I.asNumber === 0 && C({
      asText: "",
      asNumber: 0
    });
  };
  return /* @__PURE__ */ M(Xn, {
    type: "text",
    inputMode: "decimal",
    variant: p,
    suffix: d,
    value: I.asText,
    onFocus: _,
    onInput: P,
    onKeyUp: B,
    onBlur: N,
    suffixAriaLabel: y,
    ref: h,
    ...S
  });
}), Wi = /* @__PURE__ */ eo("dl", {
  target: "ecnjznl0"
})(({ theme: o, variant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m;
  const n = {
    ...(r = o.component) == null ? void 0 : r.DescriptionList,
    ...(a = (i = (e = o.component) == null ? void 0 : e.DescriptionList) == null ? void 0 : i.variant) == null ? void 0 : a[t],
    desktop: {
      ...(l = (c = o.component) == null ? void 0 : c.DescriptionList) == null ? void 0 : l.desktop,
      ...(b = (u = (d = (p = o.component) == null ? void 0 : p.DescriptionList) == null ? void 0 : d.variant) == null ? void 0 : u[t]) == null ? void 0 : b.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    display: "grid",
    gridTemplateColumns: n.gridTemplateColumns ?? "1fr 1fr",
    gap: n.gap ?? o.spacing(2),
    margin: n.margin ?? 0,
    padding: n.padding ?? 0,
    fontFamily: o.typography.font[n.fontFamily || "primary"],
    fontSize: o.typography.size[n.fontSize || "md"],
    fontWeight: n.fontWeight || "normal",
    lineHeight: n.lineHeight ?? "normal",
    letterSpacing: n.letterSpacing ?? "normal",
    textTransform: n.textTransform || "none",
    color: n.color || o.typography.color.primary
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...n.desktop,
      fontFamily: (g = n.desktop) != null && g.fontFamily ? o.typography.font[n.desktop.fontFamily] : void 0,
      fontSize: (m = n.desktop) != null && m.fontSize ? o.typography.size[n.desktop.fontSize] : void 0
    }).styles
  })}
    `;
}), Bi = {
  DlElement: Wi
}, Ha = /* @__PURE__ */ $o.forwardRef(({ variant: o = Oo.PRIMARY, items: t, children: n, ...r }, e) => {
  const i = Io();
  return /* @__PURE__ */ M(Bi.DlElement, {
    variant: o,
    ref: e,
    ...r,
    children: t ? t.map(({ term: a, detail: c }, l) => {
      var p, d, u, b, g, m, y, S, h, w, v, I;
      return (
        // Since both term and detail are React Nodes and not very suitable as keys,
        // make an exception and use the index.
        // eslint-disable-next-line react-x/no-array-index-key
        /* @__PURE__ */ wo($o.Fragment, {
          children: [
            /* @__PURE__ */ M(nr, {
              variant: ((b = (u = (d = (p = i.component) == null ? void 0 : p.DescriptionList) == null ? void 0 : d.variant) == null ? void 0 : u[o]) == null ? void 0 : b.descriptionTermVariant) || ((m = (g = i.component) == null ? void 0 : g.DescriptionList) == null ? void 0 : m.descriptionTermVariant) || o,
              children: a
            }),
            /* @__PURE__ */ M(tr, {
              variant: ((w = (h = (S = (y = i.component) == null ? void 0 : y.DescriptionList) == null ? void 0 : S.variant) == null ? void 0 : h[o]) == null ? void 0 : w.descriptionDetailVariant) || ((I = (v = i.component) == null ? void 0 : v.DescriptionList) == null ? void 0 : I.descriptionDetailVariant) || o,
              children: c
            })
          ]
        }, l)
      );
    }) : n
  });
}), Mi = /* @__PURE__ */ eo("dialog", {
  target: "e13buv010"
})(({ theme: o, dialogVariant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Dialog) == null ? void 0 : e.wrapper,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Dialog) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.wrapper,
    desktop: {
      ...(u = (d = (p = o.component) == null ? void 0 : p.Dialog) == null ? void 0 : d.wrapper) == null ? void 0 : u.desktop,
      ...(S = (y = (m = (g = (b = o.component) == null ? void 0 : b.Dialog) == null ? void 0 : g.variant) == null ? void 0 : m[t]) == null ? void 0 : y.wrapper) == null ? void 0 : S.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    ...No(n, [
      "focusStyle",
      "focusVisibleStyle",
      "focusWithinStyle"
    ]),
    "&[open]": {
      display: "flex",
      flexDirection: "column"
    }
  }).styles}

        ${_o({
    focusStyle: n.focusStyle,
    focusVisibleStyle: n.focusVisibleStyle
  })}
        ${mt(n.focusWithinStyle)}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${k(No(n.desktop, [
      "focusStyle",
      "focusVisibleStyle",
      "focusWithinStyle"
    ])).styles}
                ${_o({
      focusStyle: n.desktop.focusStyle,
      focusVisibleStyle: n.desktop.focusVisibleStyle
    })}
                ${mt(n.desktop.focusWithinStyle)}
            `
  })}
    `;
}), Oi = /* @__PURE__ */ eo(rr, {
  target: "e13buv011"
})(({ theme: o }) => {
  var t, n, r, e, i, a;
  return `
        ${k({
    marginBottom: (r = (n = (t = o.component) == null ? void 0 : t.Dialog) == null ? void 0 : n.heading) == null ? void 0 : r.marginBottom
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      marginBottom: (a = (i = (e = o.component) == null ? void 0 : e.Dialog) == null ? void 0 : i.heading) == null ? void 0 : a.marginBottom
    }).styles
  })}
    `;
}), Pi = /* @__PURE__ */ eo("div", {
  target: "e13buv012"
})(({ theme: o, dialogVariant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Dialog) == null ? void 0 : e.content,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Dialog) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.content,
    desktop: {
      ...(u = (d = (p = o.component) == null ? void 0 : p.Dialog) == null ? void 0 : d.content) == null ? void 0 : u.desktop,
      ...(S = (y = (m = (g = (b = o.component) == null ? void 0 : b.Dialog) == null ? void 0 : g.variant) == null ? void 0 : m[t]) == null ? void 0 : y.content) == null ? void 0 : S.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    ...No(n),
    fontFamily: o.typography.font[n.fontFamily || "primary"],
    fontSize: o.typography.size[n.fontSize || "md"],
    fontWeight: n.fontWeight ?? "normal",
    color: n.color || o.typography.color.primary
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...n.desktop,
      fontFamily: n.desktop.fontFamily && o.typography.font[n.desktop.fontFamily],
      fontSize: n.desktop.fontSize && o.typography.size[n.desktop.fontSize]
    }).styles
  })}
    `;
}), Li = /* @__PURE__ */ eo("div", {
  target: "e13buv013"
})(({ theme: o, dialogVariant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I;
  const n = {
    ...(i = (e = (r = o.component) == null ? void 0 : r.Dialog) == null ? void 0 : e.buttons) == null ? void 0 : i.wrapper,
    ...(d = (p = (l = (c = (a = o.component) == null ? void 0 : a.Dialog) == null ? void 0 : c.variant) == null ? void 0 : l[t]) == null ? void 0 : p.buttons) == null ? void 0 : d.wrapper,
    desktop: {
      ...(m = (g = (b = (u = o.component) == null ? void 0 : u.Dialog) == null ? void 0 : b.buttons) == null ? void 0 : g.wrapper) == null ? void 0 : m.desktop,
      ...(I = (v = (w = (h = (S = (y = o.component) == null ? void 0 : y.Dialog) == null ? void 0 : S.variant) == null ? void 0 : h[t]) == null ? void 0 : w.buttons) == null ? void 0 : v.wrapper) == null ? void 0 : I.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: n.flexDirection || "row",
    justifyContent: n.justifyContent || "flex-end",
    gap: n.gap ?? o.spacing(3)
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k(n.desktop).styles
  })}
    `;
}), Pn = {
  Wrapper: Mi,
  Heading: Oi,
  Content: Pi,
  ButtonsWrapper: Li
}, Ga = /* @__PURE__ */ $o.forwardRef(({ show: o, onClose: t, heading: n, dismissButtonLabel: r, confirmButtonLabel: e, variant: i = Oo.PRIMARY, mode: a = "modal", children: c, ...l }, p) => {
  var w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so;
  const d = Io(), u = Mo(null), b = _n(), g = ((x = (C = (I = (v = (w = d.component) == null ? void 0 : w.Dialog) == null ? void 0 : v.variant) == null ? void 0 : I[i]) == null ? void 0 : C.heading) == null ? void 0 : x.level) || ((O = (A = (T = d.component) == null ? void 0 : T.Dialog) == null ? void 0 : A.heading) == null ? void 0 : O.level), m = () => {
    t("dismiss");
  }, y = yt((K, X) => {
    var q;
    (q = u.current) != null && q.open && (u.current.close(), t(K, X));
  }, [
    t
  ]), S = Vt(() => {
    var K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo;
    return Array.isArray(e) ? ((io = (no = (ro = (q = (X = (K = d.component) == null ? void 0 : K.Dialog) == null ? void 0 : X.variant) == null ? void 0 : q[i]) == null ? void 0 : ro.buttons) == null ? void 0 : no.dismiss) == null ? void 0 : io.buttonVariantWhenTwoConfirmButtons) || ((G = (W = (z = (ao = d.component) == null ? void 0 : ao.Dialog) == null ? void 0 : z.buttons) == null ? void 0 : W.dismiss) == null ? void 0 : G.buttonVariantWhenTwoConfirmButtons) || qo.TERTIARY : ((uo = (po = (co = (oo = (Q = (Y = d.component) == null ? void 0 : Y.Dialog) == null ? void 0 : Q.variant) == null ? void 0 : oo[i]) == null ? void 0 : co.buttons) == null ? void 0 : po.dismiss) == null ? void 0 : uo.buttonVariant) || ((vo = (So = (bo = (fo = d.component) == null ? void 0 : fo.Dialog) == null ? void 0 : bo.buttons) == null ? void 0 : So.dismiss) == null ? void 0 : vo.buttonVariant) || qo.SECONDARY;
  }, [
    e,
    (_ = (N = (B = (P = d.component) == null ? void 0 : P.Dialog) == null ? void 0 : B.buttons) == null ? void 0 : N.dismiss) == null ? void 0 : _.buttonVariant,
    (V = (j = (R = (D = d.component) == null ? void 0 : D.Dialog) == null ? void 0 : R.buttons) == null ? void 0 : j.dismiss) == null ? void 0 : V.buttonVariantWhenTwoConfirmButtons,
    (J = (Z = d.component) == null ? void 0 : Z.Dialog) == null ? void 0 : J.variant,
    i
  ]), h = Vt(() => {
    var X, q, ro, no, io, ao, z, W, G, Y;
    const K = ((ao = (io = (no = (ro = (q = (X = d.component) == null ? void 0 : X.Dialog) == null ? void 0 : q.variant) == null ? void 0 : ro[i]) == null ? void 0 : no.buttons) == null ? void 0 : io.confirm) == null ? void 0 : ao.buttonVariant) || ((Y = (G = (W = (z = d.component) == null ? void 0 : z.Dialog) == null ? void 0 : W.buttons) == null ? void 0 : G.confirm) == null ? void 0 : Y.buttonVariant);
    return typeof e == "string" ? [
      {
        buttonVariant: Array.isArray(K) ? K[0] : K,
        label: e
      }
    ] : e.map((Q, oo) => ({
      buttonVariant: Array.isArray(K) ? K[oo] : K || oo === 0 ? qo.SECONDARY : qo.PRIMARY,
      label: Q
    }));
  }, [
    e,
    (E = (H = (L = (F = d.component) == null ? void 0 : F.Dialog) == null ? void 0 : L.buttons) == null ? void 0 : H.confirm) == null ? void 0 : E.buttonVariant,
    (so = (to = d.component) == null ? void 0 : to.Dialog) == null ? void 0 : so.variant,
    i
  ]);
  return Eo(() => {
    u.current && (o && !u.current.open ? a === "modal" ? u.current.showModal() : u.current.show() : !o && u.current.open && y("prop-change"));
  }, [
    y,
    a,
    o
  ]), he(p, () => u.current), /* @__PURE__ */ wo(Pn.Wrapper, {
    ...l,
    dialogVariant: i,
    "aria-labelledby": b,
    ref: u,
    onCancel: m,
    children: [
      /* @__PURE__ */ M(Pn.Heading, {
        level: g || "3",
        id: b,
        tabIndex: void 0,
        children: n
      }),
      c && /* @__PURE__ */ M(Pn.Content, {
        dialogVariant: i,
        children: c
      }),
      /* @__PURE__ */ wo(Pn.ButtonsWrapper, {
        dialogVariant: i,
        children: [
          /* @__PURE__ */ M(St, {
            variant: S,
            onClick: () => {
              y("dismiss");
            },
            children: r
          }),
          h.map(({ buttonVariant: K, label: X }, q) => /* @__PURE__ */ M(St, {
            variant: K,
            onClick: () => {
              y("confirm", q);
            },
            children: X
          }, `confirm-button-${q}`))
        ]
      })
    ]
  });
}), _i = (o, t) => {
  var e, i, a, c, l, p, d, u, b, g, m, y, S, h;
  const n = {
    ...No((i = (e = o.component) == null ? void 0 : e.DisguisedRadioButton) == null ? void 0 : i.icon, [
      "checkedStyle"
    ]),
    ...(p = (l = (c = (a = o.component) == null ? void 0 : a.DisguisedRadioButton) == null ? void 0 : c.variant) == null ? void 0 : l[t]) == null ? void 0 : p.icon
  }, r = {
    ...No((b = (u = (d = o.component) == null ? void 0 : d.DisguisedRadioButton) == null ? void 0 : u.desktop) == null ? void 0 : b.icon, [
      "checkedStyle"
    ]),
    ...(h = (S = (y = (m = (g = o.component) == null ? void 0 : g.DisguisedRadioButton) == null ? void 0 : m.variant) == null ? void 0 : y[t]) == null ? void 0 : S.desktop) == null ? void 0 : h.icon
  };
  return `
        ${k(n).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k(r).styles
  })}
    `;
}, Vi = (o, t) => {
  var e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C;
  const n = ((l = (c = (a = (i = (e = o.component) == null ? void 0 : e.DisguisedRadioButton) == null ? void 0 : i.variant) == null ? void 0 : a[t]) == null ? void 0 : c.icon) == null ? void 0 : l.checkedStyle) || ((u = (d = (p = o.component) == null ? void 0 : p.DisguisedRadioButton) == null ? void 0 : d.icon) == null ? void 0 : u.checkedStyle), r = ((h = (S = (y = (m = (g = (b = o.component) == null ? void 0 : b.DisguisedRadioButton) == null ? void 0 : g.variant) == null ? void 0 : m[t]) == null ? void 0 : y.desktop) == null ? void 0 : S.icon) == null ? void 0 : h.checkedStyle) || ((C = (I = (v = (w = o.component) == null ? void 0 : w.DisguisedRadioButton) == null ? void 0 : v.desktop) == null ? void 0 : I.icon) == null ? void 0 : C.checkedStyle);
  return `
        ${n}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: r || ""
  })}
    `;
}, ue = {
  disguisedRadioButtonIcon: _i,
  disguisedRadioButtonIconChecked: Vi
}, ji = /* @__PURE__ */ eo("label", {
  target: "e85wf00"
})(({ theme: o, variant: t, withIcon: n }) => {
  var a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x;
  const r = {
    ...(c = (a = o.component) == null ? void 0 : a.DisguisedRadioButton) == null ? void 0 : c.label,
    ...(u = (d = (p = (l = o.component) == null ? void 0 : l.DisguisedRadioButton) == null ? void 0 : p.variant) == null ? void 0 : d[t]) == null ? void 0 : u.label
  }, e = {
    ...(m = (g = (b = o.component) == null ? void 0 : b.DisguisedRadioButton) == null ? void 0 : g.desktop) == null ? void 0 : m.label,
    ...(v = (w = (h = (S = (y = o.component) == null ? void 0 : y.DisguisedRadioButton) == null ? void 0 : S.variant) == null ? void 0 : h[t]) == null ? void 0 : w.desktop) == null ? void 0 : v.label
  }, i = n ? ((x = (C = (I = o.component) == null ? void 0 : I.DisguisedRadioButton) == null ? void 0 : C.withIcon) == null ? void 0 : x.label) || {} : {};
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    position: "relative",
    margin: 0,
    padding: 0,
    border: "none",
    boxShadow: "none",
    ...r,
    display: r.display || "inline-flex",
    textAlign: r.textAlign || "inherit",
    cursor: r.cursor || "pointer",
    ...i
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k(e).styles
  })}
        
        // Webkit browsers tend to add a background color on mobile when tapping a link or similar, this removes it.
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;
    `;
}), bt = /* @__PURE__ */ eo("span", {
  target: "e85wf01"
})(({ theme: o, variant: t, withIcon: n }) => {
  var y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po;
  const r = {
    ...(y = o.component) == null ? void 0 : y.DisguisedRadioButton,
    ...(w = (h = (S = o.component) == null ? void 0 : S.DisguisedRadioButton) == null ? void 0 : h.variant) == null ? void 0 : w[t],
    defaultStyle: `
            ${((I = (v = o.component) == null ? void 0 : v.DisguisedRadioButton) == null ? void 0 : I.defaultStyle) || ""}
            ${((A = (T = (x = (C = o.component) == null ? void 0 : C.DisguisedRadioButton) == null ? void 0 : x.variant) == null ? void 0 : T[t]) == null ? void 0 : A.defaultStyle) || ""}
        `
  }, e = `
            all: revert;
            box-sizing: border-box;
            display: block;
            ${r.defaultStyle || `
                    background: transparent;
                    border: 0;
                    font-family: inherit;
                    font-size: inherit;
                    color: inherit;
                `}
        `, i = Fo(r.hoverStyle), a = Yo(r.activeStyle), c = it(r.invalidStyle), l = n ? `
            ${((_ = (N = (B = (P = (O = o.component) == null ? void 0 : O.DisguisedRadioButton) == null ? void 0 : P.variant) == null ? void 0 : B[t]) == null ? void 0 : N.withIcon) == null ? void 0 : _.defaultStyle) || ""}
            ${((j = (R = (D = o.component) == null ? void 0 : D.DisguisedRadioButton) == null ? void 0 : R.withIcon) == null ? void 0 : j.defaultStyle) || ""}
        ` : "", p = {
    ...(Z = (V = o.component) == null ? void 0 : V.DisguisedRadioButton) == null ? void 0 : Z.desktop,
    ...(H = (L = (F = (J = o.component) == null ? void 0 : J.DisguisedRadioButton) == null ? void 0 : F.variant) == null ? void 0 : L[t]) == null ? void 0 : H.desktop,
    defaultStyle: `
            ${((so = (to = (E = o.component) == null ? void 0 : E.DisguisedRadioButton) == null ? void 0 : to.desktop) == null ? void 0 : so.defaultStyle) || ""}
            ${((no = (ro = (q = (X = (K = o.component) == null ? void 0 : K.DisguisedRadioButton) == null ? void 0 : X.variant) == null ? void 0 : q[t]) == null ? void 0 : ro.desktop) == null ? void 0 : no.defaultStyle) || ""}
        `
  }, d = p.defaultStyle || "", u = Fo(p.hoverStyle), b = Yo(p.activeStyle), g = it(p.invalidStyle), m = n ? `
            ${(Y = (G = (W = (z = (ao = (io = o.component) == null ? void 0 : io.DisguisedRadioButton) == null ? void 0 : ao.variant) == null ? void 0 : z[t]) == null ? void 0 : W.withIcon) == null ? void 0 : G.desktop) == null ? void 0 : Y.defaultStyle}
            ${(po = (co = (oo = (Q = o.component) == null ? void 0 : Q.DisguisedRadioButton) == null ? void 0 : oo.withIcon) == null ? void 0 : co.desktop) == null ? void 0 : po.defaultStyle}
        ` : "";
  return k`
    ${e}
    ${i}
        ${a}
        ${c}
        ${l}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${d}
                ${u}
                ${b}
                ${g}
                ${m}
            `
  })}
  `;
}), Hi = /* @__PURE__ */ eo(ui, {
  shouldForwardProp: (o) => Jn(o),
  target: "e85wf02"
})(({ theme: o, variant: t }) => {
  var e, i, a, c, l, p, d, u, b, g;
  const n = {
    ...(e = o.component) == null ? void 0 : e.DisguisedRadioButton,
    ...(c = (a = (i = o.component) == null ? void 0 : i.DisguisedRadioButton) == null ? void 0 : a.variant) == null ? void 0 : c[t]
  }, r = {
    ...(p = (l = o.component) == null ? void 0 : l.DisguisedRadioButton) == null ? void 0 : p.desktop,
    ...(g = (b = (u = (d = o.component) == null ? void 0 : d.DisguisedRadioButton) == null ? void 0 : u.variant) == null ? void 0 : b[t]) == null ? void 0 : g.desktop
  };
  return `
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 1px;
        border: 0;
        background: transparent;
        opacity: 0.01;

        ${_o({
    focusStyle: n.focusStyle,
    focusVisibleStyle: n.focusVisibleStyle || "outline: none; border: none; box-shadow: none;",
    appendToSelector: `+ ${bt}`
  })}

        ${Ln(n.checkedStyle, void 0, `+ ${bt}`)}
        ${jt({
    focusVisibleStyle: n.checkedAndFocusVisibleStyle,
    prependToSelector: ":checked",
    appendToSelector: `+ ${bt}`
  })}
        ${it(n.invalidStyle, void 0, `+ ${bt}`)}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${_o({
      focusStyle: r.focusStyle,
      focusVisibleStyle: r.focusVisibleStyle,
      appendToSelector: `+ ${bt}`
    })}
        
                ${Ln(r.checkedStyle, void 0, `+ ${bt}`)}
                ${jt({
      focusVisibleStyle: r.checkedAndFocusVisibleStyle,
      prependToSelector: ":checked",
      appendToSelector: `+ ${bt}`
    })}
                ${it(r.invalidStyle, void 0, `+ ${bt}`)}
            `
  })}
    `;
}), Ka = /* @__PURE__ */ $o.forwardRef(({ variant: o = Oo.PRIMARY, radioButtonProps: t, content: n, icon: r, iconPlacement: e = "beforeContent", children: i, ...a }, c) => {
  const l = Io(), p = r ? /* @__PURE__ */ $o.cloneElement(r, {
    css: [
      ue.disguisedRadioButtonIcon(l, o),
      t.checked && ue.disguisedRadioButtonIconChecked(l, o),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      r.props.css
    ]
  }) : void 0, d = !!p;
  return /* @__PURE__ */ wo(ji, {
    variant: o,
    withIcon: d,
    ref: c,
    ...a,
    children: [
      /* @__PURE__ */ M(Hi, {
        variant: o,
        ...t
      }),
      /* @__PURE__ */ wo(bt, {
        variant: o,
        withIcon: d,
        children: [
          d && e === "beforeContent" && p,
          n ?? i,
          d && e === "afterContent" && p
        ]
      })
    ]
  });
}), Gi = () => /* @__PURE__ */ k({
  float: "left"
}), Ki = {
  legend: Gi
}, Ui = /* @__PURE__ */ eo("div", {
  target: "e1boybt30"
})(({ theme: o, isInvalid: t }) => {
  var r, e, i, a, c;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Fieldset) == null ? void 0 : e.childrenWrapper,
    desktop: {
      ...(c = (a = (i = o.component) == null ? void 0 : i.Fieldset) == null ? void 0 : a.childrenWrapper) == null ? void 0 : c.desktop
    }
  };
  return k`
        all: revert;
        box-sizing: border-box;
        display: ${n.display || "block"}
        transition: ${n.transition || "none"}
        margin: 0;
        padding: 0;
        clear: both;
        ${t && n.invalidStyle || ""}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${k(n.desktop).styles}
                ${t && n.desktop.invalidStyle || ""}
            `
  })}
    `;
}), Zi = /* @__PURE__ */ eo("fieldset", {
  target: "e1boybt31"
})(({ theme: o, variant: t, isInvalid: n }) => {
  var e, i, a, c, l, p, d, u, b, g, m, y, S;
  const r = {
    ...((e = o.component) == null ? void 0 : e.Fieldset) || {},
    ...((c = (a = (i = o.component) == null ? void 0 : i.Fieldset) == null ? void 0 : a.variant) == null ? void 0 : c[t]) || {},
    desktop: {
      ...((p = (l = o.component) == null ? void 0 : l.Fieldset) == null ? void 0 : p.desktop) || {},
      ...((g = (b = (u = (d = o.component) == null ? void 0 : d.Fieldset) == null ? void 0 : u.variant) == null ? void 0 : b[t]) == null ? void 0 : g.desktop) || {}
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    display: "block",
    margin: 0,
    padding: 0,
    border: 0,
    borderRadius: 0,
    ...No(r, [
      "childrenWrapper"
    ])
  }).styles}
        ${n && r.invalidStyle || ""}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${k(r.desktop).styles}
                ${n && ((m = r.desktop) == null ? void 0 : m.invalidStyle) || ""}
            `
  })}
        ${it((S = (y = o.component) == null ? void 0 : y.Fieldset) == null ? void 0 : S.invalidStyle)}
    `;
}), qi = /* @__PURE__ */ $o.forwardRef(({ variant: o = Oo.PRIMARY, legend: t, legendVariant: n, hasError: r = !1, errorMessageElementId: e, children: i, ...a }, c) => /* @__PURE__ */ wo(Zi, {
  variant: o,
  isInvalid: r,
  ref: c,
  "aria-invalid": r,
  "aria-errormessage": r ? e : void 0,
  ...a,
  children: [
    t && /* @__PURE__ */ M(ke, {
      variant: n,
      css: Ki.legend,
      children: t
    }),
    t ? /* @__PURE__ */ M(Ui, {
      isInvalid: r,
      children: i
    }) : i
  ]
})), Yi = (o) => {
  var t, n, r, e, i, a;
  return `
    ${k({
    margin: (r = (n = (t = o.component) == null ? void 0 : t.FormChoiceGroup) == null ? void 0 : n.legend) == null ? void 0 : r.margin
  }).styles}
    ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...(a = (i = (e = o.component) == null ? void 0 : e.FormChoiceGroup) == null ? void 0 : i.legend) == null ? void 0 : a.desktop
    }).styles
  })}
`;
}, Qi = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v;
  return `
    ${k({
    ...No((n = (t = o.component) == null ? void 0 : t.FormChoiceGroup) == null ? void 0 : n.description),
    fontFamily: (i = (e = (r = o.component) == null ? void 0 : r.FormChoiceGroup) == null ? void 0 : e.description) != null && i.fontFamily ? o.typography.font[o.component.FormChoiceGroup.description.fontFamily] : void 0,
    fontSize: (l = (c = (a = o.component) == null ? void 0 : a.FormChoiceGroup) == null ? void 0 : c.description) != null && l.fontSize ? o.typography.size[o.component.FormChoiceGroup.description.fontSize] : void 0
  }).styles}

    ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...(u = (d = (p = o.component) == null ? void 0 : p.FormChoiceGroup) == null ? void 0 : d.description) == null ? void 0 : u.desktop,
      fontFamily: (y = (m = (g = (b = o.component) == null ? void 0 : b.FormChoiceGroup) == null ? void 0 : g.description) == null ? void 0 : m.desktop) != null && y.fontFamily ? o.typography.font[o.component.FormChoiceGroup.description.desktop.fontFamily] : void 0,
      fontSize: (v = (w = (h = (S = o.component) == null ? void 0 : S.FormChoiceGroup) == null ? void 0 : h.description) == null ? void 0 : w.desktop) != null && v.fontSize ? o.typography.size[o.component.FormChoiceGroup.description.desktop.fontSize] : void 0
    }).styles
  })}
`;
}, fe = {
  formChoiceGroupLegend: Yi,
  formChoiceGroupDescription: Qi
}, Ji = /* @__PURE__ */ eo(oi, {
  target: "e1dmiba90"
})(({ theme: o }) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo, Ro, To, Ao, Do, Vo, ot, tt, at, st, Wo, Ko, ct, nt, lt, et, jo, pt, Bo, dt, ut;
  return `
        ${k({
    display: "grid",
    gridTemplateColumns: ((r = (n = (t = o.component) == null ? void 0 : t.FormChoiceGroup) == null ? void 0 : n.choice) == null ? void 0 : r.inputElementPlacement) === "right" ? "1fr auto" : "auto 1fr",
    ...((a = (i = (e = o.component) == null ? void 0 : e.FormChoiceGroup) == null ? void 0 : i.choice) == null ? void 0 : a.inputElementPlacement) === "right" && {
      "> :first-child": {
        order: 2
      }
    },
    gap: o.spacing(2),
    alignItems: "center",
    cursor: "pointer",
    ...No((l = (c = o.component) == null ? void 0 : c.FormChoiceGroup) == null ? void 0 : l.choice, [
      "inputElementPlacement",
      "hoverStyle",
      "focusWithinStyle"
    ]),
    fontFamily: (u = (d = (p = o.component) == null ? void 0 : p.FormChoiceGroup) == null ? void 0 : d.choice) != null && u.fontFamily ? o.typography.font[o.component.FormChoiceGroup.choice.fontFamily] : void 0,
    fontSize: (m = (g = (b = o.component) == null ? void 0 : b.FormChoiceGroup) == null ? void 0 : g.choice) != null && m.fontSize ? o.typography.size[o.component.FormChoiceGroup.choice.fontSize] : void 0
  }).styles}

        ${Fo((h = (S = (y = o.component) == null ? void 0 : y.FormChoiceGroup) == null ? void 0 : S.choice) == null ? void 0 : h.hoverStyle)}
        ${mt((I = (v = (w = o.component) == null ? void 0 : w.FormChoiceGroup) == null ? void 0 : v.choice) == null ? void 0 : I.focusWithinStyle)}

        :has(> :first-child:checked) {
            ${k({
    ...No((T = (x = (C = o.component) == null ? void 0 : C.FormChoiceGroup) == null ? void 0 : x.choice) == null ? void 0 : T.selected, [
      "hoverStyle",
      "focusWithinStyle"
    ]),
    fontFamily: (B = (P = (O = (A = o.component) == null ? void 0 : A.FormChoiceGroup) == null ? void 0 : O.choice) == null ? void 0 : P.selected) != null && B.fontFamily ? o.typography.font[o.component.FormChoiceGroup.choice.selected.fontFamily] : void 0,
    fontSize: (R = (D = (_ = (N = o.component) == null ? void 0 : N.FormChoiceGroup) == null ? void 0 : _.choice) == null ? void 0 : D.selected) != null && R.fontSize ? o.typography.size[o.component.FormChoiceGroup.choice.selected.fontSize] : void 0
  }).styles}

            ${Fo((J = (Z = (V = (j = o.component) == null ? void 0 : j.FormChoiceGroup) == null ? void 0 : V.choice) == null ? void 0 : Z.selected) == null ? void 0 : J.hoverStyle)}
            ${mt((E = (H = (L = (F = o.component) == null ? void 0 : F.FormChoiceGroup) == null ? void 0 : L.choice) == null ? void 0 : H.selected) == null ? void 0 : E.focusWithinStyle)}
        }

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: `
                ${k({
      ...No((so = (to = o.component) == null ? void 0 : to.FormChoiceGroup) == null ? void 0 : so.choice, [
        "hoverStyle",
        "focusWithinStyle"
      ]),
      fontFamily: (ro = (q = (X = (K = o.component) == null ? void 0 : K.FormChoiceGroup) == null ? void 0 : X.choice) == null ? void 0 : q.desktop) != null && ro.fontFamily ? o.typography.font[o.component.FormChoiceGroup.choice.desktop.fontFamily] : void 0,
      fontSize: (z = (ao = (io = (no = o.component) == null ? void 0 : no.FormChoiceGroup) == null ? void 0 : io.choice) == null ? void 0 : ao.desktop) != null && z.fontSize ? o.typography.size[o.component.FormChoiceGroup.choice.desktop.fontSize] : void 0
    }).styles}
        
                ${Fo((Q = (Y = (G = (W = o.component) == null ? void 0 : W.FormChoiceGroup) == null ? void 0 : G.choice) == null ? void 0 : Y.desktop) == null ? void 0 : Q.hoverStyle)}
                ${mt((uo = (po = (co = (oo = o.component) == null ? void 0 : oo.FormChoiceGroup) == null ? void 0 : co.choice) == null ? void 0 : po.desktop) == null ? void 0 : uo.focusWithinStyle)}

                :has(> :first-child:checked) {
                    ${k({
      ...No((vo = (So = (bo = (fo = o.component) == null ? void 0 : fo.FormChoiceGroup) == null ? void 0 : bo.choice) == null ? void 0 : So.desktop) == null ? void 0 : vo.selected, [
        "hoverStyle",
        "focusWithinStyle"
      ]),
      fontFamily: (Vo = (Do = (Ao = (To = (Ro = o.component) == null ? void 0 : Ro.FormChoiceGroup) == null ? void 0 : To.choice) == null ? void 0 : Ao.desktop) == null ? void 0 : Do.selected) != null && Vo.fontFamily ? o.typography.font[o.component.FormChoiceGroup.choice.desktop.selected.fontFamily] : void 0,
      fontSize: (Wo = (st = (at = (tt = (ot = o.component) == null ? void 0 : ot.FormChoiceGroup) == null ? void 0 : tt.choice) == null ? void 0 : at.desktop) == null ? void 0 : st.selected) != null && Wo.fontSize ? o.typography.size[o.component.FormChoiceGroup.choice.desktop.selected.fontSize] : void 0
    }).styles}
        
                    ${Fo((et = (lt = (nt = (ct = (Ko = o.component) == null ? void 0 : Ko.FormChoiceGroup) == null ? void 0 : ct.choice) == null ? void 0 : nt.desktop) == null ? void 0 : lt.selected) == null ? void 0 : et.hoverStyle)}
                    ${mt((ut = (dt = (Bo = (pt = (jo = o.component) == null ? void 0 : jo.FormChoiceGroup) == null ? void 0 : pt.choice) == null ? void 0 : Bo.desktop) == null ? void 0 : dt.selected) == null ? void 0 : ut.focusWithinStyle)}
                }
            `
  })}
    `;
}), Ua = /* @__PURE__ */ $o.forwardRef(({ groupLabel: o, description: t, choices: n, ...r }, e) => {
  var a, c, l, p, d, u, b, g;
  const i = Io();
  return /* @__PURE__ */ wo(qi, {
    variant: (l = (c = (a = i.component) == null ? void 0 : a.FormChoiceGroup) == null ? void 0 : c.fieldset) == null ? void 0 : l.variant,
    ref: e,
    ...r,
    children: [
      /* @__PURE__ */ M(ke, {
        variant: (u = (d = (p = i.component) == null ? void 0 : p.FormChoiceGroup) == null ? void 0 : d.legend) == null ? void 0 : u.variant,
        css: fe.formChoiceGroupLegend,
        children: o
      }),
      t && /* @__PURE__ */ M(li, {
        css: fe.formChoiceGroupDescription,
        children: t
      }),
      /* @__PURE__ */ M(mi, {
        ...(g = (b = i.component) == null ? void 0 : b.FormChoiceGroup) == null ? void 0 : g.choicesWrapper,
        children: n.map(({ inputComponent: m, label: y }) => /* @__PURE__ */ wo(Ji, {
          children: [
            m,
            y
          ]
        }, y))
      })
    ]
  });
}), Xi = (o) => {
  var t, n, r, e, i, a, c, l, p;
  return /* @__PURE__ */ k("all:revert;box-sizing:border-box;display:grid;grid-template-columns:auto 1fr auto;column-gap:", ((n = (t = o.component) == null ? void 0 : t.IntegerInput) == null ? void 0 : n.columnGap) ?? o.spacing(2), ";align-items:center;width:", ((e = (r = o.component) == null ? void 0 : r.IntegerInput) == null ? void 0 : e.width) ?? "100%", ";max-width:", ((a = (i = o.component) == null ? void 0 : i.IntegerInput) == null ? void 0 : a.maxWidth) ?? "100%", ";margin:0;padding:0;", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: ((p = (l = (c = o.component) == null ? void 0 : c.IntegerInput) == null ? void 0 : l.desktop) == null ? void 0 : p.columnGap) != null ? `column-gap: ${o.component.IntegerInput.desktop.columnGap};` : ""
  }));
}, oa = (o) => {
  var t, n, r;
  return /* @__PURE__ */ k(((r = (n = (t = o.component) == null ? void 0 : t.IntegerInput) == null ? void 0 : n.stepperButton) == null ? void 0 : r.style) || "");
}, ta = (o) => {
  var t, n, r;
  return /* @__PURE__ */ k(((r = (n = (t = o.component) == null ? void 0 : t.IntegerInput) == null ? void 0 : n.stepperButton) == null ? void 0 : r.subtractStyle) || "");
}, na = (o) => {
  var t, n, r;
  return /* @__PURE__ */ k(((r = (n = (t = o.component) == null ? void 0 : t.IntegerInput) == null ? void 0 : n.stepperButton) == null ? void 0 : r.additionStyle) || "");
}, sn = {
  stepperButtonsWrapper: Xi,
  stepperButton: oa,
  stepperButtonSubtract: ta,
  stepperButtonAddition: na
}, ea = /* @__PURE__ */ $o.forwardRef(({ value: o, onChange: t, min: n, max: r, allowLowerThanMin: e = !1, allowHigherThanMax: i = !1, step: a = 1, locale: c = "sv-SE", debounceTime: l = 800, displayStepperButtons: p = !1, variant: d, suffix: u, hasError: b, clearOnFocusIfZero: g, allowEmptyValue: m = !1, autoSetMinValue: y = !0, autoSetMaxValue: S = !0, disableFormatting: h = !1, decrementStepperTitle: w, incrementStepperTitle: v, labelId: I, suffixAriaLabel: C, ...x }, T) => {
  var X, q, ro, no, io, ao;
  const A = Io(), [O, P] = Co(!1);
  if (p) {
    const z = [
      {
        prop: "labelId",
        propName: I
      },
      {
        prop: "decrementStepperTitle",
        propName: w
      },
      {
        prop: "incrementStepperTitle",
        propName: v
      }
    ].filter(({ propName: W }) => !W);
    z.length > 0 && console.warn(`Accessibility warning: The following props are required for stepper buttons but are missing: ${z.map(({ prop: W }) => W).join(", ")}. Please provide these props to avoid accessibility issues.`);
  }
  const B = (z) => z != null ? h ? z.toString() : z.toLocaleString(c) : "", [N, _] = Co({
    asNumber: o,
    asText: B(o)
  }), [D, R] = Co(N.asText.length), j = Mo(null), V = Ht(t, l);
  Eo(() => () => {
    V.cancel();
  }, [
    V
  ]), he(T, () => j.current), Eo(() => {
    j.current && document.activeElement === j.current && j.current.setSelectionRange(D, D);
  }, [
    D,
    N.asText
  ]), Eo(() => {
    O || _({
      asNumber: o,
      asText: B(o)
    });
  }, [
    o,
    c
  ]);
  const Z = (z) => {
    if (!z) return "";
    const W = Number(z.replace(/[^\d]/g, ""));
    return h ? W.toString() : Number.isNaN(W) ? "" : W.toLocaleString(c);
  }, J = (z) => Number(Ge(z)), F = (z, W = !1) => {
    if (Number.isNaN(z.asNumber) || z.asNumber === o) {
      V.cancel();
      return;
    }
    if (m && z.asText === "") {
      V(null);
      return;
    }
    if (!e && typeof n == "number" && z.asNumber !== null && z.asNumber < n) {
      if (W && y) {
        _({
          asNumber: n,
          asText: B(n)
        }), V(n);
        return;
      }
      V.cancel();
      return;
    }
    if (!i && typeof r == "number" && z.asNumber !== null && z.asNumber > r) {
      if (W && S) {
        _({
          asNumber: r,
          asText: B(r)
        }), V(r);
        return;
      }
      V.cancel();
      return;
    }
    V(z.asNumber ?? 0);
  }, L = (z) => {
    const { value: W, selectionStart: G } = z.target;
    if (m && W === "") {
      _({
        asNumber: null,
        asText: ""
      }), V(null);
      return;
    }
    if (h) {
      const fo = Number(W);
      Number.isNaN(fo) || (_({
        asNumber: fo,
        asText: W
      }), F({
        asNumber: fo,
        asText: W
      })), R(G ?? W.length);
      return;
    }
    if (W.replace(/\xa0/g, "").startsWith("0") || W.length === 0) {
      V.cancel();
      const fo = W.replace(/[^\d\s]/g, "");
      _({
        asNumber: N.asNumber,
        asText: fo
      }), R(G ?? fo.length);
      return;
    }
    const Y = Z(W), Q = J(Y), oo = Y.split(" ").length - 1, co = N.asText.split(" ").length - 1, po = oo < co ? Math.abs(co - oo) * -1 : Math.abs(co - oo);
    _({
      asNumber: Number.isNaN(Q) ? N.asNumber : Q,
      asText: Y
    }), F({
      asNumber: Q,
      asText: Y
    });
    const uo = (G ?? 0) + po;
    po < uo && uo < 1 ? R(Y.length) : R(uo < 0 ? 0 : uo);
  }, H = (z) => {
    const { key: W, currentTarget: G } = z, Y = N.asNumber ?? 0;
    if (W === "ArrowUp") {
      const Q = Y + a, oo = {
        asNumber: Q,
        asText: B(Q)
      };
      _(oo), F(oo, !0), R(G.selectionStart ?? 0);
      return;
    }
    if (W === "ArrowDown") {
      const Q = Y - a, oo = {
        asNumber: Q,
        asText: B(Q)
      };
      _(oo), F(oo, !0), R(G.selectionStart ?? 0);
    }
  }, E = (z) => {
    const W = N.asNumber ?? 0, G = z === "add" ? W + a : W - a, Y = {
      asNumber: G,
      asText: B(G)
    };
    _(Y), F(Y, !0);
  }, to = () => {
    if (P(!1), m && N.asText === "") {
      t(null);
      return;
    }
    const z = {
      asNumber: J(N.asText),
      asText: Z(N.asText)
    };
    !e && typeof n == "number" && z.asNumber !== null && z.asNumber < n && y && (z.asNumber = n, z.asText = B(n)), !i && typeof r == "number" && z.asNumber !== null && z.asNumber > r && S && (z.asNumber = r, z.asText = B(r));
    const W = N.asText.length === 0 || N.asNumber === o, G = o !== null && (typeof n == "number" && o < n || typeof r == "number" && o > r);
    W && G && (z.asNumber = o, z.asText = B(o)), (z.asNumber !== N.asNumber || z.asText !== N.asText) && (_(z), t(z.asNumber));
  }, so = () => {
    P(!0), g && N.asNumber === 0 && (_({
      asText: "",
      asNumber: 0
    }), R(0));
  }, K = /* @__PURE__ */ M(Xn, {
    type: "text",
    id: x.id,
    inputMode: "numeric",
    pattern: "^[\\d\\s]+$",
    variant: d,
    suffix: u,
    value: N.asText,
    onFocus: so,
    onInput: L,
    onKeyUp: H,
    onBlur: to,
    ref: j,
    hasError: b,
    placeholder: x.placeholder,
    suffixAriaLabel: C,
    ...p ? {} : x
  });
  return p ? /* @__PURE__ */ wo("div", {
    css: sn.stepperButtonsWrapper,
    role: "group",
    "aria-labelledby": I,
    ...x,
    children: [
      /* @__PURE__ */ M(St, {
        variant: qo.CLEAN,
        onClick: () => {
          E("subtract");
        },
        disabled: typeof n == "number" && N.asNumber !== null && N.asNumber <= n && !e,
        css: [
          sn.stepperButton,
          sn.stepperButtonSubtract
        ],
        title: w,
        children: (ro = (q = (X = A.component) == null ? void 0 : X.IntegerInput) == null ? void 0 : q.stepperButton) != null && ro.subtractContent ? /* @__PURE__ */ M(zo, {
          instance: A.component.IntegerInput.stepperButton.subtractContent
        }) : "-"
      }),
      K,
      /* @__PURE__ */ M(St, {
        variant: qo.CLEAN,
        onClick: () => {
          E("add");
        },
        disabled: typeof r == "number" && N.asNumber !== null && N.asNumber >= r && !i,
        css: [
          sn.stepperButton,
          sn.stepperButtonAddition
        ],
        title: v,
        children: (ao = (io = (no = A.component) == null ? void 0 : no.IntegerInput) == null ? void 0 : io.stepperButton) != null && ao.additionContent ? /* @__PURE__ */ M(zo, {
          instance: A.component.IntegerInput.stepperButton.additionContent
        }) : "+"
      })
    ]
  }) : K;
}), ra = /* @__PURE__ */ eo("div", {
  target: "e1ewlx9x0"
})(({ theme: o, notificationVariant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Notification) == null ? void 0 : e.wrapper,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Notification) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.wrapper,
    desktop: {
      ...(u = (d = (p = o.component) == null ? void 0 : p.Notification) == null ? void 0 : d.wrapper) == null ? void 0 : u.desktop,
      ...(S = (y = (m = (g = (b = o.component) == null ? void 0 : b.Notification) == null ? void 0 : g.variant) == null ? void 0 : m[t]) == null ? void 0 : y.wrapper) == null ? void 0 : S.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    position: "relative",
    boxSizing: "border-box",
    padding: n.padding ?? 0,
    background: n.background,
    border: n.border,
    borderTop: n.borderTop,
    borderRight: n.borderRight,
    borderBottom: n.borderBottom,
    borderLeft: n.borderLeft,
    borderRadius: n.borderRadius,
    boxShadow: n.boxShadow
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k(n.desktop).styles
  })}
    `;
}), ia = /* @__PURE__ */ eo("div", {
  target: "e1ewlx9x1"
})(({ theme: o, notificationVariant: t }) => {
  var r, e, i, a, c, l;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Notification) == null ? void 0 : e.content,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Notification) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.content
  };
  return k({
    margin: 0,
    display: "flex",
    gap: o.spacing(2),
    alignItems: "flex-start",
    fontFamily: o.typography.font[n.fontFamily || "primary"],
    fontSize: o.typography.size[n.fontSize || "md"],
    fontWeight: n.fontWeight ?? "normal",
    color: n.color || o.typography.color.primary,
    ...n
  });
}), aa = /* @__PURE__ */ eo(St, {
  target: "e1ewlx9x2"
})(({ theme: o, notificationVariant: t }) => {
  var r, e, i, a, c, l;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Notification) == null ? void 0 : e.dismissButton,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Notification) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.dismissButton
  };
  return k({
    ...No(n, [
      "buttonVariant",
      "icon"
    ]),
    position: "absolute",
    cursor: "pointer",
    top: n.top ?? o.spacing(1),
    bottom: n.bottom,
    left: n.left,
    right: n.right ?? o.spacing(1)
  });
}), sa = /* @__PURE__ */ eo("div", {
  target: "e1ewlx9x3"
})(({ theme: o, notificationVariant: t }) => {
  var r, e, i, a, c, l;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.Notification) == null ? void 0 : e.icon,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.Notification) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.icon
  };
  return k({
    flexShrink: 0,
    ...n
  });
}), ca = /* @__PURE__ */ eo("div", {
  target: "e1ewlx9x4"
})("flex:1;"), cn = {
  Wrapper: ra,
  Content: ia,
  DismissButton: aa,
  IconWrapper: sa,
  TextContent: ca
}, Za = /* @__PURE__ */ $o.forwardRef(({ variant: o = Oo.PRIMARY, children: t, isDismissible: n = !1, onDismiss: r, dismissButtonTitle: e, icon: i, ...a }, c) => {
  var m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _;
  const [l, p] = Co(!1), d = Io(), u = ((w = (h = (S = (y = (m = d.component) == null ? void 0 : m.Notification) == null ? void 0 : y.variant) == null ? void 0 : S[o]) == null ? void 0 : h.dismissButton) == null ? void 0 : w.buttonVariant) || ((C = (I = (v = d.component) == null ? void 0 : v.Notification) == null ? void 0 : I.dismissButton) == null ? void 0 : C.buttonVariant) || qo.CLEAN, b = ((P = (O = (A = (T = (x = d.component) == null ? void 0 : x.Notification) == null ? void 0 : T.variant) == null ? void 0 : A[o]) == null ? void 0 : O.dismissButton) == null ? void 0 : P.icon) || ((_ = (N = (B = d.component) == null ? void 0 : B.Notification) == null ? void 0 : N.dismissButton) == null ? void 0 : _.icon) || Gt.Cross, g = yt(() => {
    p(!0), typeof r == "function" && r();
  }, [
    r
  ]);
  return l ? null : /* @__PURE__ */ wo(cn.Wrapper, {
    notificationVariant: o,
    role: "note",
    ref: c,
    ...a,
    children: [
      /* @__PURE__ */ wo(cn.Content, {
        notificationVariant: o,
        children: [
          i && /* @__PURE__ */ M(cn.IconWrapper, {
            notificationVariant: o,
            children: i
          }),
          /* @__PURE__ */ M(cn.TextContent, {
            children: t
          })
        ]
      }),
      n && /* @__PURE__ */ M(cn.DismissButton, {
        "aria-label": e,
        notificationVariant: o,
        variant: u,
        onClick: g,
        title: e,
        children: /* @__PURE__ */ M(b, {})
      })
    ]
  });
}), la = /* @__PURE__ */ eo("div", {
  target: "e1y191v80"
})("all:revert;box-sizing:border-box;position:relative;margin:0;padding:0;"), pa = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z, W, G, Y, Q, oo, co, po, uo, fo, bo, So, vo, Ro, To, Ao, Do, Vo;
  return /* @__PURE__ */ k("all:revert;box-sizing:border-box;appearance:none;width:100%;margin:0;padding:", ((n = (t = o.component) == null ? void 0 : t.Select) == null ? void 0 : n.padding) ?? ((r = o.formInput) == null ? void 0 : r.padding) ?? o.spacing(3, 4), ";background:", ((i = (e = o.component) == null ? void 0 : e.Select) == null ? void 0 : i.background) ?? ((a = o.formInput) == null ? void 0 : a.background) ?? "#fff", ";border:", ((l = (c = o.component) == null ? void 0 : c.Select) == null ? void 0 : l.border) ?? ((p = o.formInput) == null ? void 0 : p.border) ?? "none", ";", ((u = (d = o.component) == null ? void 0 : d.Select) == null ? void 0 : u.borderBottom) != null || ((b = o.formInput) == null ? void 0 : b.borderBottom) != null ? `border-bottom: ${((m = (g = o.component) == null ? void 0 : g.Select) == null ? void 0 : m.borderBottom) ?? ((y = o.formInput) == null ? void 0 : y.borderBottom)}` : "", ";border-radius:", ((h = (S = o.component) == null ? void 0 : S.Select) == null ? void 0 : h.borderRadius) ?? ((w = o.formInput) == null ? void 0 : w.borderRadius) ?? 0, ";box-shadow:", ((I = (v = o.component) == null ? void 0 : v.Select) == null ? void 0 : I.boxShadow) || ((C = o.formInput) == null ? void 0 : C.boxShadow) || "none", ";font-family:", o.typography.font[((T = (x = o.component) == null ? void 0 : x.Select) == null ? void 0 : T.fontFamily) ?? ((A = o.formInput) == null ? void 0 : A.fontFamily) ?? "primary"], ";font-weight:", ((P = (O = o.component) == null ? void 0 : O.Select) == null ? void 0 : P.fontWeight) ?? ((B = o.formInput) == null ? void 0 : B.fontWeight) ?? "normal", ";font-size:", o.typography.size[((_ = (N = o.component) == null ? void 0 : N.Select) == null ? void 0 : _.fontSize) ?? ((D = o.formInput) == null ? void 0 : D.fontSize) ?? "md"], ";line-height:", ((j = (R = o.component) == null ? void 0 : R.Select) == null ? void 0 : j.lineHeight) ?? ((V = o.formInput) == null ? void 0 : V.lineHeight) ?? "100%", ";text-transform:", ((J = (Z = o.component) == null ? void 0 : Z.Select) == null ? void 0 : J.textTransform) ?? ((F = o.formInput) == null ? void 0 : F.textTransform) ?? "none", ";color:", ((H = (L = o.component) == null ? void 0 : L.Select) == null ? void 0 : H.color) ?? ((E = o.formInput) == null ? void 0 : E.color) ?? "inherit", ";transition:", ((so = (to = o.component) == null ? void 0 : to.Select) == null ? void 0 : so.transition) || ((K = o.formInput) == null ? void 0 : K.transition) || "none", ";", (q = (X = o.component) == null ? void 0 : X.Select) != null && q.transitionProperty || (ro = o.formInput) != null && ro.transitionProperty ? `transition-property: ${((io = (no = o.component) == null ? void 0 : no.Select) == null ? void 0 : io.transitionProperty) || ((ao = o.formInput) == null ? void 0 : ao.transitionProperty)};` : "", " ", Fo(((W = (z = o.component) == null ? void 0 : z.Select) == null ? void 0 : W.hoverStyle) || ((G = o.formInput) == null ? void 0 : G.hoverStyle)), " ", _o({
    focusStyle: ((Q = (Y = o.component) == null ? void 0 : Y.Select) == null ? void 0 : Q.focusStyle) || ((oo = o.formInput) == null ? void 0 : oo.focusStyle),
    focusVisibleStyle: ((po = (co = o.component) == null ? void 0 : co.Select) == null ? void 0 : po.focusVisibleStyle) || ((uo = o.formInput) == null ? void 0 : uo.focusVisibleStyle)
  }), " ", Yo(((bo = (fo = o.component) == null ? void 0 : fo.Slider) == null ? void 0 : bo.activeStyle) || ((So = o.formInput) == null ? void 0 : So.activeStyle)), " ", Xo(((Ro = (vo = o.component) == null ? void 0 : vo.Select) == null ? void 0 : Ro.disabledStyle) || ((To = o.formInput) == null ? void 0 : To.disabledStyle)), " ", it(((Do = (Ao = o.component) == null ? void 0 : Ao.Select) == null ? void 0 : Do.invalidStyle) || ((Vo = o.formInput) == null ? void 0 : Vo.invalidStyle)));
}, da = (o) => {
  var t, n, r, e, i, a, c, l, p;
  return /* @__PURE__ */ k("position:absolute;top:50%;right:", ((r = (n = (t = o.component) == null ? void 0 : t.Select) == null ? void 0 : n.icon) == null ? void 0 : r.rightOffset) ?? o.spacing(4), ";transform:translateY(-50%);pointer-events:none;color:", ((a = (i = (e = o.component) == null ? void 0 : e.Select) == null ? void 0 : i.icon) == null ? void 0 : a.color) ?? ((l = (c = o.component) == null ? void 0 : c.Select) == null ? void 0 : l.color) ?? ((p = o.formInput) == null ? void 0 : p.color) ?? "inherit", ";");
}, ge = {
  select: pa,
  icon: da
}, qa = /* @__PURE__ */ $o.forwardRef(({ options: o, value: t, hasError: n = !1, errorMessageElementId: r, ...e }, i) => /* @__PURE__ */ wo(la, {
  children: [
    /* @__PURE__ */ M("select", {
      value: t,
      css: ge.select,
      ref: i,
      "aria-invalid": n,
      "aria-errormessage": n ? r : void 0,
      ...e,
      children: o.map((a) => /* @__PURE__ */ M(si, {
        ...a
      }, a.value))
    }),
    /* @__PURE__ */ M(Gt.ChevronDown, {
      css: ge.icon
    })
  ]
})), ua = (o) => {
  var t, n, r, e, i;
  return /* @__PURE__ */ k("all:revert;box-sizing:border-box;display:grid;gap:", ((n = (t = o.component) == null ? void 0 : t.SliderWithField) == null ? void 0 : n.gap) ?? o.spacing(3), ";", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k((i = (e = (r = o.component) == null ? void 0 : r.SliderWithField) == null ? void 0 : e.desktop) == null ? void 0 : i.gap).styles
  }));
}, fa = {
  sliderWithField: ua
}, Ya = /* @__PURE__ */ $o.forwardRef(({ fieldType: o, value: t, onChange: n, min: r, max: e, allowLowerThanMin: i = !1, allowHigherThanMax: a = !1, step: c, decimals: l, disableFormatting: p = !1, pattern: d, maxLength: u, fieldVariant: b, suffix: g, fieldHtmlAttributes: m, sliderHtmlAttributes: y, hasError: S, errorMessageElementId: h, showSliderLabels: w = !1, suffixAriaLabel: v, ...I }, C) => {
  const [x, T] = Co(r), [A, O] = Co(e);
  Eo(() => {
    r !== x && T(r), e !== A && O(e);
  }, [
    r,
    e,
    x,
    A
  ]);
  const P = (R) => {
    R != null && (i && R < r && T(R), a && R > A && O(R), n(R));
  }, B = (R) => {
    R <= A ? n(R) : t !== A && n(A);
  }, N = {
    value: t,
    min: x,
    step: c,
    hasError: S,
    errorMessageElementId: h,
    pattern: d,
    maxLength: u
  }, _ = {
    max: A,
    onChange: P,
    allowLowerThanMin: i,
    allowHigherThanMax: a,
    variant: b,
    suffix: g,
    suffixAriaLabel: v,
    ...m || {}
  }, D = () => {
    switch (o) {
      case "decimal":
        return /* @__PURE__ */ M(Ei, {
          ..._,
          ...N,
          decimals: l
        });
      default:
        return /* @__PURE__ */ M(ea, {
          ..._,
          ...N,
          disableFormatting: p
        });
    }
  };
  return /* @__PURE__ */ wo("div", {
    css: fa.sliderWithField,
    ref: C,
    ...I,
    children: [
      D(),
      /* @__PURE__ */ M(bi, {
        max: A,
        decimals: l,
        showLabels: w && !a && !i,
        ...N,
        ...y && {
          ...y
        },
        onChange: B
      })
    ]
  });
}), ga = (o) => {
  var t, n;
  return /* @__PURE__ */ k("all:revert;box-sizing:border-box;position:relative;display:", ((n = (t = o.component) == null ? void 0 : t.TooltipModal) == null ? void 0 : n.display) || "inline-flex", ";margin:0;padding:0;");
}, ba = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y;
  return /* @__PURE__ */ k("background:", ((r = (n = (t = o.component) == null ? void 0 : t.TooltipModal) == null ? void 0 : n.button) == null ? void 0 : r.background) || "none", ";", Fo((a = (i = (e = o.component) == null ? void 0 : e.TooltipModal) == null ? void 0 : i.button) == null ? void 0 : a.hoverStyle), " ", jt({
    focusVisibleStyle: (p = (l = (c = o.component) == null ? void 0 : c.TooltipModal) == null ? void 0 : l.button) == null ? void 0 : p.focusVisibleStyle
  }), " ", Yo((b = (u = (d = o.component) == null ? void 0 : d.TooltipModal) == null ? void 0 : u.button) == null ? void 0 : b.activeStyle), " ", Xo((y = (m = (g = o.component) == null ? void 0 : g.TooltipModal) == null ? void 0 : m.button) == null ? void 0 : y.disabledStyle));
}, ma = (o) => {
  var t, n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A;
  return /* @__PURE__ */ k("position:absolute;cursor:pointer;top:", ((r = (n = (t = o.component) == null ? void 0 : t.TooltipModal) == null ? void 0 : n.closeButton) == null ? void 0 : r.top) ?? o.spacing(3), ";right:", ((a = (i = (e = o.component) == null ? void 0 : e.TooltipModal) == null ? void 0 : i.closeButton) == null ? void 0 : a.right) ?? o.spacing(3), ";background:", ((p = (l = (c = o.component) == null ? void 0 : c.TooltipModal) == null ? void 0 : l.closeButton) == null ? void 0 : p.background) || "#fff", ";", Fo((b = (u = (d = o.component) == null ? void 0 : d.TooltipModal) == null ? void 0 : u.closeButton) == null ? void 0 : b.hoverStyle), " ", jt({
    focusVisibleStyle: (y = (m = (g = o.component) == null ? void 0 : g.TooltipModal) == null ? void 0 : m.closeButton) == null ? void 0 : y.focusVisibleStyle,
    focusStyle: (w = (h = (S = o.component) == null ? void 0 : S.TooltipModal) == null ? void 0 : h.closeButton) == null ? void 0 : w.focusStyle
  }), " ", Yo((C = (I = (v = o.component) == null ? void 0 : v.TooltipModal) == null ? void 0 : I.closeButton) == null ? void 0 : C.activeStyle), " ", Xo((A = (T = (x = o.component) == null ? void 0 : x.TooltipModal) == null ? void 0 : T.closeButton) == null ? void 0 : A.disabledStyle));
}, Yn = {
  tooltipModal: ga,
  tooltipModalButton: ba,
  tooltipModalCloseButton: ma
}, ya = /* @__PURE__ */ eo("div", {
  shouldForwardProp: (o) => Jn(o),
  target: "e7kkf1k0"
})(({ theme: o, isOpen: t }) => {
  var n, r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w, v, I, C, x, T, A, O, P, B, N, _, D, R, j, V, Z, J, F, L, H, E, to;
  return `
        all: revert;
        box-sizing: border-box;
        
        display: ${t ? ((e = (r = (n = o.component) == null ? void 0 : n.TooltipModal) == null ? void 0 : r.modal) == null ? void 0 : e.display) || "grid" : "none"}; 
        grid-template-rows: 1fr;
        position: absolute;
        z-index: ${((c = (a = (i = o.component) == null ? void 0 : i.TooltipModal) == null ? void 0 : a.modal) == null ? void 0 : c.zIndex) ?? 999};
        top: calc(100% + ${((d = (p = (l = o.component) == null ? void 0 : l.TooltipModal) == null ? void 0 : p.modal) == null ? void 0 : d.buttonOffset) ?? o.spacing(2)});
        left: 0;
        min-width: ${((g = (b = (u = o.component) == null ? void 0 : u.TooltipModal) == null ? void 0 : b.modal) == null ? void 0 : g.minWidth) ?? "250px"};
        max-width: ${((S = (y = (m = o.component) == null ? void 0 : m.TooltipModal) == null ? void 0 : y.modal) == null ? void 0 : S.maxWidth) ?? "98vw"};
        max-height: ${((v = (w = (h = o.component) == null ? void 0 : h.TooltipModal) == null ? void 0 : w.modal) == null ? void 0 : v.maxHeight) ?? "80vh"};
        margin: 0;
        background: ${((x = (C = (I = o.component) == null ? void 0 : I.TooltipModal) == null ? void 0 : C.modal) == null ? void 0 : x.background) ?? "#fff"};
        border: ${((O = (A = (T = o.component) == null ? void 0 : T.TooltipModal) == null ? void 0 : A.modal) == null ? void 0 : O.border) ?? "none"};
        border-radius: ${((N = (B = (P = o.component) == null ? void 0 : P.TooltipModal) == null ? void 0 : B.modal) == null ? void 0 : N.borderRadius) ?? "0"};
        box-shadow: ${((R = (D = (_ = o.component) == null ? void 0 : _.TooltipModal) == null ? void 0 : D.modal) == null ? void 0 : R.boxShadow) || "none"};
        ${(Z = (V = (j = o.component) == null ? void 0 : j.TooltipModal) == null ? void 0 : V.modal) != null && Z.textAlign ? `text-align: ${o.component.TooltipModal.modal.textAlign};` : ""}
        ${(L = (F = (J = o.component) == null ? void 0 : J.TooltipModal) == null ? void 0 : F.modal) != null && L.justifyContent ? `justify-content: ${o.component.TooltipModal.modal.justifyContent};` : ""}
        ${(to = (E = (H = o.component) == null ? void 0 : H.TooltipModal) == null ? void 0 : E.modal) != null && to.alignItems ? `align-items: ${o.component.TooltipModal.modal.alignItems};` : ""}
    `;
}), Sa = /* @__PURE__ */ eo("div", {
  target: "e7kkf1k1"
})(({ theme: o }) => {
  var t, n, r;
  return `
        padding: ${((r = (n = (t = o.component) == null ? void 0 : t.TooltipModal) == null ? void 0 : n.modal) == null ? void 0 : r.padding) ?? o.spacing(3)};
        overflow: hidden auto;
    `;
}), be = {
  ModalWrapper: ya,
  ScrollContainer: Sa
}, Qa = /* @__PURE__ */ $o.forwardRef(({ id: o, boundryElementRef: t, fillBoundryWidth: n = !0, overflowBoundryHeight: r = !0, onToggle: e, hideCloseButton: i, closeButtonTitle: a, children: c, onBlur: l, toggleButtonTitle: p, ...d }, u) => {
  var B, N, _, D, R, j, V, Z, J, F, L, H, E, to, so, K, X, q, ro, no, io, ao, z;
  const b = Io(), g = `${o}-button`, m = `${o}-content`, y = Mo(null), S = ((_ = (N = (B = b.component) == null ? void 0 : B.TooltipModal) == null ? void 0 : N.button) == null ? void 0 : _.icon) || Gt.Questionmark, h = ((j = (R = (D = b.component) == null ? void 0 : D.TooltipModal) == null ? void 0 : R.closeButton) == null ? void 0 : j.icon) || Gt.Cross, w = Mo(null), [v, I] = Co({
    isOpen: !1,
    width: void 0,
    height: void 0,
    xPos: void 0
  }), [C, x] = Co(window.innerWidth), T = ((J = (Z = (V = b.component) == null ? void 0 : V.TooltipModal) == null ? void 0 : Z.modal) == null ? void 0 : J.windowOffset) ?? b.spacing(4), A = yt(() => {
    I((W) => {
      const G = !W.isOpen;
      return typeof e == "function" && e(G), {
        ...W,
        isOpen: G
      };
    });
  }, [
    I,
    e
  ]), O = Ht(() => {
    x(window.innerWidth);
  }, 200), P = yt((W) => {
    var Y, Q;
    const G = W.target;
    v.isOpen && !((Y = y.current) != null && Y.contains(G)) && !((Q = w.current) != null && Q.contains(G)) && A();
  }, [
    v.isOpen,
    A
  ]);
  return Eo(() => (window.addEventListener("resize", O), document.addEventListener("click", P), () => {
    window.removeEventListener("resize", O), document.removeEventListener("click", P), O.cancel();
  }), [
    O,
    P
  ]), Me(() => {
    const W = y.current, G = w.current, Y = t == null ? void 0 : t.current;
    if (!W || !G) return;
    if (!v.isOpen) {
      O.cancel(), I((co) => ({
        ...co,
        xPos: "0"
      }));
      return;
    }
    const Q = W.getBoundingClientRect(), oo = G.getBoundingClientRect();
    if (Y) {
      const { width: co, height: po, x: uo, y: fo } = Y.getBoundingClientRect(), { paddingRight: bo, paddingLeft: So, paddingBottom: vo } = getComputedStyle(Y);
      let Ro = Q.x + G.clientWidth < co + uo ? "0" : `calc(${(Q.x + G.clientWidth - co - uo) * -1}px - ${bo})`;
      n && (Ro = `calc(${(Q.x - uo) * -1}px + ${So})`), I((To) => ({
        ...To,
        width: n ? `calc(${co}px - ${So} - ${bo})` : void 0,
        height: r ? void 0 : `calc(${po + fo - oo.y}px - ${vo})`,
        xPos: Ro
      }));
      return;
    }
    I((co) => oo.right > C ? {
      ...co,
      xPos: `calc(${C - oo.right}px - ${T})`
    } : oo.left < 0 ? {
      ...co,
      xPos: `calc((${getComputedStyle(G).left || 0} - (${oo.left}px)) + ${T})`
    } : {
      ...co,
      xPos: Q.x + G.clientWidth < C ? "0" : `calc(${(Q.x + G.clientWidth - C) * -1}px - ${T})`
    });
  }, [
    v.isOpen,
    t,
    n,
    r,
    C,
    T,
    O
  ]), /* @__PURE__ */ wo("div", {
    css: Yn.tooltipModal,
    ref: u,
    ...d,
    onBlur: (W) => {
      l == null || l(W), v.isOpen && !W.currentTarget.contains(W.relatedTarget) && A();
    },
    children: [
      /* @__PURE__ */ M(St, {
        title: p,
        css: Yn.tooltipModalButton,
        variant: ((H = (L = (F = b.component) == null ? void 0 : F.TooltipModal) == null ? void 0 : L.button) == null ? void 0 : H.buttonVariant) || qo.PRIMARY,
        ref: y,
        onClick: A,
        id: g,
        "aria-expanded": v.isOpen,
        "aria-controls": m,
        children: !((so = (to = (E = b.component) == null ? void 0 : E.TooltipModal) == null ? void 0 : to.button) != null && so.hideIcon) && /* @__PURE__ */ M(S, {})
      }),
      /* @__PURE__ */ wo(be.ModalWrapper, {
        css: k({
          width: v.width,
          minWidth: v.width ? "unset" : void 0,
          maxHeight: v.height,
          left: v.xPos
        }),
        isOpen: v.isOpen,
        id: m,
        "aria-labelledby": g,
        ref: w,
        "aria-modal": "true",
        role: "dialog",
        children: [
          (!((X = (K = b.component) == null ? void 0 : K.TooltipModal) != null && X.hideCloseButton) || i === !1) && /* @__PURE__ */ M(St, {
            title: a,
            variant: ((no = (ro = (q = b.component) == null ? void 0 : q.TooltipModal) == null ? void 0 : ro.closeButton) == null ? void 0 : no.buttonVariant) || qo.CLEAN,
            css: Yn.tooltipModalCloseButton,
            onClick: A,
            disabled: !v.isOpen,
            children: !((z = (ao = (io = b.component) == null ? void 0 : io.TooltipModal) == null ? void 0 : ao.closeButton) != null && z.hideIcon) && /* @__PURE__ */ M(h, {})
          }),
          /* @__PURE__ */ M(be.ScrollContainer, {
            children: c
          })
        ]
      })
    ]
  });
}), $a = /* @__PURE__ */ eo("div", {
  target: "e19v15hi0"
})(({ displayComponent: o }) => k({
  all: "revert",
  boxSizing: "border-box",
  display: o ? "flex" : "none",
  alignItems: "center"
})), ha = /* @__PURE__ */ eo("strong", {
  target: "e19v15hi1"
})(({ theme: o, variant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S, h, w;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.ValidationMessage) == null ? void 0 : e.message,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.ValidationMessage) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.message,
    desktop: {
      ...(u = (d = (p = o.component) == null ? void 0 : p.ValidationMessage) == null ? void 0 : d.message) == null ? void 0 : u.desktop,
      ...(S = (y = (m = (g = (b = o.component) == null ? void 0 : b.ValidationMessage) == null ? void 0 : g.variant) == null ? void 0 : m[t]) == null ? void 0 : y.message) == null ? void 0 : S.desktop
    }
  };
  return `
        ${k({
    all: "revert",
    boxSizing: "border-box",
    ...No(n),
    fontFamily: o.typography.font[n.fontFamily || "primary"],
    fontSize: o.typography.size[n.fontSize || "sm"],
    fontWeight: n.fontWeight || "normal"
  }).styles}

        ${o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k({
      ...n.desktop,
      fontFamily: (h = n.desktop) != null && h.fontFamily ? o.typography.font[n.desktop.fontFamily] : void 0,
      fontSize: (w = n.desktop) != null && w.fontSize ? o.typography.size[n.desktop.fontSize] : void 0
    }).styles
  })}
    `;
}), me = {
  Wrapper: $a,
  Message: ha
}, va = ({ theme: o, variant: t }) => {
  var r, e, i, a, c, l, p, d, u, b, g, m, y, S;
  const n = {
    ...(e = (r = o.component) == null ? void 0 : r.ValidationMessage) == null ? void 0 : e.icon,
    ...(l = (c = (a = (i = o.component) == null ? void 0 : i.ValidationMessage) == null ? void 0 : a.variant) == null ? void 0 : c[t]) == null ? void 0 : l.icon,
    desktop: {
      ...(u = (d = (p = o.component) == null ? void 0 : p.ValidationMessage) == null ? void 0 : d.icon) == null ? void 0 : u.desktop,
      ...(S = (y = (m = (g = (b = o.component) == null ? void 0 : b.ValidationMessage) == null ? void 0 : g.variant) == null ? void 0 : m[t]) == null ? void 0 : y.icon) == null ? void 0 : S.desktop
    }
  };
  return /* @__PURE__ */ k(k({
    ...No(n, [
      "component"
    ]),
    margin: n.margin || o.spacing(0, 2, 0, 0),
    color: n.color
  }).styles, " ", o.mq({
    theme: o,
    min: lo.DESKTOP,
    css: k(n.desktop).styles
  }));
}, wa = {
  icon: va
}, Ja = /* @__PURE__ */ $o.forwardRef(({ variant: o = Oo.PRIMARY, hasError: t, message: n, messageElementId: r, getMessageElementId: e, ...i }, a) => {
  var b, g, m, y, S, h, w, v;
  const c = Io(), p = `validation-message-${_n()}`, d = r || p, u = ((S = (y = (m = (g = (b = c.component) == null ? void 0 : b.ValidationMessage) == null ? void 0 : g.variant) == null ? void 0 : m[o]) == null ? void 0 : y.icon) == null ? void 0 : S.component) || ((v = (w = (h = c.component) == null ? void 0 : h.ValidationMessage) == null ? void 0 : w.icon) == null ? void 0 : v.component) || Gt.Error;
  return Eo(() => {
    e && e(d);
  }, [
    e,
    d
  ]), /* @__PURE__ */ wo(me.Wrapper, {
    displayComponent: t,
    ref: a,
    ...i,
    children: [
      /* @__PURE__ */ M(zo, {
        instance: u,
        css: wa.icon({
          theme: c,
          variant: o
        })
      }),
      /* @__PURE__ */ M(me.Message, {
        id: d,
        variant: o,
        children: n
      })
    ]
  });
}), ye = (o) => typeof o == "string" && o.toLowerCase() === "point address", oe = {
  id: "tomtom",
  validCountries: [
    Zo.UNITED_KINGDOM
  ],
  performApiCall: async ({ apiKey: o, searchString: t }) => {
    const n = await fetch(`https://api.tomtom.com/search/2/search/${t}.json?${new URLSearchParams({
      key: o || "dYyFQhjilGDGFAyJr0BCbJS0i6Vc6229",
      language: "en-GB",
      countrySet: "GB",
      limit: "100",
      typeahead: "true",
      idxSet: "PAD,Str"
    }).toString()}`);
    return n.ok ? (await n.json()).results : new Error(n.statusText);
  },
  parseApiResult: (o) => {
    let t = [];
    const n = o.filter(({ type: r }) => ye(r));
    return n.length > 0 ? t = n.reduce((r, e) => {
      const i = e.id, a = `${e.address.streetName} ${e.address.streetNumber || ""}, ${e.address.localName}`, c = {
        ...e.address,
        addressType: "Point Address"
      };
      return i && a && r.push({
        key: i,
        label: a,
        meta: c,
        icon: Vn
      }), r;
    }, []) : t = Array.from(new Set(o.map((e) => e.address.streetName))).reduce((e, i) => {
      const a = o.find((c) => c.address.streetName === i);
      return a && e.push(a), e;
    }, []).reduce((e, i) => {
      const a = i.id, c = `${i.address.streetName} `, l = {
        ...i.address,
        addressType: "Street Address"
      };
      return a && c && e.push({
        key: a,
        label: c,
        meta: l
      }), e;
    }, []), t;
  },
  standardizeAddress: ({ localName: o, municipality: t, postalCode: n, streetName: r, streetNumber: e }) => ({
    city: o,
    municipality: t,
    postCode: n,
    streetName: r,
    streetNumber: e
  }),
  selectItemPredicate: (o) => {
    var t;
    return ye((t = o.meta) == null ? void 0 : t.addressType);
  }
}, Ia = (o) => [
  "NA",
  "NB",
  "NC"
].includes(o), xa = (o) => {
  switch (o) {
    case Zo.SWEDEN:
      return "se";
    case Zo.DENMARK:
      return "dk";
    case Zo.NORWAY:
      return "no";
    case Zo.FINLAND:
      return "fi";
    default:
      return "se";
  }
}, ka = "geposit", Re = {
  id: ka,
  validCountries: [
    Zo.SWEDEN,
    Zo.DENMARK,
    Zo.FINLAND,
    Zo.NORWAY
  ],
  performApiCall: async ({ apiKey: o, searchString: t, country: n }) => {
    var e;
    const r = await fetch(`https://app-api.geposit.se/v2.0/suggest/address/${xa(n)}?${new URLSearchParams({
      api_key: o,
      query: t,
      street_number: ((e = t.match(/\d+/)) == null ? void 0 : e[0]) || "",
      max_rows: "100",
      administrative: "true",
      sort_by: "ip"
    }).toString()}`);
    if (r.ok) {
      const i = await r.json();
      return (i == null ? void 0 : i.suggestions) || [];
    }
    return new Error(r.statusText);
  },
  parseApiResult: (o) => {
    let t = [];
    const n = o.filter(({ address_type: e }) => Ia(e)), r = Array.from(new Set(n.map((e) => e.street))).reduce((e, i) => {
      const a = o.find((c) => c.street === i);
      return a && e.push(a), e;
    }, []);
    return t = (r.length > 1 ? r : n).map((e) => ({
      key: `${e.street}-${e.street_number}${e.letter ? `-${e.letter}` : ""}-${e.locality}-${e.adm2_name}`,
      label: r.length > 1 ? `${e.street} ` : `${e.street} ${e.street_number}${e.letter ? e.letter : ""}, ${e.locality}`,
      meta: {
        addressType: e.address_type,
        streetName: e.street,
        streetNumber: e.street_number,
        letter: e.letter,
        postCode: e.postcode,
        locality: e.locality,
        municipality: e.adm2_name,
        isMatch: r.length === 1
      },
      icon: Vn
    })), t;
  },
  standardizeAddress: ({ locality: o, municipality: t, postCode: n, streetName: r, streetNumber: e, letter: i }) => ({
    city: o,
    municipality: t,
    postCode: n,
    streetName: r,
    streetNumber: `${e}${i || ""}`
  }),
  selectItemPredicate: (o) => {
    var t;
    return !!((t = o.meta) != null && t.isMatch);
  }
}, Ca = [
  Re,
  oe
], Se = (o) => o.id === Re.id, $e = (o) => o.id === oe.id, Xa = /* @__PURE__ */ $o.forwardRef(({ country: o, apiKey: t, handleMatch: n, autoCompleteProps: r, ...e }, i) => {
  const a = Vt(() => {
    const g = Ca.find(({ validCountries: m }) => m.includes(o));
    return g || (console.warn(`No address API found for country ${o}! Using TomTom API as fallback.`), oe);
  }, [
    o
  ]), [c, l] = Co([]), p = (g) => {
    if (!g.length) {
      l([]);
      return;
    }
    (Se(a) || $e(a)) && l(a.parseApiResult(g));
  }, d = Ht(async (g) => {
    if (g.length < 3) {
      l([]);
      return;
    }
    const m = await a.performApiCall({
      apiKey: t,
      searchString: g,
      country: o
    });
    Array.isArray(m) && p(m);
  }, 250);
  return /* @__PURE__ */ M(Ce, {
    mode: "search",
    items: c,
    itemSelectionCallback: (g) => {
      var m, y;
      if (Se(a)) {
        const S = g;
        S.meta && ((m = a.selectItemPredicate) != null && m.call(a, S)) && n(a.standardizeAddress(S.meta));
      }
      if ($e(a)) {
        const S = g;
        S.meta && ((y = a.selectItemPredicate) != null && y.call(a, S)) && n(a.standardizeAddress(S.meta));
      }
    },
    ref: i,
    ...r,
    inputChangeCallback: (g) => {
      d(g), typeof r.inputChangeCallback == "function" && r.inputChangeCallback(g);
    },
    ...e
  });
}), Ae = {
  id: "geposit",
  validCountries: [
    Zo.SWEDEN,
    Zo.DENMARK,
    Zo.FINLAND,
    Zo.NORWAY
  ],
  performApiCall: async ({ apiKey: o, searchString: t, country: n }) => {
    const r = t.replace(/\s/g, ""), e = await fetch(`https://staging.api.econans.se/v1/PostalCode/${n}/${r}?${new URLSearchParams({
      maxRows: "5"
    }).toString()}`, {
      signal: AbortSignal.timeout(3e4),
      headers: {
        "api-key": o || "2I0PgZtDEVrjozgWHJdVKPzJH73Nl0"
      }
    });
    return e.ok ? await e.json() || [] : new Error(e.statusText);
  },
  parseApiResult: (o) => o.map(({ countryCode: n, postalCodeString: r }) => ({
    key: r,
    label: `${r.substring(0, 3)} ${r.substring(3)}`,
    icon: Vn,
    meta: {
      countryCode: n,
      postCode: r
    }
  })),
  standardizePostCode: ({ countryCode: o, postCode: t }) => ({
    locality: o,
    postCode: t
  })
}, Ra = [
  Ae
], os = /* @__PURE__ */ $o.forwardRef(({ country: o, apiKey: t, handleMatch: n, autoCompleteProps: r, ...e }, i) => {
  const a = Vt(() => {
    const m = Ra.find(({ validCountries: y }) => y.includes(o));
    return m || (console.warn(`No post code API found for country ${o}! Using Geposit API as fallback.`), Ae);
  }, [
    o
  ]), c = r.fieldValueFormatter ?? ((m) => {
    const y = m.replace(/\D/g, "");
    return y.length > 3 ? `${y.substring(0, 3)} ${y.substring(3, 5)}` : y;
  }), [l, p] = Co([]), d = (m) => {
    if (!m.length) {
      p([]);
      return;
    }
    const y = a.parseApiResult(m).map((S) => ({
      ...S,
      label: c(S.label)
    }));
    p(y);
  }, u = Ht(async (m) => {
    if (m.length < 3) {
      p([]);
      return;
    }
    const y = await a.performApiCall({
      apiKey: t,
      searchString: m,
      country: o
    });
    Array.isArray(y) && d(y);
  }, 250);
  return /* @__PURE__ */ M(Ce, {
    mode: "search",
    items: l,
    itemSelectionCallback: (m) => {
      m.meta && n(a.standardizePostCode(m.meta));
    },
    fieldValueFormatter: c,
    ref: i,
    ...r,
    inputChangeCallback: (m) => {
      u(m), typeof r.inputChangeCallback == "function" && r.inputChangeCallback(m);
    },
    inputFieldProps: {
      ...r.inputFieldProps,
      inputMode: "numeric"
    },
    ...e
  });
});
export {
  ja as Accordion,
  Xa as AddressSearch,
  Ce as Autocomplete,
  lo as BREAKPOINT,
  qo as BUTTON_VARIANT,
  St as Button,
  Zo as COUNTRY,
  Oa as Checkbox,
  Ei as DecimalInput,
  tr as DescriptionDetail,
  Ha as DescriptionList,
  nr as DescriptionTerm,
  Ga as Dialog,
  Ka as DisguisedRadioButton,
  Wa as EmotionConfiguration,
  qi as Fieldset,
  Ua as FormChoiceGroup,
  mi as Grid,
  rr as Heading,
  qn as INPUT_FIELD_VARIANT,
  Gt as Icon,
  Xn as InputField,
  ea as IntegerInput,
  ti as LEGEND_VARIANT,
  oi as Label,
  ke as Legend,
  ri as Link,
  Pa as NonBreakingSpace,
  Za as Notification,
  si as Option,
  li as Paragraph,
  os as PostCodeSearch,
  ui as RadioButton,
  zo as RenderComponentInstance,
  qa as Select,
  bi as Slider,
  Ya as SliderWithField,
  Qa as TooltipModal,
  _a as TransBold,
  Va as TransLink,
  Oo as VARIANT,
  Ja as ValidationMessage,
  La as VisuallyHidden,
  ft as convertNumberToPresentationalDecimal,
  Ma as createTheme,
  Yo as generateActiveStyle,
  ve as generateAfterElementStyle,
  we as generateBeforeElementStyle,
  Ln as generateCheckedStyle,
  Xo as generateDisabledStyle,
  _o as generateFocusStyle,
  jt as generateFocusVisibleStyle,
  mt as generateFocusWithinStyle,
  Fo as generateHoverStyle,
  it as generateInvalidStyle,
  No as removeNonCssProperties,
  Ge as removeWhiteSpaceFromString,
  Ba as useMediaQuery
};
//# sourceMappingURL=ui-components.js.map
